
// --- SOLUSI ERROR ---
// Buka terminal di folder proyek Anda (semesta-cafe) dan jalankan perintah ini:
// npm install firebase recharts xlsx

import React, { useState, useEffect, useRef, useCallback } from 'react';
// [MODIFIKASI] Gunakan instance dari firebase.js untuk mencegah error "Duplicate App"
import { app, db, auth, appId } from './firebase';
// import { initializeApp } from "firebase/app"; // DIHAPUS
import {
    getFirestore, collection, doc, getDoc, getDocs, setDoc, addDoc,
    updateDoc, deleteDoc, onSnapshot, Timestamp, serverTimestamp, query, increment,
    writeBatch, arrayUnion, where, limit, orderBy,
    startAfter // <--- INI YANG HILANG
} from "firebase/firestore";
import {
    getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword,
    signOut, onAuthStateChanged, sendPasswordResetEmail,
    GoogleAuthProvider, signInWithPopup, signInAnonymously
} from "firebase/auth";
import { Geolocation } from '@capacitor/geolocation'; // [BARU] Hybrid GPS
import { getFunctions, httpsCallable } from "firebase/functions";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { NotificationPermissionModal, NotificationBellIcon, NotificationCenterModal, InAppNotificationPopup } from './components/NotificationComponents';
import { useFCMToken, useForegroundMessage, isNotificationSupported } from './hooks/useFCM';
import { playNotificationSound } from './utils/notificationSound';
import { parseDocument } from './utils/documentParser';
import { downloadAsPdf, downloadAsDocx } from './utils/documentGenerator';
import { logScreenView, logAddToCart, logPurchase, logViewItem, logEvent } from './utils/analytics'; // [ANALYTICS] Import Utility
import { HiOutlineHome, HiOutlineClock, HiOutlineMapPin, HiOutlineTag, HiOutlineShoppingCart, HiOutlineCalendar, HiOutlineChatBubbleOvalLeftEllipsis, HiOutlineTicket, HiOutlineUsers, HiXMark } from 'react-icons/hi2';
import BookingForm from './components/BookingForm';
import ShareBookingButton from './components/ShareBookingButton'; // [BARU] Import Share Button
import ShareButton from './components/ShareButton'; // [BARU] Component Share
import { QRCodeSVG } from 'qrcode.react'; // [BARU] QR Code generator
import EventListScreen from './components/EventListScreen'; // [NEW] Real Event List
import EventDetailScreen from './components/EventDetailScreen'; // [NEW] Real Event Detail
import MyTicketsScreen from './components/MyTicketsScreen'; // [NEW] My Tickets Screen
import TicketDetailScreen from './components/TicketDetailScreen'; // [NEW] Ticket Detail Screen
import LeafletMap from './components/LeafletMap'; // [NEW] Leaflet Map Component
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import PromoWeekendScreen from './components/PromoWeekendScreen'; // [BARU] Promo Weekend 10rb (Fase 2)
import { HiOutlineBookOpen } from 'react-icons/hi2';
// [DIHAPUS] Import Firebase Storage tidak lagi diperlukan untuk chat
// import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// [MODIFIKASI] Versi aplikasi disesuaikan dengan yang ada di admin
const CURRENT_APP_VERSION = '9.0';

// [BARU] Helper function untuk membandingkan versi (cth: '1.0.1' > '1.0.0')
const isNewerVersion = (newVersion, oldVersion) => {
    if (!newVersion || !oldVersion) return false;
    const newParts = newVersion.split('.').map(Number);
    const oldParts = oldVersion.split('.').map(Number);
    const len = Math.max(newParts.length, oldParts.length);
    for (let i = 0; i < len; i++) {
        const newPart = newParts[i] || 0;
        const oldPart = oldParts[i] || 0;
        if (newPart > oldPart) return true;
        if (newPart < oldPart) return false;
    }
    return false;
};


// [DIHAPUS] Konfigurasi dipindah ke src/firebase.js
// const firebaseConfig = { ... };
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app);

const functions = getFunctions(app);
let messaging = null; // Will be initialized conditionally

// Initialize Firebase Messaging (only if supported)
try {
    const isSupportedWeb = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
    if (isSupportedWeb) {
        messaging = getMessaging(app);
    }
} catch (error) {
    console.log("Firebase Messaging not supported (Native or Fallback):", error);
}

// [DIHAPUS] Logic dipindah ke dalam useEffect di AppView agar lebih robust
// if (typeof window !== 'undefined') { ... }
// [DIHAPUS] Inisialisasi Firebase Storage tidak diperlukan lagi
// const storage = getStorage(app);

// --- Helper & Referensi Firestore ---
// const appId = firebaseConfig.projectId; // DIHAPUS - sudah diimport dari firebase.js
console.log("DEBUG: AppId initialized as:", appId);
const publicDataPath = `artifacts/${appId}/public/data`;
const usersCol = collection(db, `${publicDataPath}/users`);
const menuItemsCol = collection(db, `${publicDataPath}/menuItems`);
const packagesCol = collection(db, `${publicDataPath}/packages`);
const tutorialsCol = collection(db, `${publicDataPath}/tutorials`);
const transactionsCol = collection(db, `${publicDataPath}/transactions`);
const quizzesCol = collection(db, `${publicDataPath}/quizzes`);
const quizBankCol = collection(db, `${publicDataPath}/quizBank`);
const specialPromosCol = collection(db, `${publicDataPath}/specialPromos`);
const scansCol = collection(db, `${publicDataPath}/scans`);
const saranCol = collection(db, `${publicDataPath}/saran`);
// [FIX] Settings juga harus mengambil dari path public data, bukan root global
const settingsDoc = doc(db, `${publicDataPath}/settings`, 'main');
const categoriesDoc = doc(db, `${publicDataPath}/settings`, 'menuCategories'); // [BARU] Referensi untuk kategori menu
const notificationDoc = doc(db, `${publicDataPath}/notifications`, 'latest');
// [BARU] Referensi untuk koleksi broadcast/pengumuman
const broadcastsCol = collection(db, `${publicDataPath}/broadcasts`);
// [BARU] Referensi untuk pesan langsung dari admin
const directMessagesCol = collection(db, `${publicDataPath}/directMessages`);
const partnersCol = collection(db, `${publicDataPath}/partners`);

// [MODIFIKASI] Titik Lokasi Semesta Cafe (TITIK 0)
// Menggunakan koordinat yang benar dari link Google Maps Anda:
// https://www.google.com/maps/place/Semesta+Coffee/@-7.4148434,109.2723232
const CAFE_LOCATION = { latitude: -7.4148434, longitude: 109.2723232 };
// [BARU] Radius Semesta Area (500 meter = 0.5 km) - Diperluas agar deteksi lebih mudah
const SEMESTA_AREA_RADIUS_KM = 0.5;

// [BARU] Komponen WhatsApp Bubble
const WhatsAppBubble = () => {
    const adminPhoneNumber = '628895772061'; // Nomor admin yang benar
    const message = 'Halo Admin Semesta Cafe, saya butuh bantuan.';
    // ... (rest of WhatsAppBubble component code)
};

// [BARU] Helper function untuk menghitung jarak (Formula Haversine)
const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius bumi dalam km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Jarak dalam km
    return d;
};

const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
};


// --- Ikon ---
const HomeIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>;
const GiftIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>;
const CartIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>;
const LogoutIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>;
const SearchIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;
const EyeIcon = (props) => <svg {...props} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const EyeOffIcon = (props) => <svg {...props} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>;
const MessageSquareIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>;
const StarIcon = ({ filled, ...props }) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>;
const TimerIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;
const GoogleIcon = (props) => <svg {...props} viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"></path><path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"></path><path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.222 0-9.519-3.487-11.182-8.169l-6.571 4.819C9.656 39.663 16.318 44 24 44z"></path><path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.19 5.238C42.021 35.596 44 30.138 44 24c0-1.341-.138-2.65-.389-3.917z"></path></svg>;
const CheckCircleIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const CoffeeIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>;
const SendIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>;
const HistoryIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18" /><path d="M7 12h10" /><path d="M7 6h10" /><path d="M7 18h10" /></svg>;
const MapPinIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const TrophyIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21A3.98 3.98 0 0 1 8 22c-2.21 0-4-1.79-4-4 0-1.05.4-2.04 1.07-2.75" /><path d="M14 14.66V17c0 .55.47.98.97 1.21A3.98 3.98 0 0 0 16 22c2.21 0 4-1.79 4-4 0-1.05-.4-2.04-1.07-2.75" /><path d="M9 4h6v10H9z" /></svg>;
const AnnounceIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18" /><path d="M7 12h10" /><path d="M7 6h10" /><path d="M7 18h10" /></svg>;
const DownloadIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>;

const CheckIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>;
const CheckCheckIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 7 17l-5-5" /><path d="m22 10-7.5 7.5L11 14" /></svg>;
const WalletIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" /><path d="M4 6v12c0 1.1.9 2 2 2h14v-4" /><path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z" /></svg>;
const BellIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>;
const LocationIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const UnlockIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></svg>;
const QrCode = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="5" height="5" x="3" y="3" /><rect width="5" height="5" x="16" y="3" /><rect width="5" height="5" x="3" y="16" /><path d="M21 16h-3a2 2 0 0 0-2 2v3" /><path d="M21 21v.01" /><path d="M12 7v3a2 2 0 0 1-2 2H7" /><path d="M3 12h.01" /><path d="M12 3h.01" /><path d="M12 16v.01" /><path d="M16 12h1" /><path d="M21 12v.01" /><path d="M12 21v-1" /></svg>;

// [BARU] Flat Icons untuk Menu Utama
const GatchaIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" /><path d="M5 3v4" /><path d="M9 3v4" /><path d="M3 5h4" /><path d="M3 9h4" /></svg>;
const TopUpIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2" /><line x1="2" x2="22" y1="10" y2="10" /></svg>;
const LaundryIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><path d="M16 13H8" /><path d="M16 17H8" /><path d="M10 9H8" /></svg>;
const SparringIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>;


// --- [BARU] Helper Functions untuk Gambar ---
const compressImage = (file, options = { quality: 0.75, maxWidth: 1024 }) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = event => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const { maxWidth } = options;
                let { width, height } = img;

                if (width > maxWidth) {
                    height = Math.round((height * maxWidth) / width);
                    width = maxWidth;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            resolve(new File([blob], file.name, {
                                type: 'image/jpeg',
                                lastModified: Date.now(),
                            }));
                        } else {
                            reject(new Error('Canvas to Blob conversion failed'));
                        }
                    },
                    'image/jpeg',
                    options.quality
                );
            };
            img.onerror = error => reject(error);
        };
        reader.onerror = error => reject(error);
    });
};

const uploadImageToCloudinary = async (file, folder) => {
    const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/ddjraseyg/image/upload`;
    const uploadData = new FormData();
    uploadData.append('file', file);
    uploadData.append('upload_preset', "semesta");
    uploadData.append('folder', folder);

    try {
        const response = await fetch(CLOUDINARY_URL, { method: 'POST', body: uploadData });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error.message || 'Gagal unggah gambar.');
        }
        const data = await response.json();
        return data.secure_url;
    } catch (error) {
        console.error(`Cloudinary upload error in folder ${folder}:`, error);
        throw error;
    }
};


// --- Komponen UI ---
// [BARU] Komponen untuk Banner Pengumuman
const AnnouncementBanner = ({ broadcast, onDismiss }) => {
    if (!broadcast) return null;
    return (
        <div className="bg-green-800 text-white p-3 flex items-center justify-between text-sm rounded-lg shadow-md mb-4 mx-4">
            <div className="flex items-center">
                <AnnounceIcon className="w-6 h-6 mr-3 flex-shrink-0" />
                <span>{broadcast.message}</span>
            </div>
            <button onClick={onDismiss} className="p-1 rounded-full hover:bg-green-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
        </div>
    );
};

// [BARU] Komponen Modal untuk Notifikasi Update
const UpdateModal = ({ isOpen }) => {
    if (!isOpen) return null;

    const handleRefresh = () => {
        // Memaksa reload dari server, bukan cache
        window.location.reload(true);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[100] p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
                <h2 className="text-2xl font-bold text-green-900 mb-2">Update Tersedia!</h2>
                <p className="text-gray-600 mb-6">Ada fitur baru yang seru! Mohon segarkan aplikasi Anda untuk menikmati pengalaman terbaik.</p>
                <button
                    onClick={handleRefresh}
                    className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors"
                >
                    Segarkan Sekarang
                </button>
            </div>
        </div>
    );
};

// [BARU] TopUpModal Component - Hybrid QRIS + Manual
const TopUpModal = ({ isOpen, onClose, user, showNotification }) => {
    const [mode, setMode] = useState('select'); // 'select' | 'qris' | 'manual' | 'waiting'
    const [amount, setAmount] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [qrisData, setQrisData] = useState(null);
    const [countdown, setCountdown] = useState(300); // 5 menit
    const [selectedManualOption, setSelectedManualOption] = useState(null);
    const pollingRef = useRef(null);
    const countdownRef = useRef(null);

    // Manual top up options (Lynk.id - backup)
    const manualOptions = [
        { value: 20000, link: 'http://lynk.id/semestacafe/mmllez21dwy8/checkout' },
        { value: 50000, link: 'http://lynk.id/semestacafe/86ooq90958l4/checkout' },
        { value: 100000, link: 'http://lynk.id/semestacafe/12ggr0xgwqmr/checkout' },
        { value: 200000, link: 'http://lynk.id/semestacafe/n7rr9v5go9nn/checkout' }
    ];

    // Reset state saat modal ditutup
    useEffect(() => {
        if (!isOpen) {
            setMode('select');
            setAmount('');
            setIsProcessing(false);
            setQrisData(null);
            setCountdown(300);
            setSelectedManualOption(null);
            if (pollingRef.current) clearInterval(pollingRef.current);
            if (countdownRef.current) clearInterval(countdownRef.current);
        }
    }, [isOpen]);

    // Countdown timer untuk QRIS
    useEffect(() => {
        if (mode === 'waiting' && countdown > 0) {
            countdownRef.current = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(countdownRef.current);
                        setMode('select');
                        showNotification('QRIS kedaluwarsa. Silakan coba lagi.', 'error');
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(countdownRef.current);
        }
    }, [mode, countdown, showNotification]);

    // Polling untuk cek status pembayaran QRIS
    useEffect(() => {
        if (mode === 'waiting' && qrisData?.partnerReferenceNo) {
            const checkStatus = async () => {
                try {
                    const checkTopUpStatus = httpsCallable(functions, 'checkTopUpStatus');
                    const result = await checkTopUpStatus({ partnerReferenceNo: qrisData.partnerReferenceNo });

                    if (result.data.status === 'success') {
                        clearInterval(pollingRef.current);
                        clearInterval(countdownRef.current);
                        showNotification(`Top Up berhasil! Saldo bertambah Rp ${qrisData.amount.toLocaleString('id-ID')}`, 'success');
                        onClose();
                    } else if (result.data.status === 'expired') {
                        clearInterval(pollingRef.current);
                        setMode('select');
                        showNotification('QRIS kedaluwarsa.', 'error');
                    }
                } catch (error) {
                    console.error('Status check error:', error);
                }
            };

            pollingRef.current = setInterval(checkStatus, 3000); // Check setiap 3 detik
            return () => clearInterval(pollingRef.current);
        }
    }, [mode, qrisData, showNotification, onClose]);

    // [BARU] Duitku Payment Integration
    const handleDuitkuTopUp = async () => {
        const numAmount = parseInt(amount.replace(/\D/g, ''), 10);

        if (!numAmount || numAmount < 1) {
            showNotification('Masukkan nominal yang valid', 'error');
            return;
        }

        setIsProcessing(true);
        try {
            const createDuitkuInvoice = httpsCallable(functions, 'createDuitkuInvoice');
            const result = await createDuitkuInvoice({ amount: numAmount });

            if (result.data.paymentUrl) {
                window.location.href = result.data.paymentUrl;
            } else {
                throw new Error('Gagal mendapatkan link pembayaran');
            }
        } catch (error) {
            console.error('Duitku Error:', error);
            showNotification(error.message || 'Terjadi kesalahan saat memproses pembayaran', 'error');
        } finally {
            setIsProcessing(false);
        }
    };

    // Generate QRIS via Cloud Function
    const handleGenerateQRIS = async () => {
        const numAmount = parseInt(amount.replace(/\D/g, ''), 10);

        if (!numAmount || numAmount < 10000) {
            showNotification('Minimal top up Rp 10.000', 'error');
            return;
        }

        setIsProcessing(true);
        try {
            const createTopUpQRIS = httpsCallable(functions, 'createTopUpQRIS');
            const result = await createTopUpQRIS({ amount: numAmount });

            if (result.data.success) {
                setQrisData(result.data);
                setCountdown(result.data.expiresIn || 300);
                setMode('waiting');
            } else {
                throw new Error('Failed to generate QRIS');
            }
        } catch (error) {
            console.error('Generate QRIS error:', error);
            showNotification(error.message || 'Gagal membuat QRIS. Coba metode manual.', 'error');
        } finally {
            setIsProcessing(false);
        }
    };

    // Manual top up via Lynk.id
    const handleManualTopUp = async () => {
        if (!selectedManualOption) return;
        setIsProcessing(true);

        try {
            await addDoc(collection(db, `${publicDataPath}/topup_requests`), {
                userId: user.uid,
                userName: user.name,
                userEmail: user.email || '-',
                amount: selectedManualOption.value,
                status: 'pending',
                source: 'lynk_manual',
                createdAt: Timestamp.now(),
                paymentLink: selectedManualOption.link
            });

            window.open(selectedManualOption.link, '_blank');
            showNotification("Permintaan dicatat! Silakan selesaikan pembayaran.", "success");
            onClose();
        } catch (error) {
            console.error("Manual topup error:", error);
            showNotification("Gagal memproses. Silakan coba lagi.", "error");
        } finally {
            setIsProcessing(false);
        }
    };

    // Format input amount
    const handleAmountChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setAmount(value ? parseInt(value, 10).toLocaleString('id-ID') : '');
    };

    // Format countdown timer
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>

                {/* HEADER */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-green-900">
                        {mode === 'waiting' ? 'Scan QRIS' : 'Isi Saldo Semesta Pay'}
                    </h2>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>

                {/* MODE: SELECT */}
                {mode === 'select' && (
                    <>
                        <div className="mb-6 text-center">
                            <p className="text-gray-500 text-sm mb-1">Saldo Semesta Pay</p>
                            <h3 className="text-3xl font-extrabold text-green-900 tracking-tight">
                                Rp {(user.balance || 0).toLocaleString('id-ID')}
                            </h3>
                        </div>

                        <div className="space-y-3">
                            {/* Duitku Option - Enhanced */}
                            <button
                                onClick={() => setMode('duitku_input')}
                                className="w-full p-5 bg-gradient-to-br from-indigo-600 via-blue-600 to-blue-700 text-white rounded-2xl flex items-center justify-between hover:shadow-xl hover:scale-[1.02] transition-all duration-300 shadow-lg group relative overflow-hidden"
                            >
                                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl group-hover:scale-150 transition-transform duration-500"></div>

                                <div className="flex items-center">
                                    <div className="bg-white/20 p-3 rounded-full mr-4 backdrop-blur-sm">
                                        <span className="text-2xl">⚡</span>
                                    </div>
                                    <div className="text-left">
                                        <p className="font-bold text-lg leading-tight">Isi Saldo Instan</p>
                                        <p className="text-xs text-blue-100 opacity-90 font-medium mt-1">QRIS, E-Wallet, VA (Otomatis)</p>
                                    </div>
                                </div>

                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white opacity-70 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </>
                )}

                {/* MODE: Duitku Input Amount */}
                {mode === 'duitku_input' && (
                    <>
                        <button onClick={() => setMode('select')} className="text-sm text-green-600 mb-4 flex items-center hover:underline">
                            ← Kembali
                        </button>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Nominal Top Up</label>
                            <div className="relative">
                                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">Rp</span>
                                <input
                                    type="text"
                                    value={amount}
                                    onChange={handleAmountChange}
                                    placeholder="Min Rp 10.000"
                                    className="w-full pl-12 pr-4 py-3 border-2 border-green-200 rounded-xl focus:border-green-500 focus:ring-0 text-lg font-bold text-center"
                                />
                            </div>
                            <p className="text-xs text-gray-500 mt-2">Minimal Rp 10.000</p>
                        </div>

                        {/* Quick Amount Buttons */}
                        <div className="grid grid-cols-4 gap-2 mb-4">
                            {[10000, 25000, 50000, 100000].map(val => (
                                <button
                                    key={val}
                                    onClick={() => setAmount(val.toLocaleString('id-ID'))}
                                    className="py-2 text-xs bg-green-50 text-green-700 rounded-lg hover:bg-green-100 font-medium"
                                >
                                    {val >= 1000 ? `${val / 1000}rb` : val}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={handleDuitkuTopUp}
                            disabled={isProcessing || !amount}
                            className="w-full py-3 bg-blue-700 text-white font-bold rounded-xl hover:bg-blue-800 disabled:bg-gray-300 disabled:cursor-not-allowed flex justify-center items-center"
                        >
                            {isProcessing ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : 'Bayar Sekarang'}
                        </button>
                    </>
                )}

                {/* MODE: WAITING - Show QRIS */}
                {mode === 'waiting' && qrisData && (
                    <div className="text-center">
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 mb-4">
                            <p className="text-blue-700 font-medium">Scan dengan aplikasi e-wallet atau m-banking</p>
                        </div>

                        <div className="bg-white border-2 border-gray-200 rounded-xl p-4 mb-4">
                            {qrisData.qrisString ? (
                                <QRCodeSVG
                                    value={qrisData.qrisString}
                                    size={256}
                                    level="M"
                                    className="mx-auto"
                                />
                            ) : (
                                <div className="h-48 flex items-center justify-center text-gray-400">
                                    <SemestaLogoSpinner />
                                </div>
                            )}
                        </div>

                        <p className="text-2xl font-bold text-green-800 mb-2">Rp {qrisData.amount.toLocaleString('id-ID')}</p>

                        {/* Countdown */}
                        <div className="flex items-center justify-center text-gray-600 mb-4">
                            <TimerIcon className="w-4 h-4 mr-1" />
                            <span className={countdown < 60 ? 'text-red-500 font-bold' : ''}>
                                Berlaku {formatTime(countdown)}
                            </span>
                        </div>

                        <p className="text-xs text-gray-500 mb-4">
                            Menunggu pembayaran... Saldo akan otomatis masuk setelah scan.
                        </p>

                        <button
                            onClick={() => setMode('select')}
                            className="w-full py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                        >
                            Batal
                        </button>
                    </div>
                )}

                {/* MODE: MANUAL - Lynk.id */}
                {mode === 'manual' && (
                    <>
                        <button onClick={() => setMode('select')} className="text-sm text-green-600 mb-4 flex items-center hover:underline">
                            ← Kembali
                        </button>

                        <p className="text-sm text-gray-600 mb-3">Pilih nominal (via Lynk.id):</p>

                        <div className="grid grid-cols-2 gap-3 mb-4">
                            {manualOptions.map((option) => (
                                <button
                                    key={option.value}
                                    onClick={() => setSelectedManualOption(option)}
                                    className={`py-3 px-2 rounded-xl text-sm font-bold transition-colors ${selectedManualOption?.value === option.value
                                        ? 'bg-green-600 text-white'
                                        : 'bg-green-50 text-green-800 border border-green-200 hover:bg-green-100'
                                        }`}
                                >
                                    Rp {option.value.toLocaleString('id-ID')}
                                </button>
                            ))}
                        </div>

                        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
                            <p className="text-xs text-yellow-800">
                                ⚠️ Metode ini memerlukan verifikasi admin. Saldo akan masuk dalam 1-2 jam kerja.
                            </p>
                        </div>

                        <button
                            onClick={handleManualTopUp}
                            disabled={isProcessing || !selectedManualOption}
                            className="w-full py-3 bg-green-700 text-white font-bold rounded-xl hover:bg-green-800 disabled:bg-gray-300 disabled:cursor-not-allowed flex justify-center items-center"
                        >
                            {isProcessing ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : 'Lanjut ke Pembayaran'}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};


// [BARU] Komponen Modal untuk pesan langsung dari admin
const DirectMessageFromAdminModal = ({ message, onClose }) => {
    if (!message) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[100] p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 text-center transform transition-all duration-300 scale-100">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4 border-4 border-yellow-200">
                    <TrophyIcon className="h-8 w-8 text-yellow-500" />
                </div>
                <h3 className="text-xl font-bold text-green-900">Pesan Spesial dari Admin!</h3>
                <p className="text-gray-700 mt-4 mb-6 whitespace-pre-wrap text-lg">
                    "{message.message}"
                </p>
                <button
                    onClick={onClose}
                    className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors"
                >
                    Mengerti!
                </button>
            </div>
        </div>
    );
};


const CustomNotification = ({ message, type, onDismiss }) => {
    if (!message) return null;
    const baseClasses = "fixed bottom-5 left-1/2 -translate-x-1/2 px-6 py-3 rounded-lg shadow-lg text-white transition-opacity duration-300 z-50";
    const typeClasses = type === 'error' ? 'bg-red-500' : 'bg-green-500';
    return <div className={`${baseClasses} ${typeClasses}`} onClick={onDismiss}>{message}</div>;
};

const AuthPage = ({ children }) => (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50/50 font-sans p-4">
        <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-lg mb-6">
            {children}
        </div>

        {/* Footer Info for Requirement Duitku */}
        <div className="max-w-md text-center text-xs text-gray-500 space-y-1">
            <p className="font-bold text-gray-700">Semesta Coffee</p>
            <p>Modern Cafe & Co-working Space</p>
            <p>Menyajikan Kopi, Non-Kopi, dan Makanan Ringan (Rp 10.000 - Rp 50.000)</p>

            <div className="pt-2 mt-2 border-t border-gray-300">
                <p className="font-bold">Contact Support:</p>
                <p>Email: semestaacoffee@gmail.com | Telp: 081229512129</p>
                <p>Alamat: Jl. Tegal Sari, Dukuhwaluh, Kembaran, Banyumas</p>
            </div>
            <p className="pt-2">&copy; 2026 Semesta App</p>
        </div>
    </div>
);

const SemestaLogoSpinner = (props) => (
    <div {...props}>
        <style>{`
            .semesta-logo-pulse {
                animation: semesta-pulse 1.5s ease-in-out infinite;
            }
            @keyframes semesta-pulse {
                0% { transform: scale(0.95); opacity: 0.8; }
                50% { transform: scale(1); opacity: 1; }
                100% { transform: scale(0.95); opacity: 0.8; }
            }
        `}</style>
        <img
            src="https://res.cloudinary.com/dxeram9ta/image/upload/v1755600880/logo_semesta_baru-removebg-preview-removebg-preview_v70utl.svg"
            alt="Loading..."
            className="semesta-logo-pulse"
            style={{ width: '80px', height: '80px' }}
        />
    </div>
);

const MenuDetailModal = ({ isOpen, onClose, item, onAddToCart, currentUser }) => {
    // [ANALYTICS] Track View Item
    useEffect(() => {
        if (isOpen && item) {
            logViewItem(item);
        }
    }, [isOpen, item]);

    if (!isOpen || !item) return null;

    const handleAddToCartAndClose = () => {
        onAddToCart(item);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden" onClick={(e) => e.stopPropagation()}>
                <img
                    src={item.image || 'https://placehold.co/400x300/e2e8f0/64748b?text=Gambar+Tidak+Tersedia'}
                    alt={item.name}
                    className="w-full h-48 object-cover"
                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/400x300/e2e8f0/64748b?text=Error'; }}
                />
                <div className="p-6">
                    <div className="flex justify-between items-start mb-2">
                        <h2 className="text-2xl font-bold text-green-900">{item.name}</h2>
                        {/* [BARU] Tombol Share di Modal */}
                        {currentUser && <ShareButton item={item} user={currentUser} />}
                    </div>
                    <p className="text-gray-600 mb-4">{item.description}</p>

                    {item.isPackage ? (
                        <div className="flex items-baseline space-x-2 mb-4">
                            <p className="text-2xl text-green-800 font-bold">Rp {item.packagePrice.toLocaleString('id-ID')}</p>
                            <p className="text-gray-500 text-md line-through">Rp {item.originalPrice.toLocaleString('id-ID')}</p>
                        </div>
                    ) : (
                        <p className="text-2xl text-green-800 font-bold mb-4">Rp {item.price.toLocaleString('id-ID')}</p>
                    )}

                    <button
                        onClick={handleAddToCartAndClose}
                        disabled={item.isAvailable === false}
                        className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                        {item.isAvailable === false ? 'Menu Habis' : 'Tambah ke Keranjang'}
                    </button>
                </div>
            </div>
        </div>
    );
};


const ChatModal = ({ isOpen, onClose, order, currentUser, showNotification }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isLocating, setIsLocating] = useState(false);
    // [BARU] State untuk upload gambar
    const [isUploading, setIsUploading] = useState(false);
    const messagesEndRef = useRef(null);
    // [BARU] Ref untuk input file
    const fileInputRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (!isOpen || !order?.id) {
            setMessages([]);
            return;
        }

        setIsLoading(true);
        const messagesCol = collection(db, `${publicDataPath}/transactions/${order.id}/messages`);
        const q = query(messagesCol, orderBy("createdAt", "asc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedMessages = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            setMessages(fetchedMessages);
            setIsLoading(false);
        }, (error) => {
            console.error("Gagal memuat pesan chat:", error);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [isOpen, order?.id]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSendMessage = async (e, messagePayload = null) => {
        if (e) e.preventDefault();

        // [MODIFIKASI] Menentukan payload dari input text atau dari parameter
        const payload = messagePayload || { text: newMessage.trim() };

        if (!payload.text && !payload.imageUrl) return;

        const batch = writeBatch(db);
        const messagesCol = collection(db, `${publicDataPath}/transactions/${order.id}/messages`);
        const newMessageRef = doc(messagesCol);
        const transactionRef = doc(db, `${publicDataPath}/transactions`, order.id);

        try {
            batch.set(newMessageRef, {
                ...payload, // Menggunakan payload
                senderId: currentUser.uid,
                senderName: currentUser.name,
                createdAt: Timestamp.now(),
            });

            // [MODIFIKASI] Snippet pesan disesuaikan jika yang dikirim adalah gambar
            const snippet = payload.imageUrl ? '[Gambar]' : (payload.text.substring(0, 40) + (payload.text.length > 40 ? '...' : ''));
            batch.update(transactionRef, {
                hasUnreadCashierMessages: true,
                lastMessageAt: Timestamp.now(),
                lastMessageSnippet: snippet,
            });

            await batch.commit();

            if (!messagePayload) {
                setNewMessage('');
            }
        } catch (error) {
            console.error("Gagal mengirim pesan:", error);
            showNotification('Gagal mengirim pesan.', 'error');
        }
    };

    // [MODIFIKASI] Fungsi diubah untuk kompresi dan upload ke Cloudinary
    const handleSendImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            showNotification('Hanya file gambar yang diizinkan.', 'error');
            return;
        }

        setIsUploading(true);
        showNotification("Mengecilkan & mengunggah gambar...");
        try {
            const compressedFile = await compressImage(file);
            const downloadURL = await uploadImageToCloudinary(compressedFile, 'ChatImages');

            handleSendMessage(null, { text: '[Gambar]', imageUrl: downloadURL });
            showNotification("Gambar berhasil terkirim.", "success");

        } catch (error) {
            console.error("Gagal mengunggah gambar via Cloudinary:", error);
            showNotification(`Gagal mengirim gambar: ${error.message}`, 'error');
        } finally {
            setIsUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const handleShareLocation = () => {
        if (!("geolocation" in navigator)) {
            showNotification("Browser Anda tidak mendukung fitur lokasi.", "error");
            return;
        }

        setIsLocating(true);
        showNotification("Mencari lokasi akurat...", "info");

        // Helper function untuk mendapatkan lokasi dengan opsi tertentu
        const getLocation = (options) => {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, options);
            });
        };

        const attemptLocation = async () => {
            try {
                // Percobaan 1: High Accuracy (Timeout 5 detik)
                const position = await getLocation({ enableHighAccuracy: true, timeout: 5000, maximumAge: 0 });
                return position;
            } catch (error) {
                console.warn("High accuracy location failed, trying low accuracy...", error);
                showNotification("Sinyal GPS lemah, mencoba mode hemat daya...", "info");
                // Percobaan 2: Low Accuracy (Timeout 15 detik) - Fallback
                return await getLocation({ enableHighAccuracy: false, timeout: 15000, maximumAge: 0 });
            }
        };

        attemptLocation()
            .then((position) => {
                const { latitude, longitude } = position.coords;
                const locationUrl = `https://maps.google.com/?q=${latitude},${longitude}`;
                handleSendMessage(null, { text: `Lokasi saya saat ini: ${locationUrl}` });
                showNotification("Lokasi berhasil dikirim!", "success");
            })
            .catch((error) => {
                console.error("Geolocation error:", error);
                let errorMessage = "Gagal mendapatkan lokasi.";
                if (error.code === 1) errorMessage = "Izin lokasi ditolak. Mohon aktifkan di pengaturan browser.";
                else if (error.code === 2) errorMessage = "Posisi tidak tersedia. Pastikan GPS aktif.";
                else if (error.code === 3) errorMessage = "Waktu habis. Sinyal GPS terlalu lemah.";

                showNotification(errorMessage, "error");
            })
            .finally(() => {
                setIsLocating(false);
            });
    };

    const renderMessageText = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split(urlRegex).map((part, i) => {
            if (part.match(urlRegex)) {
                return <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline hover:text-blue-700">{part}</a>;
            }
            return part;
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-end sm:items-center justify-center z-50 p-0 sm:p-4" onClick={onClose}>
            <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-xl w-full max-w-md flex flex-col h-[85vh] sm:h-[90vh]" onClick={(e) => { e.stopPropagation(); }}>
                <header className="p-4 border-b flex items-center justify-between sticky top-0 bg-white z-10 rounded-t-2xl sm:rounded-t-lg">
                    <div>
                        <h2 className="text-lg font-bold text-green-900">Chat dengan Kasir</h2>
                        <p className="text-sm text-gray-500">ID Pesanan: {order.id.substring(0, 8)}...</p>
                    </div>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </header>

                <main className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50">
                    {isLoading ? (
                        <div className="flex justify-center items-center h-full"><SemestaLogoSpinner /></div>
                    ) : messages.length > 0 ? (
                        messages.map(msg => {
                            const isUser = msg.senderId === currentUser.uid;
                            return (
                                // [MODIFIKASI] Wrapper diubah untuk alignment vertikal
                                <div key={msg.id} className={`flex flex-col ${isUser ? 'items-end' : 'items-start'}`}>
                                    {/* Gelembung chat */}
                                    <div className={`max-w-xs lg:max-w-md px-4 py-2 rounded-2xl ${isUser ? 'bg-green-800 text-white rounded-br-none' : 'bg-gray-200 text-gray-800 rounded-bl-none'}`}>
                                        {/* [MODIFIKASI] Render gambar jika ada */}
                                        {msg.imageUrl ? (
                                            <a href={msg.imageUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={msg.imageUrl} alt="Gambar terkirim" className="rounded-lg max-w-full h-auto" style={{ maxHeight: '200px' }} />
                                            </a>
                                        ) : (
                                            <p className="text-sm" style={{ wordBreak: 'break-word' }}>{renderMessageText(msg.text)}</p>
                                        )}
                                        {/* [DIHAPUS] Timestamp <p> tag yang lama dihapus dari sini */}
                                    </div>
                                    {/* [BARU] Baris Status (Timestamp + Tanda Dibaca) */}
                                    <div className="flex items-center space-x-1 mt-1 px-1">
                                        <span className="text-xs text-gray-400">
                                            {msg.createdAt ? new Date(msg.createdAt.seconds * 1000).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) : '--:--'}
                                        </span>
                                        {/* [BARU] Tanda Dibaca (Hanya untuk pesan pengguna/pelanggan) */}
                                        {isUser && (
                                            order.hasUnreadCashierMessages === false ? (
                                                <CheckCheckIcon className="w-4 h-4 text-green-500" title="Dilihat Kasir" />
                                            ) : (
                                                <CheckIcon className="w-4 h-4 text-gray-400" title="Terkirim" />
                                            )
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p className="text-center text-gray-500">Mulai percakapan dengan kasir...</p>
                    )}
                    <div ref={messagesEndRef} />
                </main>

                <footer className="p-4 bg-white border-t">
                    <form onSubmit={handleSendMessage} className="flex items-center space-x-2">
                        {/* [BARU] Input file tersembunyi */}
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleSendImage}
                            accept="image/*"
                            style={{ display: 'none' }}
                        />
                        {/* [BARU] Tombol kirim gambar */}
                        <button type="button" onClick={() => fileInputRef.current.click()} disabled={isUploading} className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-gray-500 rounded-full hover:bg-gray-200 transition-colors disabled:opacity-50">
                            {isUploading ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>}
                        </button>
                        <button type="button" onClick={handleShareLocation} disabled={isLocating} className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-gray-500 rounded-full hover:bg-gray-200 transition-colors disabled:opacity-50">
                            {isLocating ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : <MapPinIcon className="w-5 h-5" />}
                        </button>
                        <input
                            type="text"
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            placeholder="Ketik pesan Anda..."
                            className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-full focus:ring-2 focus:ring-green-500 focus:border-transparent"
                            autoComplete="off"
                        />
                        <button type="submit" className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-green-800 text-white rounded-full hover:bg-green-900 transition-colors disabled:bg-gray-400" disabled={!newMessage.trim()}>
                            <SendIcon className="w-5 h-5" />
                        </button>
                    </form>
                </footer>
            </div>
        </div>
    );
};


const LoginPage = ({ onLogin, onSwitchToRegister, onSwitchToForgotPassword, onGoogleLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    return (
        <AuthPage>
            <div className="flex justify-center mb-4">
                <img src="https://res.cloudinary.com/dixc7tg2l/image/upload/v1753695417/logo_semesta_baru-removebg-preview_x8admb.png" alt="Logo Semesta Cafe" className="w-48" />
            </div>
            <div className="text-center"><h2 className="text-3xl font-bold text-green-900">Selamat Datang</h2><p className="text-gray-500">Log in to Semesta Cafe</p></div>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onLogin(email, password); }}>
                <div><label className="text-sm font-medium text-gray-700">Email</label><input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500" /></div>
                <div className="space-y-1"><label className="text-sm font-medium text-gray-700">Password</label><div className="relative"><input type={showPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500 pr-10" /><button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500">{showPassword ? <EyeOffIcon /> : <EyeIcon />}</button></div></div>
                <button type="submit" className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors">Login</button>
            </form>
            <div className="relative my-4"><div className="absolute inset-0 flex items-center"><span className="w-full border-t"></span></div><div className="relative flex justify-center text-xs uppercase"><span className="bg-white px-2 text-gray-500">Atau lanjut dengan</span></div></div>
            <button onClick={onGoogleLogin} className="w-full flex justify-center items-center py-3 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"><GoogleIcon className="w-6 h-6 mr-2" /> Masuk dengan Google</button>
            <div className="text-center text-sm text-gray-600 mt-4">
                <p>Belum punya akun? <span onClick={onSwitchToRegister} className="font-semibold text-green-700 cursor-pointer hover:underline">Daftar di sini</span></p>
                <p onClick={onSwitchToForgotPassword} className="mt-2 cursor-pointer text-blue-600 hover:underline">Lupa Password?</p>
            </div>
        </AuthPage>
    );
};

const RegisterPage = ({ onRegister, onSwitchToLogin, onGoogleLogin }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    return (
        <AuthPage>
            <div className="flex justify-center mb-4">
                <img src="https://res.cloudinary.com/dixc7tg2l/image/upload/v1753695417/logo_semesta_baru-removebg-preview_x8admb.png" alt="Logo Semesta Cafe" className="w-48" />
            </div>
            <div className="text-center"><h2 className="text-3xl font-bold text-green-900">Buat Akun</h2><p className="text-gray-500">Gabung bersama keluarga Semesta</p></div>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onRegister({ name, email, password }); }}>
                <div><label className="text-sm font-medium text-gray-700">Nama Lengkap</label><input type="text" value={name} onChange={e => setName(e.target.value)} required className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500" /></div>
                <div><label className="text-sm font-medium text-gray-700">Email</label><input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500" /></div>
                <div className="space-y-1"><label className="text-sm font-medium text-gray-700">Password</label><div className="relative"><input type={showPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500 pr-10" /><button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500">{showPassword ? <EyeOffIcon /> : <EyeIcon />}</button></div></div>
                <button type="submit" className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors">Daftar</button>
            </form>
            <div className="relative my-4"><div className="absolute inset-0 flex items-center"><span className="w-full border-t"></span></div><div className="relative flex justify-center text-xs uppercase"><span className="bg-white px-2 text-gray-500">Atau</span></div></div>
            <button onClick={onGoogleLogin} className="w-full flex justify-center items-center py-3 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"><GoogleIcon className="w-6 h-6 mr-2" /> Daftar dengan Google</button>
            <div className="text-center text-sm text-gray-600 mt-4"><p>Sudah punya akun? <span onClick={onSwitchToLogin} className="font-semibold text-green-700 cursor-pointer hover:underline">Login di sini</span></p></div>
        </AuthPage>
    );
};

const ForgotPasswordPage = ({ onResetPassword, onSwitchToLogin }) => {
    const [email, setEmail] = useState('');
    return (
        <AuthPage>
            <div className="text-center">
                <h2 className="text-3xl font-bold text-green-900">Lupa Password</h2>
                <p className="text-gray-500">Masukkan email Anda untuk menerima link reset.</p>
            </div>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onResetPassword(email); }}>
                <div>
                    <label className="text-sm font-medium text-gray-700">Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-lg focus:ring-green-500 focus:border-green-500" />
                </div>
                <button type="submit" className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors">Kirim Link Reset</button>
            </form>
            <div className="text-center text-sm text-gray-600">
                <p>Kembali ke <span onClick={onSwitchToLogin} className="font-semibold text-green-700 cursor-pointer hover:underline">Login</span></p>
            </div>
        </AuthPage>
    );
};

const ImageSlider = ({ urls }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (!urls || urls.length <= 1) return;
        const timer = setTimeout(() => setCurrentIndex((prev) => (prev + 1) % urls.length), 5000);
        return () => clearTimeout(timer);
    }, [currentIndex, urls]);

    if (!urls || urls.length === 0) return <div className="w-full h-40 md:h-56 bg-gray-200 rounded-2xl flex items-center justify-center text-gray-500">Banner belum diatur</div>;
    return <div className="relative w-full h-40 md:h-56 overflow-hidden rounded-2xl shadow-lg mb-6">
        {urls.map((url, i) => (
            <img
                key={i}
                src={url}
                alt={`Banner ${i + 1}`}
                className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${i === currentIndex ? 'opacity-100' : 'opacity-0'}`}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Banner+Error';
                }}
            />
        ))}
    </div>;
};

const HomeScreen = ({ user, settings, menuItems, packages, activeOrder, onAddToCart, onShowRecommendation, onShowDetail, latestBroadcast, onDismissBroadcast, isPremiumMode, userLocation, currentHour, locationError, onRefreshLocation, isLocationLoading, menuCategories }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState('All');

    // [BARU] Header Status Lokasi & Refresh
    const LocationStatusHeader = () => {
        if (isLocationLoading) {
            return (
                <div className="bg-blue-50 p-2 rounded-lg flex items-center justify-center text-xs text-blue-700 mb-4 animate-pulse">
                    <SemestaLogoSpinner style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                    Mencari sinyal GPS...
                </div>
            );
        }

        if (locationError) {
            return (
                <div className="bg-red-50 p-2 rounded-lg flex items-center justify-between text-xs text-red-700 mb-4">
                    <span className="flex-1 mr-2">⚠️ {locationError}</span>
                    <button
                        onClick={onRefreshLocation}
                        className="bg-red-200 hover:bg-red-300 text-red-800 px-2 py-1 rounded font-bold"
                    >
                        Coba Lagi
                    </button>
                </div>
            );
        }

        if (userLocation) {
            return (
                <div className="flex justify-between items-center mb-4 px-1">
                    <span className="text-xs text-green-600 flex items-center">
                        <MapPinIcon className="w-3 h-3 mr-1" />
                        Akurasi: {userLocation.distance ? userLocation.distance.toFixed(3) + 'km' : 'OK'}
                    </span>
                    <button
                        onClick={onRefreshLocation}
                        className="text-xs text-gray-400 hover:text-green-600 underline"
                    >
                        Update Lokasi
                    </button>
                </div>
            );
        }

        return null;
    };

    // [MODIFIKASI] Kategori sekarang dinamis dari Firestore (sinkron dengan admin)
    const categories = ['All', 'Paket', ...menuCategories];

    const availablePackages = packages.map(p => {
        const itemsInPackage = p.itemIds.map(id => menuItems.find(mi => mi.id === id));
        const isPackageAvailable = itemsInPackage.every(item => item && item.isAvailable !== false);
        return { ...p, isPackage: true, isAvailable: isPackageAvailable };
    });

    const allItems = [...menuItems, ...availablePackages];

    const featuredIds = settings.featuredMenuItems || [];
    const featuredList = featuredIds.map(id => allItems.find(item => item.id === id)).filter(Boolean);
    const otherList = allItems.filter(item => !featuredIds.includes(item.id));

    let itemsToDisplay;
    if (activeCategory === 'All') {
        itemsToDisplay = [...featuredList, ...otherList];
    } else if (activeCategory === 'Paket') {
        itemsToDisplay = availablePackages;
    } else {
        itemsToDisplay = menuItems.filter(item => item.category === activeCategory);
    }

    const filteredMenuItems = itemsToDisplay.filter(item =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // [MODIFIKASI] Logika untuk menangani format banner lama dan baru
    let activeBannerUrls = [];
    if (settings.banners) {
        // Format baru: array objek { url, active }
        activeBannerUrls = settings.banners
            .filter(b => b.active && b.url)
            .map(b => b.url);
    } else if (settings.bannerUrls && settings.isBannerActive !== false) {
        // Fallback untuk format lama: array string
        activeBannerUrls = settings.bannerUrls.filter(url => url && url.trim() !== '');
    }

    return (
        <div className="p-4 md:p-6 bg-gray-50">
            {/* [MODIFIKASI] Banner Pengumuman dihapus, pindah ke Notifikasi Lonceng */}
            {/* <AnnouncementBanner broadcast={latestBroadcast} onDismiss={onDismissBroadcast} /> */}

            <header className="mb-6 flex justify-between items-start">
                <div>
                    <p className="text-lg text-gray-500">Hai {user.name}</p>
                    <h1 className="text-3xl font-bold text-green-900">{settings.headerTexts?.title || "Selamat Datang!"}</h1>
                </div>
                <div className="bg-white p-3 rounded-xl shadow-sm border border-green-100 flex flex-col items-end">
                    <p className="text-xs text-gray-500 mb-1">Saldo Semesta Pay</p>
                    <p className="text-lg font-bold text-green-800">Rp {(user.balance || 0).toLocaleString('id-ID')}</p>
                    <button
                        onClick={() => window.dispatchEvent(new CustomEvent('openTopUpModal'))}
                        className="text-xs text-green-600 font-semibold mt-1 hover:underline flex items-center"
                    >
                        + Isi Saldo
                    </button>
                </div>
            </header>

            <LocationStatusHeader />

            <ImageSlider urls={activeBannerUrls} />

            <div className="relative mb-4">
                <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input type="text" placeholder="Cari kopi favoritmu..." className="w-full py-3 pl-12 pr-4 bg-white border border-gray-200 rounded-full focus:ring-2 focus:ring-green-500 focus:border-transparent" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>

            <div className="grid grid-cols-4 gap-4 mb-8">
                <button onClick={onShowRecommendation} className="flex flex-col items-center justify-center space-y-2 group">
                    <div className="w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center group-hover:bg-green-200 transition-colors shadow-sm text-green-700">
                        <GatchaIcon className="w-7 h-7" />
                    </div>
                    <span className="text-xs font-medium text-center text-gray-700">Gatcha Menu</span>
                </button>
                <button onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: 'EventList' }))} className="flex flex-col items-center justify-center space-y-2 group">
                    <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center group-hover:bg-orange-200 transition-colors shadow-sm text-orange-700">
                        <HiOutlineCalendar className="w-7 h-7" />
                    </div>
                    <span className="text-xs font-medium text-center text-gray-700">Eventku</span>
                </button>
                <button onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: 'Bukber' }))} className="flex flex-col items-center justify-center space-y-2 group">
                    <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center group-hover:bg-emerald-200 transition-colors shadow-sm text-emerald-700">
                        <HiOutlineUsers className="w-7 h-7" />
                    </div>
                    <span className="text-xs font-medium text-center text-gray-700">Bukber</span>
                </button>

                <button
                    onClick={() => {
                        if (!isPremiumMode && !window.isPremiumModeGlobal) {
                            window.dispatchEvent(new CustomEvent('show-notification', { detail: { message: 'Fitur ini hanya aktif di area Semesta Cafe!', type: 'error' } }));
                            return;
                        }
                        window.dispatchEvent(new CustomEvent('navigate', { detail: 'Sparring' }));
                    }}
                    className="flex flex-col items-center justify-center space-y-2 group"
                >
                    <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-colors shadow-sm ${isPremiumMode || window.isPremiumModeGlobal ? 'bg-red-100 text-red-700 group-hover:bg-red-200' : 'bg-gray-200 text-gray-400'}`}>
                        <SparringIcon className="w-7 h-7" />
                    </div>
                    <span className={`text-xs font-medium text-center ${isPremiumMode || window.isPremiumModeGlobal ? 'text-gray-700' : 'text-gray-400'}`}>Simulasi Sidang</span>
                </button>
            </div>

            {/* [BARU] Banner Promo Weekend 10rb (Fase 2) */}
            <button
                onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: 'PromoWeekend' }))}
                className="w-full mb-6 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-4 text-white shadow-lg text-left active:scale-[0.99]"
            >
                <p className="font-bold text-lg leading-tight">🔥 Promo Weekend: Semua Menu 10rb!</p>
                <p className="text-sm opacity-90 mt-1">Sabtu & Minggu • Pagi 08–11 • Malam 19–21 • Kuota 10/sesi, siapa cepat dia dapat. Cek sisa kuota & booking →</p>
            </button>

            <div className="flex space-x-2 mb-6 overflow-x-auto pb-2">
                {categories.map(cat => (
                    <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-colors ${cat === activeCategory ? 'bg-green-800 text-white' : 'bg-white text-gray-700 hover:bg-green-100'}`}>
                        {cat}
                    </button>
                ))}
            </div>

            {activeCategory === 'All' && featuredList.length > 0 && searchQuery === '' && (
                <h2 className="col-span-2 md:col-span-3 text-xl font-bold text-green-800 mb-4">Pilihan Spesial Untukmu</h2>
            )}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                {filteredMenuItems.map(item => {
                    // [MODIFIKASI] Logika Tampilan Promo di Home Screen
                    const promoConfig = settings?.locationPromo || {};
                    const isPromoConfigActive = promoConfig.isActive === true;
                    // Gunakan prop currentHour yang dilempar dari AppView (real-time)
                    const promoMaxHour = promoConfig.maxHour !== undefined ? promoConfig.maxHour : 22;
                    const promoPrice = promoConfig.price || 10000;

                    // Cek ketersediaan promo (Time & Location & Active)
                    // Kita gunakan logic agak longgar untuk display: kalau active & time masuk, kita show.
                    // Detail jarak validasi ada di Cart. Di sini kita kasih indikator visual aja.
                    const isPromoTime = currentHour < promoMaxHour;
                    const showPromoDisplay = isPromoConfigActive && isPromoTime;

                    return (
                        <div key={item.id} className={`bg-white rounded-2xl shadow-md overflow-hidden group flex flex-col relative ${item.isAvailable === false ? 'opacity-60' : ''}`}>
                            {item.isAvailable === false && (
                                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center z-10 rounded-2xl">
                                    <span className="text-white font-bold text-lg bg-red-600 px-3 py-1 rounded-md shadow-lg">Habis</span>
                                </div>
                            )}
                            <div onClick={() => item.isAvailable !== false && onShowDetail(item)} className={item.isAvailable !== false ? 'cursor-pointer' : 'cursor-default'}>
                                <img
                                    src={item.image || 'https://placehold.co/400x300/e2e8f0/64748b?text=Gambar+Tidak+Tersedia'}
                                    alt={item.name}
                                    className="w-full h-32 object-cover transition-transform group-hover:scale-105"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://placehold.co/400x300/e2e8f0/64748b?text=Gambar+Tidak+Tersedia';
                                    }}
                                />
                                {/* [BARU] Tombol Share di Kartu Menu */}
                                <div className="absolute top-2 right-2 z-10">
                                    <ShareButton item={item} user={user} compact={true} />
                                </div>
                                <div className="p-3">
                                    <h3 className="font-bold text-green-900 truncate">{item.name}</h3>
                                    <p className="text-sm text-gray-500 truncate">{item.description}</p>
                                </div>
                            </div>
                            <div className="p-3 pt-0 mt-auto">
                                <div className="flex justify-between items-center">
                                    {item.isPackage ? (
                                        <div className="flex items-baseline space-x-2">
                                            <p className="text-gray-700 font-semibold">Rp {item.packagePrice.toLocaleString('id-ID')}</p>
                                            <p className="text-gray-500 text-xs line-through">Rp {item.originalPrice.toLocaleString('id-ID')}</p>
                                        </div>
                                    ) : (
                                        /* LOGIKA HARGA PROMO */
                                        showPromoDisplay ? (
                                            <div className="flex flex-col">
                                                <div className="flex items-center space-x-1">
                                                    <span className="bg-red-100 text-red-600 text-[10px] font-bold px-1.5 py-0.5 rounded">PROMO</span>
                                                    <p className="text-green-700 font-bold">Rp {promoPrice.toLocaleString('id-ID')}</p>
                                                </div>
                                                <p className="text-gray-400 text-xs line-through">Rp {item.price.toLocaleString('id-ID')}</p>
                                            </div>
                                        ) : (
                                            <p className="text-gray-700 font-semibold">Rp {item.price.toLocaleString('id-ID')}</p>
                                        )
                                    )}
                                    <button
                                        onClick={() => onAddToCart(item)}
                                        disabled={item.isAvailable === false}
                                        className="w-8 h-8 flex items-center justify-center bg-green-800 text-white rounded-full text-xl hover:bg-green-900 transition-transform transform hover:scale-110 disabled:bg-gray-400 disabled:cursor-not-allowed"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const CartScreen = ({ cart, onPlaceOrder, onUpdateQuantity, onDeleteItem, onBack, user, showNotification, settings, currentHour, defaultOrderType, bukberJoinData, setCurrentPage, guestName, setGuestName, isBukberMode }) => {
    const [notes, setNotes] = useState('');
    const [orderType, setOrderType] = useState(defaultOrderType || '');
    const [address, setAddress] = useState('');
    const [seatingPosition, setSeatingPosition] = useState('');
    const [voucherCode, setVoucherCode] = useState('');
    const [appliedVoucher, setAppliedVoucher] = useState(null);

    const [isProcessingOrder, setIsProcessingOrder] = useState(false);
    const [isLocating, setIsLocating] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    // [BARU] State untuk ongkir
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [distanceInKm, setDistanceInKm] = useState(null);
    const [isLocationSet, setIsLocationSet] = useState(false); // Untuk validasi
    const [deliveryError, setDeliveryError] = useState(''); // Untuk pesan error > 5km

    // [MODIFIKASI] Logika Promo Server-Side (Dari Firestore via settings.locationPromo)
    // Structure expected: settings.locationPromo = { isActive: true, price: 10000, radiusKm: 0.1, maxHour: 22, message: "..." }
    const promoConfig = settings?.locationPromo || {};

    // [MOVED UP] currentHour sekarang diterima dari props (AppView) agar sinkron
    // const [currentHour, setCurrentHour] = useState(new Date().getHours());
    // useEffect moved to AppView

    // Default values if config exists but incomplete, or fallback to false if no config
    const isPromoConfigActive = promoConfig.isActive === true;
    const promoPrice = promoConfig.price || 10000;
    const promoRadius = promoConfig.radiusKm || 0.1;
    const promoMaxHour = promoConfig.maxHour !== undefined ? promoConfig.maxHour : 22;

    const isPromoTime = currentHour < promoMaxHour;
    const isActivePromo = isPromoConfigActive && orderType === 'dine-in' && distanceInKm !== null && distanceInKm <= promoRadius && isPromoTime;



    // [BARU] Auto-select metode pembayaran untuk Bukber
    useEffect(() => {
        if (orderType === 'booking') {
            setPaymentMethod('duitku_qris');
        } else if (orderType === 'delivery') {
            setPaymentMethod('qris'); // Default delivery ke QRIS (preferensi)
        } else {
            // Reset jika pindah dari booking/delivery ke dine-in, tapi biarkan user memilih
            if (paymentMethod === 'duitku_qris') setPaymentMethod('');
        }
    }, [orderType]);

    // [MODIFIKASI] Total sekarang menghitung harga promo jika eligible
    const subtotal = cart.reduce((sum, item) => {
        let price = item.isPackage ? item.packagePrice : item.price;
        // [BARU] Override harga paket/item jadi 10rb jika promo aktif
        if (isActivePromo) {
            price = promoPrice;
        }
        return sum + price * item.quantity;
    }, 0);

    // [BARU] AFFILIATE: Diskon Referral 5%
    const referrerId = localStorage.getItem('semesta_referrer_id');
    const isSelfReferral = referrerId === user.uid;
    const isReferralEligible = referrerId && !isSelfReferral;

    // Diskon referral dihitung dari subtotal
    const referralDiscount = isReferralEligible ? subtotal * 0.05 : 0;

    const voucherDiscount = appliedVoucher ? (subtotal * appliedVoucher.discount) / 100 : 0;

    // [BARU] Diskon Semesta Pay (5%)
    // Base calculation: Subtotal - Voucher - Referral (Agar tidak double count gross)
    const semestaPayBase = Math.max(0, subtotal - voucherDiscount - referralDiscount);
    const semestaPayDiscount = paymentMethod === 'semesta_pay' ? semestaPayBase * 0.05 : 0;

    const totalDiscount = voucherDiscount + semestaPayDiscount + referralDiscount;
    const total = subtotal - totalDiscount + deliveryFee;

    // [BARU] Validasi saldo untuk Semesta Pay
    const isBalanceSufficient = user.balance >= total;

    const handleApplyVoucher = () => {
        const availableVoucher = user.vouchers?.find(v => v.code === voucherCode && !v.used);
        if (availableVoucher) {
            setAppliedVoucher(availableVoucher);
            showNotification(`Kupon ${voucherCode} berhasil diterapkan! Diskon ${availableVoucher.discount}%`, 'success');
        } else {
            showNotification('Kupon tidak valid atau sudah digunakan.', 'error');
        }
    };

    const handleDownloadQRIS = async () => {
        try {
            const imageUrl = 'https://res.cloudinary.com/dxeram9ta/image/upload/v1760513408/PXL_20251015_072705713_2_q9qjoj.jpg';
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'qris-semesta-cafe.jpg';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            showNotification('Gambar QRIS berhasil diunduh.', 'success');
        } catch (error) {
            console.error('Gagal mengunduh QRIS:', error);
            showNotification('Gagal mengunduh gambar QRIS.', 'error');
        }
    };

    // [MODIFIKASI] handleUseCurrentLocation sekarang menghitung jarak dan ongkir
    // [MODIFIKASI] handleUseCurrentLocation sekarang menghitung jarak dan ongkir
    const handleUseCurrentLocation = () => {
        if (!("geolocation" in navigator)) {
            showNotification("Browser Anda tidak mendukung fitur lokasi.", "error");
            return;
        }

        setIsLocating(true);
        setDeliveryError('');
        setDistanceInKm(null);
        setIsLocationSet(false);
        showNotification("Mencari lokasi... Pastikan GPS aktif dan izin lokasi diberikan.", "info");

        // Helper function untuk mendapatkan lokasi dengan opsi tertentu (Hybrid: Web + Native)
        const getLocation = async (options) => {
            // Capacitor Geolocation plugin otomatis menangani Web & Native
            const coordinates = await Geolocation.getCurrentPosition({
                enableHighAccuracy: options.enableHighAccuracy,
                timeout: options.timeout,
                maximumAge: options.maximumAge
            });
            // Mapping hasil Capacitor ke format yang diharapkan (Position.coords)
            return {
                coords: {
                    latitude: coordinates.coords.latitude,
                    longitude: coordinates.coords.longitude
                }
            };
        };

        const attemptLocation = async () => {
            try {
                // Level 1: High Accuracy (15 detik) - Prioritas Satelit
                showNotification("Mencari sinyal GPS akurat...", "info");
                return await getLocation({ enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
            } catch (err1) {
                console.warn("High accuracy failed, trying network...", err1);
                try {
                    // Level 2: Low Accuracy (20 detik) - Prioritas Jaringan/WiFi
                    showNotification("Sinyal GPS lemah, mencoba mode jaringan/WiFi...", "info");
                    return await getLocation({ enableHighAccuracy: false, timeout: 20000, maximumAge: 0 });
                } catch (err2) {
                    console.warn("Network location failed, trying cache...", err2);
                    // Level 3: Cached Location (Last Resort) - Lokasi terakhir yang diketahui
                    showNotification("Sinyal sulit. Menggunakan lokasi terakhir yang diketahui...", "warning");
                    return await getLocation({ enableHighAccuracy: false, timeout: 5000, maximumAge: Infinity });
                }
            }
        };

        attemptLocation()
            .then((position) => {
                const { latitude, longitude } = position.coords;
                const locationUrl = `https://maps.google.com/?q=${latitude},${longitude}`;
                setAddress(locationUrl);

                // [BARU] Hitung jarak
                const distance = getDistanceFromLatLonInKm(
                    CAFE_LOCATION.latitude,
                    CAFE_LOCATION.longitude,
                    latitude,
                    longitude
                );
                setDistanceInKm(distance);

                // [BARU] Terapkan logika tarif ongkir dan validasi area
                // Untuk Promo Dine In (Radius 100m)
                if (distance <= promoRadius) {
                    showNotification("Anda berada di area Semesta Cafe!", "success");
                }

                if (distance > 7) {
                    setDeliveryError("Maaf terlalu jauh, bisa pakai maxim chat kasir saja");
                    setDeliveryFee(0);
                    setIsLocationSet(false);
                    showNotification("Lokasi Anda terlalu jauh untuk pengantaran.", "error");
                } else if (distance > 5) {
                    setDeliveryFee(9000);
                    setDeliveryError('');
                    setIsLocationSet(true);
                    showNotification("Lokasi didapat! Ongkir: Rp 9.000", "success");
                } else if (distance > 3.1) {
                    setDeliveryFee(7000);
                    setDeliveryError('');
                    setIsLocationSet(true);
                    showNotification("Lokasi didapat! Ongkir: Rp 7.000", "success");
                } else if (distance > 1) {
                    setDeliveryFee(5000);
                    setDeliveryError('');
                    setIsLocationSet(true);
                    showNotification("Lokasi didapat! Ongkir: Rp 5.000", "success");
                } else {
                    // 0 - 1 km
                    setDeliveryFee(0);
                    setDeliveryError('');
                    setIsLocationSet(true);
                    showNotification("Lokasi didapat! Gratis Ongkir!", "success");
                }
            })
            .catch((error) => {
                console.error("Geolocation error:", error);
                let errorMessage = "Gagal mendapatkan lokasi.";
                if (error.code === 1) {
                    errorMessage = "Izin lokasi ditolak. Klik ikon gembok 🔒 di address bar, lalu izinkan lokasi.";
                } else if (error.code === 2) {
                    errorMessage = "Posisi tidak tersedia. Pastikan GPS aktif dan coba lagi.";
                } else if (error.code === 3) {
                    errorMessage = "Waktu habis. Coba lagi di tempat terbuka atau aktifkan GPS.";
                    setDeliveryError(errorMessage); // Set error khusus untuk timeout agar tombol retry muncul
                }

                showNotification(errorMessage, "error");
                setIsLocationSet(false);
            })
            .finally(() => {
                setIsLocating(false);
            });
    };

    const handleOrderClick = () => {
        if (!orderType) {
            showNotification('Anda harus memilih tipe pesanan terlebih dahulu.', 'error');
            return;
        }
        // [BARU] Validasi untuk delivery
        if (orderType === 'delivery' && !isLocationSet) {
            showNotification('Anda harus menggunakan lokasi saat ini untuk pesanan delivery.', 'error');
            return;
        }
        if (deliveryError) {
            showNotification(deliveryError, 'error');
            return;
        }
        // [MODIFIKASI] Booking tidak perlu metode pembayaran di awal (karena pending/konfirmasi)
        if (orderType !== 'booking' && !paymentMethod) {
            showNotification('Anda harus memilih metode pembayaran.', 'error');
            return;
        }

        // [BARU] Validasi saldo Semesta Pay (Skip untuk Booking)
        if (orderType !== 'booking' && paymentMethod === 'semesta_pay' && !isBalanceSufficient) {
            showNotification('Saldo Semesta Pay tidak mencukupi. Silakan Top Up.', 'error');
            return;
        }

        // [MODIFIKASI] Mengirim ongkir, jarak, dan referral discount ke fungsi order
        onPlaceOrder({ notes, orderType, address, seatingPosition, appliedVoucher, total, discount: totalDiscount, paymentMethod, deliveryFee, distanceInKm, referralDiscount }, setIsProcessingOrder);
    };

    return (
        <div className="p-4 md:p-6">
            <div className="flex items-center mb-6">
                <button onClick={onBack} className="mr-4 p-2 rounded-full hover:bg-gray-200">&larr;</button>
                <h1 className="text-3xl font-bold text-green-900">Keranjang Anda</h1>
            </div>
            {cart.length === 0 ? (<p className="text-center text-gray-500 mt-10">Keranjang Anda kosong. Yuk, tambah kopi!</p>) : (
                <>
                    <div className="space-y-4">
                        {cart.map(item => (
                            <div key={item.id} className="flex items-center bg-white p-3 rounded-lg shadow-sm">
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="w-16 h-16 rounded-lg object-cover mr-4"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://placehold.co/100x100/e2e8f0/64748b?text=Gambar+Tidak+Tersedia';
                                    }}
                                />
                                <div className="flex-grow">
                                    <p className="font-semibold text-green-900">{item.name}</p>
                                    <div className="flex flex-col">
                                        {isActivePromo ? (
                                            <>
                                                <p className="text-xs text-gray-400 line-through">Rp {(item.isPackage ? item.packagePrice : item.price).toLocaleString('id-ID')}</p>
                                                <p className="text-sm font-bold text-green-600">Rp {promoPrice.toLocaleString('id-ID')} (Promo)</p>
                                            </>
                                        ) : (
                                            <p className="text-sm text-gray-500">Rp {(item.isPackage ? item.packagePrice : item.price).toLocaleString('id-ID')}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex items-center space-x-3"><button onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} className="w-7 h-7 rounded-full border border-green-800 text-green-800 font-bold">-</button><span>{item.quantity}</span><button onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} className="w-7 h-7 rounded-full bg-green-800 text-white font-bold">+</button></div>
                                <button onClick={() => onDeleteItem(item.id)} className="ml-4 text-red-500 hover:text-red-700"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></button>
                            </div>
                        ))}
                    </div>

                    <div className="mt-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Punya Kode Kupon?</label>
                        <div className="flex space-x-2">
                            <input type="text" value={voucherCode} onChange={e => setVoucherCode(e.target.value.toUpperCase())} placeholder="Masukkan kode" className="w-full p-2 border rounded-lg" />
                            <button onClick={handleApplyVoucher} className="px-4 bg-gray-800 text-white rounded-lg">Terapkan</button>
                        </div>
                    </div>

                    {/* [MODIFIKASI] Logic Interupsi untuk Joiner Bukber */}
                    {bukberJoinData ? (
                        <div className="mt-6 p-6 bg-green-50 border border-green-200 rounded-xl text-center shadow-sm">
                            <h3 className="font-bold text-green-900 text-lg mb-2">🎉 Menu Berhasil Dipilih!</h3>
                            <p className="text-green-700 mb-6">
                                Anda bergabung dengan Bukber <strong>{bukberJoinData.customerName}</strong>.
                                <br />Lanjut untuk mengisi nama Anda.
                            </p>
                            <button
                                onClick={() => setCurrentPage('Bukber')}
                                className="w-full py-4 bg-green-700 text-white font-bold rounded-xl shadow-lg hover:bg-green-800 transition-all flex items-center justify-center gap-2"
                            >
                                Lanjut ke Formulir Gabung {'>>'}
                            </button>
                        </div>
                    ) : (
                        <>
                            <div className="mt-4">
                                {isBukberMode && (
                                    <div className="mb-3 p-3 bg-green-50 border border-green-200 rounded-lg flex items-start">
                                        <span className="text-green-600 mr-2">ℹ️</span>
                                        <p className="text-sm text-green-700">
                                            <strong>Mode Reservasi Otomatis</strong><br />
                                            Pesanan Anda mengandung <strong>Paket Bukber</strong>, sehingga wajib menggunakan metode Reservasi.
                                        </p>
                                    </div>
                                )}
                                <label htmlFor="orderTypeSelect" className="block text-sm font-medium text-gray-700 mb-2">Pilih Tipe Pesanan <span className="text-red-500">*</span></label>
                                <select
                                    id="orderTypeSelect"
                                    value={orderType}
                                    onChange={(e) => setOrderType(e.target.value)}
                                    className={`w-full mt-1 p-2 border rounded-lg bg-white focus:ring-green-500 focus:border-green-500 ${isBukberMode ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''}`}
                                    required
                                    disabled={isBukberMode}
                                >
                                    <option value="" disabled>-- Silakan Pilih --</option>
                                    {!isBukberMode && <option value="delivery">Delivery</option>}
                                    {!isBukberMode && <option value="dine-in">Dine In (Makan di Tempat)</option>}
                                    <option value="booking">Bukber (Reservasi)</option>
                                </select>
                            </div>

                            {/* [BARU] Input Nama untuk Tamu (Dine-in) */}
                            {user.isAnonymous && orderType === 'dine-in' && (
                                <div className="mt-4 animate-fadeIn">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Nama Pemesan <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={guestName}
                                        onChange={(e) => {
                                            setGuestName(e.target.value);
                                            localStorage.setItem('semesta_guest_name', e.target.value);
                                        }}
                                        placeholder="Contoh: Budi"
                                        className="w-full p-3 border rounded-xl focus:ring-green-500 focus:border-green-500"
                                        required
                                    />
                                    <p className="text-xs text-gray-500 mt-1 italic">* Nama ini akan muncul di monitor kasir.</p>
                                </div>
                            )}

                            {orderType === 'delivery' && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700">Alamat Pengiriman</label>
                                    {/* [MODIFIKASI] Textarea dinonaktifkan untuk delivery */}
                                    <textarea
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="w-full mt-1 p-2 border rounded-lg disabled:bg-gray-200"
                                        placeholder="Silakan gunakan tombol 'Gunakan Lokasi Saat Ini' di bawah."
                                        required
                                        disabled
                                    />
                                    <button
                                        onClick={handleUseCurrentLocation}
                                        className="w-full mt-2 py-3 px-4 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center disabled:opacity-50 disabled:bg-gray-400"
                                        disabled={isLocating}
                                    >
                                        {isLocating ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : <><MapPinIcon className="w-5 h-5 mr-2" /> Gunakan Lokasi Saat Ini (Wajib)</>}
                                    </button>

                                    {/* [BARU] Tombol Retry jika gagal karena timeout */}
                                    {deliveryError && deliveryError.includes('Waktu habis') && (
                                        <button
                                            onClick={handleUseCurrentLocation}
                                            className="w-full mt-2 py-2 px-4 bg-yellow-100 text-yellow-800 font-semibold rounded-lg hover:bg-yellow-200 transition-colors flex items-center justify-center"
                                        >
                                            🔄 Coba Lagi
                                        </button>
                                    )}

                                    <p className="text-xs text-gray-500 mt-1">Pastikan GPS aktif untuk akurasi.</p>

                                    {/* [BARU] Tampilan info jarak dan ongkir */}
                                    {distanceInKm !== null && !deliveryError && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg text-sm">
                                            <p>Jarak: <strong>{distanceInKm.toFixed(2)} km</strong></p>
                                            <p>Ongkos Kirim: <strong>Rp {deliveryFee.toLocaleString('id-ID')}</strong></p>
                                        </div>
                                    )}

                                    {/* [NEW] Mini-map for delivery location */}
                                    {distanceInKm !== null && !deliveryError && address && (
                                        <div className="mt-3 rounded-xl overflow-hidden shadow-sm border border-gray-200">
                                            <LeafletMap
                                                userLocation={(() => {
                                                    // Extract coords from Google Maps URL
                                                    const match = address.match(/q=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
                                                    if (match) {
                                                        return { latitude: parseFloat(match[1]), longitude: parseFloat(match[2]) };
                                                    }
                                                    return null;
                                                })()}
                                                cafeLocation={CAFE_LOCATION}
                                                height="180px"
                                                zoom={14}
                                                showDeliveryZones={true}
                                            />
                                        </div>
                                    )}

                                    {deliveryError && (
                                        <div className="mt-2 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
                                            <p>{deliveryError}</p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* [BARU] Bagian Lokasi untuk Dine-In (Cek Promo) */}
                            {orderType === 'dine-in' && isPromoConfigActive && (
                                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                                    <div className="flex items-start">
                                        <TrophyIcon className="w-6 h-6 text-green-600 mr-2 flex-shrink-0" />
                                        <div>
                                            <h3 className="font-bold text-green-900">{promoConfig.title || "Promo Spesial Hari Ini! 🎉"}</h3>
                                            <p className="text-sm text-gray-700 mt-1">
                                                {promoConfig.message || `Dapatkan harga spesial Rp ${promoPrice.toLocaleString('id-ID')} jika order Dine In di area kafe sebelum jam ${promoMaxHour}:00.`}
                                            </p>

                                            {isActivePromo ? (
                                                <div className="mt-3 flex items-center text-green-700 font-bold bg-green-100 p-2 rounded-lg">
                                                    <CheckCircleIcon className="w-5 h-5 mr-2" />
                                                    Promo Aktif! Harga disesuaikan.
                                                </div>
                                            ) : (
                                                <button
                                                    onClick={handleUseCurrentLocation}
                                                    disabled={isLocating}
                                                    className="mt-3 text-sm bg-green-700 text-white py-2 px-4 rounded-lg hover:bg-green-800 transition-colors flex items-center"
                                                >
                                                    {isLocating ? <SemestaLogoSpinner style={{ width: '16px', height: '16px' }} /> : <LocationIcon className="w-4 h-4 mr-2" />}
                                                    Cek Lokasi Saya
                                                </button>
                                            )}
                                            {distanceInKm !== null && !isActivePromo && (
                                                <p className="text-xs text-red-500 mt-2">
                                                    {!isPromoTime ? `Maaf, promo sudah berakhir (Lewat jam ${promoMaxHour}:00).` :
                                                        distanceInKm > promoRadius ? "Maaf, Anda terdeteksi diluar jangkauan area kafe." : ""}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {orderType === 'dine-in' && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700">Posisi Tempat Duduk</label>
                                    <input type="text" value={seatingPosition} onChange={(e) => setSeatingPosition(e.target.value)} className="w-full mt-1 p-2 border rounded-lg" placeholder="Contoh: lesehan, indoor, outdoor, ruangan kayu" required />
                                </div>
                            )}

                            <div className="mt-4">
                                <label className="block text-sm font-medium text-gray-700">Catatan Pesanan (opsional)</label>
                                <textarea value={notes} onChange={(e) => setNotes(e.target.value)} className="w-full mt-1 p-2 border rounded-lg" placeholder="Contoh: Gula sedikit, jangan pakai es."></textarea>
                            </div>

                            <div className="mt-6">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Metode Pembayaran <span className="text-red-500">*</span></label>

                                {/* [MODIFIKASI] Logika Pelunasan Khusus Bukber */}
                                {orderType === 'booking' ? (
                                    <div className="space-y-3">
                                        <div className="p-3 bg-purple-50 text-purple-800 text-sm rounded-lg border border-purple-200">
                                            <p className="font-bold">Info Pembayaran Bukber:</p>
                                            <p>Wajib DP (Down Payment) untuk mengamankan reservasi.</p>
                                        </div>

                                        {/* Opsi 1: Semesta Pay */}
                                        <div className={`w-full rounded-lg border-2 transition-all ${paymentMethod === 'semesta_pay' ? 'bg-green-50 border-green-800' : 'bg-white border-gray-200'}`}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (isBalanceSufficient) {
                                                        setPaymentMethod('semesta_pay');
                                                    }
                                                }}
                                                disabled={!isBalanceSufficient}
                                                className={`w-full py-3 px-4 flex items-center justify-between ${!isBalanceSufficient ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                            >
                                                <div className="flex items-center">
                                                    <WalletIcon className="w-6 h-6 mr-3 text-green-800" />
                                                    <div className="text-left">
                                                        <p className="font-semibold text-gray-800">Semesta Pay (Saldo)</p>
                                                        <p className={`text-xs ${!isBalanceSufficient ? 'text-red-500 font-bold' : 'text-gray-500'}`}>
                                                            Saldo: Rp {(user.balance || 0).toLocaleString('id-ID')}
                                                            {!isBalanceSufficient && " (Kurang)"}
                                                        </p>
                                                    </div>
                                                </div>
                                                {paymentMethod === 'semesta_pay' && <CheckCircleIcon className="w-6 h-6 text-green-800" />}
                                            </button>
                                            {/* [BARU] Opsi Top Up muncul jika saldo kurang */}
                                            {!isBalanceSufficient && (
                                                <div className="px-4 pb-3 pt-0">
                                                    <button
                                                        onClick={() => window.dispatchEvent(new CustomEvent('openTopUpModal'))}
                                                        className="w-full py-2 bg-green-100 text-green-800 text-sm font-bold rounded-lg hover:bg-green-200 transition-colors"
                                                    >
                                                        + Isi Saldo Dulu
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Opsi 2: Duitku QRIS */}
                                        <div className={`w-full rounded-lg border-2 transition-all ${paymentMethod === 'duitku_qris' ? 'bg-purple-50 border-purple-800' : 'bg-white border-gray-200'}`}>
                                            <button
                                                type="button"
                                                onClick={() => setPaymentMethod('duitku_qris')}
                                                className="w-full py-3 px-4 flex items-center justify-between"
                                            >
                                                <div className="flex items-center">
                                                    <QrCode className="w-6 h-6 mr-3 text-purple-800" />
                                                    <div className="text-left">
                                                        <p className="font-semibold text-gray-800">DP via Duitku QRIS</p>
                                                        <p className="text-xs text-gray-500">Scan QR Code untuk bayar DP</p>
                                                    </div>
                                                </div>
                                                {paymentMethod === 'duitku_qris' && <CheckCircleIcon className="w-6 h-6 text-purple-800" />}
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="grid grid-cols-1 gap-3">
                                        {/* [MODIFIKASI] Logika Semesta Pay: Hanya bisa diklik jika saldo cukup */}
                                        <div className={`w-full rounded-lg border-2 transition-all ${paymentMethod === 'semesta_pay' ? 'bg-green-50 border-green-800' : 'bg-white border-gray-200'}`}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (isBalanceSufficient) {
                                                        setPaymentMethod('semesta_pay');
                                                    }
                                                }}
                                                disabled={!isBalanceSufficient}
                                                className={`w-full py-3 px-4 flex items-center justify-between ${!isBalanceSufficient ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                            >
                                                <div className="flex items-center">
                                                    <WalletIcon className="w-6 h-6 mr-3 text-green-800" />
                                                    <div className="text-left">
                                                        <p className="font-semibold text-gray-800">Semesta Pay <span className="text-xs bg-green-200 text-green-800 px-2 py-0.5 rounded-full ml-2">Hemat 5%</span></p>
                                                        <p className={`text-xs ${!isBalanceSufficient ? 'text-red-500 font-bold' : 'text-gray-500'}`}>
                                                            Saldo: Rp {(user.balance || 0).toLocaleString('id-ID')}
                                                            {!isBalanceSufficient && " (Kurang)"}
                                                        </p>
                                                    </div>
                                                </div>
                                                {paymentMethod === 'semesta_pay' && <CheckCircleIcon className="w-6 h-6 text-green-800" />}
                                            </button>

                                            {/* [BARU] Opsi Top Up muncul jika saldo kurang */}
                                            {!isBalanceSufficient && (
                                                <div className="px-4 pb-3 pt-0">
                                                    <button
                                                        onClick={() => window.dispatchEvent(new CustomEvent('openTopUpModal'))}
                                                        className="w-full py-2 bg-green-100 text-green-800 text-sm font-bold rounded-lg hover:bg-green-200 transition-colors"
                                                    >
                                                        + Isi Saldo Dulu
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex space-x-3">
                                            <button
                                                type="button"
                                                onClick={() => setPaymentMethod('tunai')}
                                                className={`flex-1 py-3 rounded-lg border-2 font-semibold transition-colors ${paymentMethod === 'tunai' ? 'bg-green-800 text-white border-green-800' : 'bg-white text-green-800 border-gray-300'}`}
                                            >
                                                Tunai
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setPaymentMethod('duitku_qris')}
                                                className={`flex-1 py-3 rounded-lg border-2 font-semibold transition-colors ${paymentMethod === 'duitku_qris' ? 'bg-green-800 text-white border-green-800' : 'bg-white text-green-800 border-gray-300'}`}
                                            >
                                                QRIS
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>


                            {/* [BARU] Info untuk Duitku QRIS (redirect, bukan gambar statis) */}
                            {paymentMethod === 'duitku_qris' && (
                                <div className="mt-4 p-4 bg-purple-50 border border-purple-200 rounded-lg text-center">
                                    <p className="font-semibold text-purple-800">Pembayaran via Duitku QRIS</p>
                                    <p className="text-sm text-gray-600 mt-1">Klik "Pesan Sekarang" untuk diarahkan ke halaman pembayaran.</p>
                                </div>
                            )}


                            <div className="pt-6 mt-6 border-t-2 border-green-800 space-y-2">
                                <div className="flex justify-between text-gray-700"><p>Subtotal</p><p>Rp {subtotal.toLocaleString('id-ID')}</p></div>
                                <div className="flex justify-between text-gray-700"><p>Subtotal</p><p>Rp {subtotal.toLocaleString('id-ID')}</p></div>
                                {appliedVoucher && <div className="flex justify-between text-green-600"><p>Diskon Kupon ({appliedVoucher.discount}%)</p><p>- Rp {voucherDiscount.toLocaleString('id-ID')}</p></div>}
                                {/* [BARU] Tampilkan Diskon Referral */}
                                {isReferralEligible && <div className="flex justify-between text-blue-600"><p>Diskon Referral Teman (5%)</p><p>- Rp {referralDiscount.toLocaleString('id-ID')}</p></div>}
                                {paymentMethod === 'semesta_pay' && <div className="flex justify-between text-green-600"><p>Diskon Semesta Pay (5%)</p><p>- Rp {semestaPayDiscount.toLocaleString('id-ID')}</p></div>}
                                {/* [BARU] Menampilkan ongkir di ringkasan */}
                                {orderType === 'delivery' && (
                                    <div className="flex justify-between text-gray-700">
                                        <p>Ongkos Kirim</p>
                                        <p>Rp {deliveryFee.toLocaleString('id-ID')}</p>
                                    </div>
                                )}
                                <div className="flex justify-between font-bold text-lg text-green-900"><p>Total</p><p>Rp {total.toLocaleString('id-ID')}</p></div>
                                {/* [MODIFIKASI] Tombol order dinonaktifkan jika ada error ongkir */}
                                <button onClick={handleOrderClick} disabled={isProcessingOrder || !paymentMethod || (orderType === 'delivery' && !!deliveryError)} className="w-full mt-4 py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors flex justify-center items-center disabled:bg-gray-400">
                                    {isProcessingOrder ? <SemestaLogoSpinner style={{ width: '24px', height: '24px' }} /> : 'Proses Pesanan'}
                                </button>
                            </div>
                        </>
                    )}

                </>
            )
            }
        </div >
    );
};

// [MODIFIKASI PRIORITAS #3 - TAHAP 3.2b]
// Versi FINAL RiwayatScreen dengan Paginasi Penuh (Muat Awal + Muat Lagi)
const RiwayatScreen = ({ currentUser, showNotification, onOpenChat, setOrderSuccessData }) => {
    const [items, setItems] = useState([]); // Diganti dari 'orders' ke 'items' karena isinya campuran
    const [loading, setLoading] = useState(true);

    // State Paginasi (Hanya untuk Orders sementara ini)
    const [lastOrderVisible, setLastOrderVisible] = useState(null);
    const [hasMoreOrders, setHasMoreOrders] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const PAGE_SIZE = 15;

    useEffect(() => {
        if (!currentUser?.uid) return;

        const fetchInitialData = async () => {
            setLoading(true);
            setHasMoreOrders(true);
            setLastOrderVisible(null);

            try {
                // 1. Ambil Data Pesanan (Transactions)
                const ordersQuery = query(
                    transactionsCol,
                    where("customerId", "==", currentUser.uid),
                    orderBy("date", "desc"),
                    limit(PAGE_SIZE)
                );
                const ordersSnap = await getDocs(ordersQuery);
                const fetchedOrders = ordersSnap.docs.map(doc => ({
                    id: doc.id,
                    type: 'order', // Penanda tipe
                    ...doc.data()
                }));

                // Simpan cursor untuk paginasi orders
                const lastDoc = ordersSnap.docs[ordersSnap.docs.length - 1];
                setLastOrderVisible(lastDoc);
                setHasMoreOrders(ordersSnap.docs.length === PAGE_SIZE);

                // 2. Ambil Data Top Up (Topup Requests)
                // Kita ambil 20 transaksi terakhir saja untuk top up agar ringan
                const topUpsQuery = query(
                    collection(db, `${publicDataPath}/topup_requests`),
                    where("userId", "==", currentUser.uid),
                    orderBy("createdAt", "desc"),
                    limit(20)
                );
                const topUpsSnap = await getDocs(topUpsQuery);
                const fetchedTopUps = topUpsSnap.docs.map(doc => ({
                    id: doc.id,
                    type: 'topup', // Penanda tipe
                    date: doc.data().createdAt, // Normalisasi field tanggal agar sama dengan order
                    ...doc.data()
                }));

                // 3. Gabungkan dan Urutkan
                const combinedItems = [...fetchedOrders, ...fetchedTopUps].sort((a, b) => {
                    const dateA = a.date?.seconds || 0;
                    const dateB = b.date?.seconds || 0;
                    return dateB - dateA; // Descending (Terbaru di atas)
                });

                setItems(combinedItems);

            } catch (error) {
                console.error("Gagal mengambil riwayat:", error);
                showNotification('Gagal memuat riwayat.', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, [currentUser?.uid, showNotification]);

    // Fungsi Load More (Khusus Orders)
    const fetchMoreOrders = async () => {
        if (!currentUser?.uid || !hasMoreOrders || isLoadingMore || !lastOrderVisible) return;

        setIsLoadingMore(true);
        try {
            const q = query(
                transactionsCol,
                where("customerId", "==", currentUser.uid),
                orderBy("date", "desc"),
                limit(PAGE_SIZE),
                startAfter(lastOrderVisible)
            );

            const snapshot = await getDocs(q);
            const newOrders = snapshot.docs.map(doc => ({
                id: doc.id,
                type: 'order',
                ...doc.data()
            }));

            // Update state paginasi
            const lastDoc = snapshot.docs[snapshot.docs.length - 1];
            setLastOrderVisible(lastDoc);
            setHasMoreOrders(snapshot.docs.length === PAGE_SIZE);

            // Gabungkan dengan item yang sudah ada, lalu urutkan ulang (opsional, tapi aman)
            setItems(prevItems => {
                const updated = [...prevItems, ...newOrders].sort((a, b) => {
                    const dateA = a.date?.seconds || 0;
                    const dateB = b.date?.seconds || 0;
                    return dateB - dateA;
                });
                return updated;
            });

        } catch (error) {
            console.error("Gagal load more:", error);
            showNotification('Gagal memuat data tambahan.', 'error');
        } finally {
            setIsLoadingMore(false);
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'baru': return <span className="text-xs font-semibold px-2 py-1 bg-yellow-200 text-yellow-800 rounded-full">Menunggu</span>;
            case 'menunggu_pembayaran': return <span className="text-xs font-semibold px-2 py-1 bg-purple-200 text-purple-800 rounded-full">Belum Bayar</span>;
            case 'pending_payment': return <span className="text-xs font-semibold px-2 py-1 bg-purple-200 text-purple-800 rounded-full">Belum Bayar</span>;
            case 'paid': return <span className="text-xs font-semibold px-2 py-1 bg-green-200 text-green-800 rounded-full">Lunas</span>;
            case 'redeemed': return <span className="text-xs font-semibold px-2 py-1 bg-green-200 text-green-800 rounded-full">Sudah Ditukar</span>;
            case 'expired': return <span className="text-xs font-semibold px-2 py-1 bg-gray-200 text-gray-600 rounded-full">Hangus/Kedaluwarsa</span>;
            case 'diproses': return <span className="text-xs font-semibold px-2 py-1 bg-blue-200 text-blue-800 rounded-full">Diproses</span>;
            case 'selesai': return <span className="text-xs font-semibold px-2 py-1 bg-green-200 text-green-800 rounded-full">Selesai</span>;
            case 'dibatalkan': return <span className="text-xs font-semibold px-2 py-1 bg-red-200 text-red-800 rounded-full">Dibatalkan</span>;
            // Status Top Up
            case 'pending': return <span className="text-xs font-semibold px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full">Belum Bayar</span>;
            case 'approved': return <span className="text-xs font-semibold px-2 py-1 bg-green-100 text-green-800 rounded-full">Berhasil</span>;
            case 'rejected': return <span className="text-xs font-semibold px-2 py-1 bg-red-100 text-red-800 rounded-full">Gagal</span>;
            default: return <span className="text-xs font-semibold px-2 py-1 bg-gray-200 text-gray-800 rounded-full">{status}</span>;
        }
    };

    if (loading) return <div className="flex items-center justify-center h-full"><SemestaLogoSpinner /></div>;

    return (
        <div className="p-4 md:p-6">
            <h1 className="text-3xl font-bold text-green-900 mb-6">Riwayat Aktivitas</h1>

            {/* [BARU] Banner Konversi untuk Tamu */}
            {currentUser?.isAnonymous && (
                <div className="mb-6 bg-gradient-to-r from-blue-600 to-indigo-600 p-5 rounded-2xl text-white shadow-lg relative overflow-hidden animate-fadeIn">
                    <div className="relative z-10">
                        <h3 className="font-bold text-lg leading-tight">Simpan Riwayat Anda! 🔐</h3>
                        <p className="text-sm opacity-90 mt-1">Buat akun agar riwayat pesanan aman & klaim **Voucher 25%**.</p>
                        <button
                            onClick={() => window.dispatchEvent(new CustomEvent('trigger-login'))}
                            className="mt-3 px-4 py-2 bg-white text-blue-600 font-bold rounded-lg text-sm shadow-sm active:scale-95 transition-transform"
                        >
                            Daftar Sekarang
                        </button>
                    </div>
                    <div className="absolute -right-4 -bottom-4 opacity-20 transform rotate-12">
                        <svg className="w-24 h-24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 15.5l-3.5 2 1-4.5L6 9.5l4.5-.5L12 5l1.5 4 4.5.5-3.5 3.5 1 4.5z" /></svg>
                    </div>
                </div>
            )}
            {items.length === 0 ? (
                <p className="text-center text-gray-500 mt-10">Belum ada aktivitas.</p>
            ) : (
                <div className="space-y-4">
                    {items.map(item => (
                        <div key={item.id} className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">

                            {/* TAMPILAN ITEM BERDASARKAN TIPE */}
                            {item.type === 'topup' ? (
                                // --- TAMPILAN TOP UP ---
                                <div>
                                    <div className="flex justify-between items-start mb-2">
                                        <div className="flex items-center">
                                            <div className="p-2 bg-blue-50 rounded-full mr-3 text-blue-600">
                                                <TopUpIcon className="w-5 h-5" />
                                            </div>
                                            <div>
                                                <p className="font-bold text-gray-800">Isi Saldo Semesta Pay</p>
                                                <p className="text-xs text-gray-500">
                                                    {item.date ? new Date(item.date.seconds * 1000).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'}
                                                </p>
                                            </div>
                                        </div>
                                        {getStatusBadge(item.status)}
                                    </div>
                                    <div className="flex justify-between items-center mt-2 pl-12">
                                        <p className="text-sm text-gray-600">Metode: {item.paymentMethod || 'Lynk.id'}</p>
                                        <p className="font-bold text-lg text-blue-800">+ Rp {(item.amount || 0).toLocaleString('id-ID')}</p>
                                    </div>
                                    {item.status === 'pending' && item.paymentLink && (
                                        <div className="mt-3 pl-12">
                                            <a href={item.paymentLink} target="_blank" rel="noreferrer" className="text-sm bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700">
                                                Lanjut Bayar
                                            </a>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                // --- TAMPILAN ORDER (PESANAN) ---
                                <div>
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-sm text-gray-500">Order ID: <span className="font-mono">{item.id.substring(0, 8)}...</span></p>
                                            <p className="text-sm text-gray-500">
                                                {item.date ? new Date(item.date.seconds * 1000).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) : '-'}
                                            </p>
                                            {/* [BARU] Bukber Badge & Info */}
                                            {(item.type === 'booking' || item.isBukber) && (
                                                <div className="flex flex-wrap items-center gap-1 mt-1">
                                                    <span className="inline-flex items-center gap-1 bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded-full font-bold border border-purple-200">
                                                        🕌 BUKBER
                                                    </span>                                                    {item.dpOption && (
                                                        <span className={`text-xs px-2 py-0.5 rounded-full font-bold border ${item.dpOption === 'lunas'
                                                            ? 'bg-green-100 text-green-800 border-green-200'
                                                            : 'bg-yellow-100 text-yellow-800 border-yellow-200'
                                                            }`}>
                                                            {item.dpOption === 'lunas' ? '✓ LUNAS' : 'DP 30%'}
                                                        </span>
                                                    )}
                                                    {item.bookingDate && (
                                                        <span className="text-xs text-purple-600 font-semibold">
                                                            📅 {item.bookingDate} {item.bookingTime}
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                            {/* [BARU] Promo Weekend 10rb Badge (Fase 2) */}
                                            {item.type === 'promo_booking' && (
                                                <div className="flex flex-wrap items-center gap-1 mt-1">
                                                    <span className="inline-flex items-center gap-1 bg-orange-100 text-orange-800 text-xs px-2 py-0.5 rounded-full font-bold border border-orange-200">
                                                        🔥 PROMO 10RB
                                                    </span>
                                                    {item.promoSlotId && (
                                                        <span className="text-xs text-orange-700 font-semibold">
                                                            📅 {item.promoSlotId} • {item.pax || 1} orang
                                                        </span>
                                                    )}
                                                    {item.kodeBooking && (
                                                        <span className="text-xs font-mono bg-gray-100 px-2 py-0.5 rounded">
                                                            {item.kodeBooking}
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        {getStatusBadge(item.status)}
                                    </div>
                                    <div className="border-t my-2 border-gray-100"></div>
                                    <div className="space-y-1 text-sm mb-3">
                                        {item.items && item.items.map((subItem, idx) => (
                                            <div key={idx} className="flex justify-between">
                                                <p>{subItem.name} <span className="text-gray-500">x{subItem.quantity}</span></p>
                                                <p>Rp {((subItem.price || subItem.packagePrice || 0) * subItem.quantity).toLocaleString('id-ID')}</p>
                                            </div>
                                        ))}
                                    </div>
                                    {/* [BARU] DP Info untuk Bukber */}
                                    {item.dpAmount > 0 && (
                                        <div className="bg-purple-50 rounded-lg p-2 mb-2 text-sm">
                                            <div className="flex justify-between">
                                                <span className="text-purple-700">DP Dibayar:</span>
                                                <span className="font-bold text-green-700">Rp {item.dpAmount.toLocaleString('id-ID')}</span>
                                            </div>
                                            {item.sisaPembayaran > 0 && (
                                                <div className="flex justify-between">
                                                    <span className="text-purple-700">Sisa:</span>
                                                    <span className="font-bold text-red-600">Rp {item.sisaPembayaran.toLocaleString('id-ID')}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className="border-t my-2 pt-2 flex justify-between items-center border-gray-100">
                                        <div>
                                            <p className="font-bold text-green-900">Total: Rp {(item.total || item.amount || 0).toLocaleString('id-ID')}</p>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            {(item.status === 'menunggu_pembayaran' || item.status === 'pending_payment') && (item.paymentUrl || item.qrString) && (
                                                <button
                                                    onClick={() => {
                                                        if (item.qrString) {
                                                            setOrderSuccessData({
                                                                orderId: item.id,
                                                                qrString: item.qrString,
                                                                totalAmount: item.total
                                                            });
                                                        } else if (item.paymentUrl) {
                                                            window.open(item.paymentUrl, '_blank');
                                                        }
                                                    }}
                                                    className="px-3 py-1 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 transition-colors font-bold"
                                                >
                                                    Bayar
                                                </button>
                                            )}
                                            {(item.type === 'booking' || item.isBukber) && (
                                                <ShareBookingButton bookingId={item.id} customerName={item.customerName || "Pelanggan"} />
                                            )}
                                            <button
                                                onClick={() => onOpenChat(item)}
                                                className="px-3 py-1 bg-gray-800 text-white text-sm rounded-lg hover:bg-black transition-colors flex items-center gap-1"
                                            >
                                                <MessageSquareIcon className="w-4 h-4" /> Chat
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    ))}

                    {/* Tombol Load More (Hanya muncul jika ada lebih banyak ORDER) */}
                    {hasMoreOrders && (
                        <div className="mt-6 text-center">
                            {isLoadingMore ? (
                                <SemestaLogoSpinner style={{ width: '30px', height: '30px', margin: 'auto' }} />
                            ) : (
                                <button
                                    onClick={fetchMoreOrders}
                                    className="text-sm text-gray-500 hover:text-green-800 font-semibold"
                                >
                                    Muat Pesanan Lama...
                                </button>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// --- [MODIFIKASI] START: Komponen Halaman Promo ---
const PromoScreen = ({ user, dailyQuiz, onQuizSubmit, showNotification, specialPromos, onPromoClick }) => {
    const [answeredToday, setAnsweredToday] = useState(false);
    const [dailyToken, setDailyToken] = useState(null);
    const [loadingToken, setLoadingToken] = useState(false);

    const handleGetDailyToken = async () => {
        setLoadingToken(true);
        try {
            const getDailyClaimToken = httpsCallable(functions, 'getDailyClaimToken');
            const result = await getDailyClaimToken();
            setDailyToken(result.data.token);
        } catch (error) {
            console.error("Daily Token Error:", error);
            showNotification(`Gagal mengambil token: ${error.message}`, 'error');
        } finally {
            setLoadingToken(false);
        }
    };

    useEffect(() => {
        if (!user) return;
        const lastAnswered = user.lastQuizAnswered?.toDate();
        if (lastAnswered) {
            const today = new Date();
            if (lastAnswered.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
                setAnsweredToday(true);
            }
        }
    }, [user]);

    const handleCopyCode = (code) => {
        const el = document.createElement('textarea');
        el.value = code;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        showNotification(`Kupon ${code} telah disalin!`, 'success');
    };

    if (!user) return <div className="p-4 text-center">Memuat data pengguna...</div>;

    // [BARU] Logika untuk progres bar scan loyalitas
    const scanCount = user.scanTransactionCount || 0;
    const progressToNextVoucher = (scanCount % 5);
    const progressPercentage = (progressToNextVoucher / 5) * 100;

    return (
        <div className="p-4 md:p-6">
            <h1 className="text-3xl font-bold text-green-900 mb-6">Promo & Member</h1>

            {/* [BARU] Entry Promo Weekend 10rb (Fase 2) */}
            <button
                onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: 'PromoWeekend' }))}
                className="w-full mb-6 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 text-white shadow-md text-left"
            >
                <p className="font-bold text-lg">🔥 Promo Weekend 10rb — Cek Kuota Live</p>
                <p className="text-sm opacity-90">Sabtu & Minggu • 08–11 & 19–21 • Max 2/sesi • Bayar QRIS depan</p>
            </button>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <h2 className="text-xl font-bold mb-4">Promo Spesial Untukmu!</h2>
                {specialPromos.length > 0 ? (
                    <div className="space-y-4">
                        {specialPromos.map(promo => (
                            <div key={promo.id} onClick={() => onPromoClick(promo)} className="cursor-pointer group">
                                <img src={promo.imageUrl || 'https://placehold.co/600x300/e2e8f0/64748b?text=Promo'} alt={promo.title} className="w-full h-32 object-cover rounded-lg shadow-lg transition-transform group-hover:scale-105" />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-gray-500">Saat ini belum ada promo spesial.</p>
                )}
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6 text-center">
                <h2 className="text-xl font-bold mb-2">Kode Member Anda</h2>
                <p className="mb-4 text-gray-600">Tunjukkan kode ini ke kasir untuk scan member & klaim brownies!</p>

                {/* [BARU] Status Free Brownies */}
                {(user.browniesExpiry && user.browniesExpiry.toDate() > new Date()) || (user.balance >= 100000) ? (
                    <div className="mb-4 bg-yellow-50 border border-yellow-200 p-3 rounded-lg inline-block">
                        <p className="text-yellow-800 font-bold text-sm">🎉 Status Free Brownies: AKTIF</p>
                        <p className="text-yellow-600 text-xs">
                            {user.balance >= 100000
                                ? "Aktif karena saldo Anda > Rp 100.000"
                                : `Berlaku sampai: ${user.browniesExpiry.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}`
                            }
                        </p>
                    </div>
                ) : (
                    <div className="mb-4 bg-gray-50 border border-gray-200 p-3 rounded-lg inline-block">
                        <p className="text-gray-500 font-bold text-sm">Status Free Brownies: TIDAK AKTIF</p>
                        <p className="text-gray-400 text-xs">Top up min. Rp 100.000 atau miliki saldo &gt; Rp 100.000 untuk aktifkan.</p>
                    </div>
                )}

                <div className="flex justify-center">
                    <img
                        src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${user.uid}`}
                        alt="QR Code Member"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://placehold.co/200x200/e2e8f0/64748b?text=QR+Error';
                        }}
                    />
                </div>
                <p className="mt-4 font-mono bg-gray-100 p-2 rounded">{user.uid}</p>

                {/* [MODIFIKASI] Tampilan progres scan loyalitas */}
                <div className="mt-6 border-t pt-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Progres Loyalitas Scan</h3>
                    <p className="text-sm text-gray-500 mb-3">Dapatkan diskon 50% setiap 5 kali scan transaksi!</p>
                    <div className="w-full bg-gray-200 rounded-full h-4">
                        <div
                            className="bg-green-600 h-4 rounded-full transition-all duration-500"
                            style={{ width: `${progressPercentage}%` }}
                        ></div>
                    </div>
                    <p className="mt-2 font-bold text-lg">{progressToNextVoucher} / 5</p>
                    <p className="text-xs text-gray-500">Total Scan: {scanCount}</p>
                </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <h2 className="text-xl font-bold mb-2">Kuis Harian</h2>
                <p className="text-sm text-gray-500 mb-4 text-center">Jawab benar 5 pertanyaan Kuis untuk dapat diskon 10%!</p>
                {answeredToday ? (
                    <p className="text-center text-gray-600">Anda sudah menjawab kuis hari ini. Coba lagi besok!</p>
                ) : dailyQuiz ? (
                    <QuizComponent quiz={dailyQuiz} onSubmit={onQuizSubmit} />
                ) : (
                    <p className="text-center text-gray-500">Kuis harian belum tersedia.</p>
                )}
                <p className="mt-4 text-center text-sm text-gray-500">Jawaban Benar Beruntun: <span className="font-bold">{user.quizCorrectAnswers || 0}</span> / 5</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-bold mb-2">Voucher Anda</h2>
                {user.vouchers && user.vouchers.filter(v => !v.used && v.code).length > 0 ? (
                    <div className="space-y-2">
                        {user.vouchers.filter(v => !v.used && v.code).map(voucher => (
                            <div key={voucher.id} className={`p-3 border-l-4 rounded ${voucher.type === 'Loyalitas 5 Transaksi Scan' ? 'bg-yellow-100 border-yellow-500' : 'bg-green-100 border-green-500'}`}>
                                <p className="font-bold">Diskon {voucher.discount}%</p>
                                <p className="text-sm">Didapat dari: {voucher.type}</p>
                                <div className="mt-2 flex items-center justify-between bg-white p-2 rounded">
                                    <span className="font-mono text-green-800">{voucher.code}</span>
                                    <button onClick={() => handleCopyCode(voucher.code)} className="text-sm font-semibold">Salin</button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-gray-500">Anda belum memiliki voucher aktif.</p>
                )}
            </div>
        </div>
    );
};
// --- [MODIFIKASI] END: Komponen Halaman Promo ---


// [BARU] NearbyScreen Component
// Menampilkan daftar mitra terdekat
const NearbyScreen = ({ currentUser, userLocation: propUserLocation, showNotification }) => {
    const [rawPartners, setRawPartners] = useState([]); // Data mentah dari DB (Fetch sekali)
    const [loading, setLoading] = useState(true);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [showMap, setShowMap] = useState(false); // [NEW] Toggle list/map view
    const [localUserLocation, setLocalUserLocation] = useState(null); // [NEW] Local geolocation
    const [isLocating, setIsLocating] = useState(false); // [NEW] Loading state for geolocation

    // Use prop or local location
    const userLocation = propUserLocation || localUserLocation;

    // [NEW] Robust 3-tier fallback geolocation function
    const handleGetLocation = async () => {
        setIsLocating(true);
        showNotification("Mencari lokasi... Pastikan GPS aktif.", "info");

        // Helper function for getting location with specific options
        const getLocationWithOptions = async (options) => {
            const position = await Geolocation.getCurrentPosition(options);
            return {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accuracy: position.coords.accuracy
            };
        };

        try {
            let coords;

            // TIER 1: High Accuracy GPS (satellite priority)
            try {
                showNotification("🛰️ Mencari sinyal GPS akurat...", "info");
                coords = await getLocationWithOptions({
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                });
                showNotification(`✓ GPS berhasil! Akurasi: ${coords.accuracy?.toFixed(0) || '?'}m`, "success");
            } catch (gpsError) {
                console.warn("Tier 1 (GPS) failed:", gpsError);

                // TIER 2: Network/WiFi based location
                try {
                    showNotification("📶 Sinyal GPS lemah, mencoba via WiFi/jaringan...", "info");
                    coords = await getLocationWithOptions({
                        enableHighAccuracy: false,
                        timeout: 20000,
                        maximumAge: 0
                    });
                    showNotification(`✓ Lokasi via jaringan berhasil! Akurasi: ${coords.accuracy?.toFixed(0) || '?'}m`, "success");
                } catch (networkError) {
                    console.warn("Tier 2 (Network) failed:", networkError);

                    // TIER 3: Cached location (last known)
                    try {
                        showNotification("📍 Menggunakan lokasi terakhir yang diketahui...", "warning");
                        coords = await getLocationWithOptions({
                            enableHighAccuracy: false,
                            timeout: 5000,
                            maximumAge: Infinity // Accept any cached location
                        });
                        showNotification(`⚠️ Menggunakan lokasi cache. Akurasi mungkin rendah.`, "warning");
                    } catch (cacheError) {
                        console.error("All geolocation tiers failed:", cacheError);
                        throw new Error("Semua metode lokasi gagal");
                    }
                }
            }

            // Success - update location
            setLocalUserLocation({ latitude: coords.latitude, longitude: coords.longitude });
            showNotification("📍 Jarak ke mitra berhasil dihitung!", "success");

        } catch (error) {
            console.error("Geolocation completely failed:", error);
            let errorMsg = "Gagal mendapatkan lokasi.";

            if (error.code === 1) {
                errorMsg = "Izin lokasi ditolak. Klik ikon 🔒 di address bar untuk mengizinkan.";
            } else if (error.code === 2) {
                errorMsg = "Lokasi tidak tersedia. Pastikan GPS dan WiFi aktif.";
            } else if (error.code === 3) {
                errorMsg = "Waktu habis. Coba di tempat terbuka atau aktifkan GPS.";
            }

            showNotification(errorMsg, "error");
        } finally {
            setIsLocating(false);
        }
    };

    // Helper untuk hitung jarak (jika userLocation tidak tersedia/akurat)
    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // Radius bumi km
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    // 1. Fetch data mitra HANYA SEKALI saat mount
    useEffect(() => {
        const fetchPartners = async () => {
            setLoading(true);
            try {
                const q = query(partnersCol, where("isActive", "==", true));
                const snapshot = await getDocs(q);
                const fetchedPartners = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setRawPartners(fetchedPartners);
            } catch (error) {
                console.error("Error fetching partners:", error);
                showNotification("Gagal memuat data mitra.", "error");
            } finally {
                setLoading(false);
            }
        };

        fetchPartners();
    }, []); // Empty dependency array = mount only

    // 2. Kalkulasi Jarak & Sorting setiap kali userLocation atau rawPartners berubah
    // Dilakukan saat render (atau bisa pakai useMemo) agar tidak trigger re-render / loading spinner
    const processedPartners = React.useMemo(() => {
        let partners = [...rawPartners];

        if (userLocation) {
            partners = partners.map(p => {
                if (p.location) {
                    const dist = calculateDistance(
                        userLocation.latitude,
                        userLocation.longitude,
                        p.location.latitude,
                        p.location.longitude
                    );
                    return { ...p, distance: dist };
                }
                return { ...p, distance: null };
            });

            // Urutkan berdasarkan jarak terdekat
            partners.sort((a, b) => {
                if (a.distance === null) return 1;
                if (b.distance === null) return -1;
                return a.distance - b.distance;
            });
        }
        return partners;
    }, [rawPartners, userLocation]);


    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-center p-4">
                <SemestaLogoSpinner />
                <p className="mt-4 font-semibold text-lg text-green-800">
                    Mencari Mitra Nearby...
                </p>
            </div>
        );
    }

    // [NEW] Convert partners to map markers
    const mapMarkers = processedPartners
        .filter(p => p.location)
        .map(p => ({
            id: p.id,
            lat: p.location.latitude,
            lng: p.location.longitude,
            name: p.name,
            info: p.distance !== null && p.distance !== undefined
                ? `📍 ${p.distance.toFixed(2)} km • ${p.address}`
                : p.address,
        }));

    return (
        <div className="p-4 md:p-6 bg-gray-50 min-h-full">
            {/* Header with Toggle */}
            <div className="flex items-center justify-between mb-2">
                <div className="flex-1"></div>
                <h1 className="text-3xl font-bold text-green-900 text-center">Nearby</h1>
                <div className="flex-1 flex justify-end">
                    <button
                        onClick={() => setShowMap(!showMap)}
                        className={`p-2 rounded-lg transition-colors ${showMap ? 'bg-green-700 text-white' : 'bg-white text-green-700 border border-green-700'}`}
                        title={showMap ? 'Tampilkan List' : 'Tampilkan Peta'}
                    >
                        {showMap ? (
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" /></svg>
                        )}
                    </button>
                </div>
            </div>
            <p className="text-center text-gray-500 mb-4">Temukan Mitra Kopi Semesta di Sekitarmu</p>

            {/* [NEW] Location status and button */}
            {!userLocation && (
                <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-xl text-center">
                    <p className="text-sm text-blue-800 mb-3">Aktifkan lokasi untuk melihat jarak ke mitra</p>
                    <button
                        onClick={handleGetLocation}
                        disabled={isLocating}
                        className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 flex items-center justify-center mx-auto gap-2"
                    >
                        {isLocating ? (
                            <SemestaLogoSpinner style={{ width: '20px', height: '20px' }} />
                        ) : (
                            <>
                                <MapPinIcon className="w-4 h-4" />
                                Cari Lokasi Saya
                            </>
                        )}
                    </button>
                </div>
            )}
            {userLocation && (
                <div className="mb-4 text-center text-xs text-green-600 font-medium">
                    ✓ Lokasi aktif - Jarak mitra ditampilkan
                </div>
            )}

            {processedPartners.length === 0 ? (
                <div className="text-center text-gray-500 mt-10">
                    <p>Belum ada mitra yang tersedia saat ini.</p>
                </div>
            ) : showMap ? (
                /* [NEW] Map View */
                <div className="rounded-xl overflow-hidden shadow-lg">
                    <LeafletMap
                        markers={mapMarkers}
                        userLocation={userLocation}
                        height="400px"
                        zoom={12}
                        onMarkerClick={(marker) => {
                            const partner = processedPartners.find(p => p.id === marker.id);
                            if (partner) setSelectedPartner(partner);
                        }}
                    />
                    <div className="bg-white p-3 text-center text-sm text-gray-600">
                        Ketuk marker untuk melihat detail mitra
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-4">
                    {processedPartners.map(partner => (
                        <div key={partner.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
                            <div className="relative h-48">
                                <img
                                    src={partner.image || 'https://placehold.co/600x400?text=Mitra+Semesta'}
                                    alt={partner.name}
                                    className="w-full h-full object-cover"
                                />
                                {partner.distance !== undefined && partner.distance !== null && (
                                    <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg text-xs font-bold shadow-sm text-green-800 flex items-center gap-1">
                                        <MapPinIcon className="w-3 h-3" />
                                        {partner.distance.toFixed(2)} km
                                    </div>
                                )}
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-lg text-gray-900 mb-1">{partner.name}</h3>
                                <p className="text-sm text-gray-600 mb-3 line-clamp-2">{partner.address}</p>

                                <div className="flex items-center justify-between mt-4">
                                    <div className="text-xs text-gray-500">
                                        {partner.stock && partner.stock.length > 0 ? (
                                            <span>Tersedia {partner.stock.length} Produk</span>
                                        ) : (
                                            <span className="text-red-500">Stok Habis</span>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => setSelectedPartner(partner)}
                                        className="px-4 py-2 bg-green-700 text-white text-sm font-semibold rounded-lg hover:bg-green-800 transition-colors"
                                    >
                                        Lihat Stok
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal Detail Mitra & Stok */}
            {selectedPartner && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4" onClick={() => setSelectedPartner(null)}>
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                        <div className="relative h-48">
                            <img
                                src={selectedPartner.image || 'https://placehold.co/600x400?text=Mitra+Semesta'}
                                alt={selectedPartner.name}
                                className="w-full h-full object-cover"
                            />
                            <button
                                onClick={() => setSelectedPartner(null)}
                                className="absolute top-2 right-2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-gray-900 mb-2">{selectedPartner.name}</h2>
                            <p className="text-gray-600 text-sm mb-4">{selectedPartner.address}</p>

                            {/* Tombol Arahkan via Maps */}
                            {selectedPartner.location && (
                                <a
                                    href={`https://www.google.com/maps/dir/?api=1&destination=${selectedPartner.location.latitude},${selectedPartner.location.longitude}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full text-center py-2 mb-6 bg-blue-50 text-blue-700 font-semibold rounded-lg hover:bg-blue-100 transition-colors"
                                >
                                    📍 Arahkan via Google Maps
                                </a>
                            )}

                            <h3 className="font-bold text-gray-800 mb-3 border-b pb-2">Stok Tersedia</h3>
                            {selectedPartner.stock && selectedPartner.stock.length > 0 ? (
                                <div className="space-y-3">
                                    {selectedPartner.stock.filter(item => Number(item.stock) > 0).map((item, idx) => (
                                        <div key={idx} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                                            <div>
                                                <p className="font-semibold text-gray-900">{item.name}</p>
                                                <p className="text-xs text-gray-500">Stok: {item.stock}</p>
                                            </div>
                                            <p className="font-bold text-green-700">Rp {Number(item.price).toLocaleString('id-ID')}</p>
                                        </div>
                                    ))}
                                    {selectedPartner.stock.filter(item => Number(item.stock) > 0).length === 0 && (
                                        <p className="text-center text-gray-500 text-sm py-2">Stok habis semua.</p>
                                    )}
                                </div>
                            ) : (
                                <p className="text-center text-gray-500 text-sm py-2">Belum ada data stok.</p>
                            )}

                            <div className="mt-6 bg-yellow-50 p-3 rounded-lg text-xs text-yellow-800">
                                ℹ️ Hubungi mitra atau datang langsung untuk membeli produk ini.
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const QuizComponent = ({ quiz, onSubmit }) => {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedOption !== null) {
            onSubmit(quiz, selectedOption);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <p className="font-semibold mb-3">{quiz.question}</p>
            <div className="space-y-2 mb-4">
                {quiz.options.map((option, index) => (
                    <label key={index} className="flex items-center p-2 border rounded-lg cursor-pointer">
                        <input type="radio" name="quizOption" value={index} checked={selectedOption === index} onChange={() => setSelectedOption(index)} className="mr-3" />
                        {option}
                    </label>
                ))}
            </div>
            <button type="submit" disabled={selectedOption === null} className="w-full py-2 bg-green-800 text-white rounded-lg disabled:bg-gray-400">Jawab</button>
        </form>
    );
};

const StarRating = ({ rating, setRating }) => {
    return (
        <div className="flex space-x-1">
            {[3, 4, 5].map((star) => (
                <button key={star} type="button" onClick={() => setRating(star)} className="focus:outline-none">
                    <StarIcon filled={star <= rating} className={`w-8 h-8 ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`} />
                </button>
            ))}
        </div>
    );
};

const SaranScreen = ({ user, showNotification }) => {
    const [ratings, setRatings] = useState({ rasa: 3, harga: 3, pelayanan: 3 });
    const [review, setReview] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await addDoc(saranCol, {
                userId: user.uid,
                userName: user.name,
                ratings,
                review,
                createdAt: Timestamp.now(),
            });
            showNotification('Terima kasih atas saran Anda!', 'success');
            setRatings({ rasa: 3, harga: 3, pelayanan: 3 });
            setReview('');
        } catch (error) {
            showNotification(`Gagal mengirim saran: ${error.message}`, 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="p-4 md:p-6">
            <h1 className="text-3xl font-bold text-green-900 mb-2">Beri Kami Saran</h1>
            <p className="text-gray-600 mb-6">Masukan Anda sangat berarti untuk kami.</p>
            <form onSubmit={handleSubmit} className="space-y-6 bg-white p-6 rounded-lg shadow-md">
                <div className="flex justify-between items-center">
                    <label className="font-semibold">Rasa</label>
                    <StarRating rating={ratings.rasa} setRating={(r) => setRatings(p => ({ ...p, rasa: r }))} />
                </div>
                <div className="flex justify-between items-center">
                    <label className="font-semibold">Harga</label>
                    <StarRating rating={ratings.harga} setRating={(r) => setRatings(p => ({ ...p, harga: r }))} />
                </div>
                <div className="flex justify-between items-center">
                    <label className="font-semibold">Pelayanan</label>
                    <StarRating rating={ratings.pelayanan} setRating={(r) => setRatings(p => ({ ...p, pelayanan: r }))} />
                </div>
                <div>
                    <label className="font-semibold block mb-2">Review / Saran Anda</label>
                    <textarea value={review} onChange={(e) => setReview(e.target.value)} required className="w-full p-2 border rounded-lg h-32" placeholder="Tulis masukan Anda di sini..."></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors disabled:bg-gray-400">
                    {isSubmitting ? 'Mengirim...' : 'Kirim Saran'}
                </button>
            </form>
        </div>
    );
};

const FokusScreen = ({ setIsFokusModeActive }) => {
    const [durations, setDurations] = useState({ fokus: 25, short: 5, long: 15 });
    const [mode, setMode] = useState('fokus');
    const [time, setTime] = useState(durations.fokus * 60);
    const [isActive, setIsActive] = useState(false);
    const [notificationPermission, setNotificationPermission] = useState(Notification.permission);
    const [isSoundEnabled, setIsSoundEnabled] = useState(true);
    const timerRef = useRef(null);
    const audioRef = useRef(null);
    const [isAlarmPlaying, setIsAlarmPlaying] = useState(false);
    const wakeLockRef = useRef(null);

    const modes = {
        fokus: { label: 'Fokus' },
        short: { label: 'Istirahat Pendek' },
        long: { label: 'Istirahat Panjang' },
    };

    const acquireWakeLock = async () => {
        if ('wakeLock' in navigator) {
            try {
                wakeLockRef.current = await navigator.wakeLock.request('screen');
                console.log('Wake Lock diaktifkan!');
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        }
    };

    const releaseWakeLock = () => {
        if (wakeLockRef.current) {
            wakeLockRef.current.release().then(() => {
                wakeLockRef.current = null;
                console.log('Wake Lock dilepaskan.');
            });
        }
    };

    const playAlarm = () => {
        if (!isSoundEnabled) return;
        if (!audioRef.current) {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            oscillator.loop = true;
            audioRef.current = { oscillator, audioContext };
        }
        audioRef.current.oscillator.start();
        setIsAlarmPlaying(true);
    };

    const stopAlarm = () => {
        if (audioRef.current && isAlarmPlaying) {
            audioRef.current.oscillator.stop();
            audioRef.current = null;
            setIsAlarmPlaying(false);
        }
    };

    const showTimerNotification = (message) => {
        if (notificationPermission === 'granted') {
            new Notification('Waktu Habis!', { body: message, tag: 'pomodoro-timer' });
        }
    };

    useEffect(() => {
        if (isActive) {
            setIsFokusModeActive(true);
            acquireWakeLock();
            timerRef.current = setInterval(() => {
                setTime(prev => prev - 1);
            }, 1000);
        } else {
            setIsFokusModeActive(false);
            releaseWakeLock();
            clearInterval(timerRef.current);
        }
        return () => {
            clearInterval(timerRef.current);
            releaseWakeLock();
        };
    }, [isActive, setIsFokusModeActive]);

    useEffect(() => {
        if (time <= 0) {
            playAlarm();
            showTimerNotification(`Sesi ${modes[mode].label} telah selesai.`);
            // [ANALYTICS] Track Fokus Timer Completion
            logEvent('fokus_timer_complete', {
                mode: mode,
                duration_minutes: durations[mode]
            });
            setIsActive(false);
        }
    }, [time]);

    const requestNotificationPermission = () => {
        if ('Notification' in window && Notification.permission !== 'granted') {
            Notification.requestPermission().then(permission => {
                setNotificationPermission(permission);
            });
        }
    };

    const toggleTimer = () => {
        stopAlarm();
        if (!isActive) {
            // [ANALYTICS] Track Fokus Timer Start
            logEvent('fokus_timer_start', {
                mode: mode,
                duration_minutes: durations[mode]
            });
        }
        setIsActive(!isActive);
    };

    const resetTimer = () => {
        stopAlarm();
        setIsActive(false);
        setTime(durations[mode] * 60);
    };

    const switchMode = (newMode) => {
        stopAlarm();
        setMode(newMode);
        setTime(durations[newMode] * 60);
        setIsActive(false);
    };

    const handleDurationChange = (modeKey, amount) => {
        stopAlarm();
        setDurations(prev => {
            const newTime = Math.max(1, prev[modeKey] + amount);
            const newDurations = { ...prev, [modeKey]: newTime };
            if (mode === modeKey) {
                setTime(newTime * 60);
                setIsActive(false);
            }
            return newDurations;
        });
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    return (
        <div className="p-4 md:p-6 flex flex-col items-center justify-center h-full">
            <h1 className="text-3xl font-bold text-green-900 mb-2">Mode Fokus</h1>
            <p className="text-center text-gray-600 max-w-md mb-6">
                Gunakan <strong>Teknik Pomodoro</strong> untuk meningkatkan produktivitas. Bekerja dalam interval fokus (misal 25 menit) diikuti istirahat singkat terbukti secara ilmiah dapat menjaga konsentrasi dan mencegah kelelahan mental.
            </p>
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center w-full max-w-sm">
                <div className="flex justify-center space-x-2 mb-6">
                    {Object.keys(modes).map(key => (
                        <button key={key} onClick={() => switchMode(key)} className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${mode === key ? 'bg-green-800 text-white' : 'bg-gray-200 text-gray-700'}`}>
                            {modes[key].label}
                        </button>
                    ))}
                </div>
                <div className="text-7xl font-bold text-green-900 my-4">
                    {formatTime(time)}
                </div>
                <div className="flex justify-center space-x-4">
                    <button onClick={toggleTimer} className="px-8 py-3 bg-green-800 text-white font-semibold rounded-lg hover:bg-green-900 transition-colors">
                        {isActive ? 'Jeda' : 'Mulai'}
                    </button>
                    <button onClick={resetTimer} className="px-8 py-3 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 transition-colors">
                        Reset
                    </button>
                </div>
                {isAlarmPlaying && (
                    <button onClick={stopAlarm} className="mt-4 w-full py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition-colors">
                        Matikan Alarm
                    </button>
                )}
                {isActive && <p className="text-green-700 mt-4 font-semibold">Mode fokus aktif. Layar tidak akan mati.</p>}
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg text-left w-full max-w-sm mt-6">
                <h2 className="text-xl font-bold text-green-900 mb-4">Atur Durasi (Menit)</h2>
                <div className="space-y-3">
                    {Object.keys(durations).map(key => (
                        <div key={key} className="flex items-center justify-between">
                            <span className="font-medium text-gray-700">{modes[key].label}</span>
                            <div className="flex items-center space-x-3">
                                <button onClick={() => handleDurationChange(key, -1)} className="w-7 h-7 rounded-full border border-green-800 text-green-800 font-bold">-</button>
                                <span>{durations[key]}</span>
                                <button onClick={() => handleDurationChange(key, 1)} className="w-7 h-7 rounded-full bg-green-800 text-white font-bold">+</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg text-left w-full max-w-sm mt-6">
                <h2 className="text-xl font-bold text-green-900 mb-4">Pengaturan Alarm</h2>
                <div className="space-y-3">
                    <div className="flex items-center justify-between">
                        <label htmlFor="notif-toggle" className="font-medium text-gray-700">Izinkan Notifikasi</label>
                        <button onClick={requestNotificationPermission} disabled={notificationPermission === 'granted'} className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md disabled:bg-gray-400">
                            {notificationPermission === 'granted' ? 'Diizinkan' : 'Izinkan'}
                        </button>
                    </div>
                    <div className="flex items-center justify-between">
                        <label htmlFor="sound-toggle" className="font-medium text-gray-700">Alarm Saat Selesai</label>
                        <button onClick={() => setIsSoundEnabled(!isSoundEnabled)} className={`px-3 py-1 text-sm rounded-md text-white ${isSoundEnabled ? 'bg-green-600' : 'bg-red-500'}`}>
                            {isSoundEnabled ? 'Aktif' : 'Mati'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PromoModal = ({ notification, onClose, showNotification }) => {
    if (!notification) return null;

    const handleCopyCode = (code) => {
        const el = document.createElement('textarea');
        el.value = code;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        showNotification(`Kupon ${code} telah disalin!`, 'success');
        onClose();
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <div className="bg-white rounded-lg p-6 text-center max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
                <img src={notification.imageUrl || 'https://placehold.co/400x200/e2e8f0/64748b?text=Promo'} alt={notification.title} className="w-full h-32 object-cover rounded-md mb-4" />
                <h2 className="text-2xl font-bold text-green-800 mb-2">{notification.title}</h2>
                <p className="text-gray-700 whitespace-pre-wrap">{notification.description}</p>
                {notification.voucherCode && (
                    <div className="mt-4">
                        <p className="text-sm">Gunakan kode kupon di bawah ini:</p>
                        <div className="mt-2 flex items-center justify-between bg-gray-100 p-2 rounded">
                            <span className="font-mono text-green-800">{notification.voucherCode}</span>
                            <button onClick={() => handleCopyCode(notification.voucherCode)} className="text-sm font-semibold">Salin</button>
                        </div>
                    </div>
                )}
                <button onClick={onClose} className="mt-4 px-6 py-2 bg-green-700 text-white rounded-lg">Tutup</button>
            </div>
        </div>
    );
};

const RecommendationModal = ({ isOpen, onClose, menuItems, onAddToCart, showNotification }) => {
    const [recommendation, setRecommendation] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [clickCount, setClickCount] = useState(0);
    const [shownRecommendations, setShownRecommendations] = useState([]);
    const [tasteProfile, setTasteProfile] = useState({
        sukaManis: false,
        sukaKopiKuat: false,
        sukaNonKopi: false,
        sukaMakananBerat: false,
        sukaCemilan: false,
    });

    useEffect(() => {
        if (!isOpen) {
            setTimeout(() => {
                setClickCount(0);
                setRecommendation(null);
                setShownRecommendations([]);
                setTasteProfile({
                    sukaManis: false,
                    sukaKopiKuat: false,
                    sukaNonKopi: false,
                    sukaMakananBerat: false,
                    sukaCemilan: false,
                });
            }, 300);
        }
    }, [isOpen]);

    const handleTasteChange = (e) => {
        const { name, checked } = e.target;
        setTasteProfile(prev => ({ ...prev, [name]: checked }));
    };

    const generateRecommendations = async () => {
        setClickCount(prev => prev + 1);
        setIsLoading(true);

        const preferences = Object.entries(tasteProfile)
            .filter(([, value]) => value)
            .map(([key]) => key)
            .join(', ');

        const menuList = menuItems
            .filter(item => !shownRecommendations.map(r => r.name).includes(item.name))
            .map(item => `- ${item.name} (Kategori: ${item.category}, Deskripsi: ${item.description})`)
            .join('\n');

        let prompt = `Tugas Anda adalah memberikan satu rekomendasi menu yang paling cocok dari daftar yang tersedia. JANGAN merekomendasikan menu yang tidak ada di daftar. Balas HANYA dengan objek JSON tunggal yang valid. Berdasarkan preferensi pelanggan: "${preferences || 'tidak ada preferensi spesifik'}", dan daftar menu ini:\n${menuList}\n\n`;

        if (shownRecommendations.length > 0) {
            const firstCategory = shownRecommendations[0].category;
            prompt += `Prioritaskan untuk merekomendasikan menu dari kategori '${firstCategory}'.\n\n`;
        }

        prompt += `Kembalikan objek JSON tunggal dengan kunci "name" (nama menu persis dari daftar) dan "reason" (alasan singkat, santai, dan menghibur kenapa menu ini direkomendasikan). Contoh format: {"name": "Kopi Susu Gula Aren", "reason": "Manisnya pas buat naikin mood kamu!"}`;

        const payload = { contents: [{ role: "user", parts: [{ text: prompt }] }] };
        const apiKey = "AIzaSyAgCuXrityryqfbHmIJhmTJCzPslSkxb1E";
        const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const result = await response.json();

            let finalRecommendation;
            let finalReason = "Cocok buat kamu coba hari ini!";

            if (result.candidates && result.candidates[0]?.content?.parts?.[0]) {
                const text = result.candidates[0].content.parts[0].text;
                const cleanedText = text.replace(/```json|```/g, '').trim();
                const recommendedItem = JSON.parse(cleanedText);

                let foundMenuItem = menuItems.find(item =>
                    item.name.trim().toLowerCase() === recommendedItem.name.trim().toLowerCase() &&
                    !shownRecommendations.map(r => r.name).includes(item.name)
                );

                if (foundMenuItem) {
                    finalRecommendation = foundMenuItem;
                    finalReason = recommendedItem.reason;
                }
            }

            if (!finalRecommendation) {
                const shownNames = shownRecommendations.map(r => r.name);
                let potentialItems = menuItems.filter(item => !shownNames.includes(item.name));

                if (shownRecommendations.length > 0) {
                    const firstCategory = shownRecommendations[0].category;
                    const sameCategoryItems = potentialItems.filter(item => item.category === firstCategory);
                    if (sameCategoryItems.length > 0) {
                        potentialItems = sameCategoryItems;
                    }
                }

                if (potentialItems.length > 0) {
                    finalRecommendation = potentialItems[Math.floor(Math.random() * potentialItems.length)];
                } else {
                    finalRecommendation = shownRecommendations[shownRecommendations.length - 1];
                }
            }

            setRecommendation({ ...finalRecommendation, reason: finalReason });
            setShownRecommendations(prev => [...prev, finalRecommendation]);

        } catch (error) {
            console.error("AI Recommendation Error:", error);
            showNotification('Error! AI lagi pusing, kita kasih rekomendasi acak aja ya!', 'error');
            const shownNames = shownRecommendations.map(r => r.name);
            const potentialItems = menuItems.filter(item => !shownNames.includes(item.name));
            const randomItem = potentialItems.length > 0 ? potentialItems[Math.floor(Math.random() * potentialItems.length)] : menuItems[0];
            setRecommendation({ ...randomItem, reason: "Kadang, pilihan terbaik itu yang nggak disengaja. Coba aja dulu!" });
            setShownRecommendations(prev => [...prev, randomItem]);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    const isLocked = clickCount >= 3;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 transition-opacity duration-300" onClick={onClose}>
            <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6 transform transition-all duration-300 scale-95" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-2xl font-bold text-green-900 text-center mb-4">Bingung Mau Pesan Apa?</h2>
                <p className="text-center text-gray-600 mb-6">Bantu kami memahami seleramu, dan AI kami akan berikan rekomendasi terbaik!</p>

                <div className="space-y-3 mb-6">
                    <h3 className="font-semibold text-lg text-gray-800">Preferensi Rasa Anda:</h3>
                    <label className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" name="sukaManis" checked={tasteProfile.sukaManis} onChange={handleTasteChange} className="mr-3 h-4 w-4 rounded text-green-600 focus:ring-green-500 border-gray-300" /> Suka yang manis?</label>
                    <label className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" name="sukaKopiKuat" checked={tasteProfile.sukaKopiKuat} onChange={handleTasteChange} className="mr-3 h-4 w-4 rounded text-green-600 focus:ring-green-500 border-gray-300" /> Suka kopi yang strong?</label>
                    <label className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" name="sukaNonKopi" checked={tasteProfile.sukaNonKopi} onChange={handleTasteChange} className="mr-3 h-4 w-4 rounded text-green-600 focus:ring-green-500 border-gray-300" /> Lagi ingin non-kopi?</label>
                    <label className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" name="sukaMakananBerat" checked={tasteProfile.sukaMakananBerat} onChange={handleTasteChange} className="mr-3 h-4 w-4 rounded text-green-600 focus:ring-green-500 border-gray-300" /> Lagi lapar & mau makan berat?</label>
                    <label className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer"><input type="checkbox" name="sukaCemilan" checked={tasteProfile.sukaCemilan} onChange={handleTasteChange} className="mr-3 h-4 w-4 rounded text-green-600 focus:ring-green-500 border-gray-300" /> Mau ngemil aja?</label>
                </div>

                {!isLocked && (
                    <button onClick={generateRecommendations} disabled={isLoading} className="w-full py-3 font-semibold text-white bg-green-800 rounded-lg hover:bg-green-900 transition-colors flex items-center justify-center disabled:bg-gray-400">
                        {isLoading ? <SemestaLogoSpinner /> : (clickCount === 0 ? 'Cari Rekomendasi' : 'Cari Lagi')}
                    </button>
                )}

                {recommendation && !isLoading && (
                    <div className="mt-6 border-t pt-4">
                        <h3 className="font-semibold text-lg text-center mb-2">{isLocked ? "Udah ini aja ya, aku capek!" : "Ini rekomendasi buat kamu!"}</h3>
                        <div className="bg-green-50 p-3 rounded-lg">
                            <div className="flex items-center">
                                <img src={recommendation.image} alt={recommendation.name} className="w-16 h-16 rounded-lg object-cover mr-4" />
                                <div className="flex-grow">
                                    <p className="font-bold text-lg">{recommendation.name}</p>
                                    <p className="text-sm text-gray-600">Rp {(recommendation.isPackage ? recommendation.packagePrice : recommendation.price).toLocaleString('id-ID')}</p>
                                </div>
                                <button onClick={() => { onAddToCart(recommendation); onClose(); }} className="px-4 py-2 text-sm bg-green-700 text-white rounded-lg hover:bg-green-800">Tambah</button>
                            </div>
                            <p className="text-center text-gray-700 mt-3 pt-3 border-t border-green-200">"{recommendation.reason}"</p>
                        </div>
                    </div>
                )}
                {isLoading && (
                    <div className="mt-6 border-t pt-4 flex flex-col items-center justify-center">
                        <SemestaLogoSpinner className="my-4" />
                        <p className="text-gray-600">AI sedang meracik rekomendasi...</p>
                    </div>
                )}

                <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
            </div>
        </div>
    );
};

const SemestaLaundryScreen = ({ user, showNotification, isPremiumMode, userLocation }) => {
    const [inputText, setInputText] = useState('');
    const [outputText, setOutputText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [quota, setQuota] = useState(user.laundryQuota || 0);

    useEffect(() => {
        setQuota(user.laundryQuota || 0);
    }, [user.laundryQuota]);

    const handleLaundry = async () => {
        if (!inputText.trim()) {
            showNotification('Tulis sesuatu dulu dong!', 'error');
            return;
        }
        if (!isPremiumMode && quota <= 0) {
            showNotification('Kuota harian habis. Datang ke cafe untuk unlimited!', 'error');
            return;
        }

        setIsLoading(true);
        try {
            const semestaLaundry = httpsCallable(functions, 'semestaLaundry');
            const result = await semestaLaundry({
                text: inputText,
                mode: isPremiumMode ? 'onsite' : 'remote'
            });
            setOutputText(result.data.text);
            if (!isPremiumMode) {
                setQuota(prev => prev - 1); // Optimistic update for remote mode
            }
            showNotification('Tulisan berhasil dicuci!', 'success');
        } catch (error) {
            console.error("Laundry error:", error);
            showNotification(`Gagal mencuci: ${error.message}`, 'error');
        } finally {
            setIsLoading(false);
        }
    };



    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsLoading(true);
        showNotification('Sedang membaca dokumen...', 'info');
        try {
            const text = await parseDocument(file);
            setInputText(text);
            showNotification('Dokumen berhasil dibaca! Silakan cuci.', 'success');
        } catch (error) {
            console.error("File parse error:", error);
            showNotification(`Gagal membaca file: ${error.message}`, 'error');
        } finally {
            setIsLoading(false);
            e.target.value = null; // Reset input
        }
    };

    return (
        <div className="p-4 md:p-6 bg-gray-50 min-h-full">
            <h1 className="text-3xl font-bold text-green-900 mb-2">Semesta Laundry</h1>
            <p className="text-gray-600 mb-6">Cuci tulisanmu agar terlihat lebih manusiawi dan lolos deteksi AI.</p>

            <div className="bg-white p-4 rounded-lg shadow-md mb-6">
                <div className="flex justify-between items-center mb-4">
                    <div className="text-sm">
                        Status: <span className={`font-bold ${isPremiumMode ? 'text-green-600' : 'text-blue-600'}`}>{isPremiumMode ? 'ON-SITE (Unlimited)' : 'REMOTE'}</span>
                    </div>
                    {!isPremiumMode && (
                        <div className="text-sm">
                            Kuota: <span className="font-bold text-red-600">{quota}</span> / 3
                            {userLocation && (
                                <div className="text-xs text-gray-400 mt-1">
                                    Jarak: {userLocation.distance ? userLocation.distance.toFixed(3) : '?'} km
                                </div>
                            )}
                        </div>
                    )}
                </div>


                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Upload Dokumen (Word/PDF)</label>
                    <input
                        type="file"
                        accept=".pdf,.docx"
                        onChange={handleFileUpload}
                        className="block w-full text-sm text-gray-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-green-50 file:text-green-700
                            hover:file:bg-green-100"
                    />
                </div>

                <textarea
                    className="w-full p-3 border rounded-lg h-40 mb-4 focus:ring-2 focus:ring-green-500"
                    placeholder="Tempel tulisan AI kamu di sini..."
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                ></textarea>

                <button
                    onClick={handleLaundry}
                    disabled={isLoading || (!isPremiumMode && quota <= 0)}
                    className="w-full py-3 bg-green-800 text-white rounded-lg font-bold hover:bg-green-900 disabled:bg-gray-400 flex justify-center items-center"
                >
                    {isLoading ? <SemestaLogoSpinner /> : 'Cuci Tulisan'}
                </button>
            </div>

            {outputText && (
                <div className="bg-green-50 p-6 rounded-lg shadow-inner border border-green-200">
                    <h3 className="font-bold text-green-900 mb-2">Hasil Cucian:</h3>
                    <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">{outputText}</p>
                    <div className="flex space-x-2 mt-4">
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(outputText);
                                showNotification('Teks disalin!', 'success');
                            }}
                            className="text-sm text-green-700 font-semibold hover:underline px-3 py-2 rounded hover:bg-green-100"
                        >
                            Salin Teks
                        </button>
                        <button
                            onClick={() => downloadAsPdf(outputText)}
                            className="text-sm text-red-700 font-semibold hover:underline px-3 py-2 rounded hover:bg-red-100 flex items-center"
                        >
                            <span className="mr-1">📄</span> PDF
                        </button>
                        <button
                            onClick={() => downloadAsDocx(outputText)}
                            className="text-sm text-blue-700 font-semibold hover:underline px-3 py-2 rounded hover:bg-blue-100 flex items-center"
                        >
                            <span className="mr-1">📝</span> Word
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

const SemestaSparringScreen = ({ user, showNotification, isPremiumMode }) => {
    const [messages, setMessages] = useState([
        { sender: 'ai', text: 'Saya Profesor Brawijaya. Mana argumenmu? Jangan buang waktu saya.' }
    ]);
    const [inputText, setInputText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(scrollToBottom, [messages]);

    const handleSend = async () => {
        if (!inputText.trim()) return;

        const userMsg = { sender: 'user', text: inputText };
        setMessages(prev => [...prev, userMsg]);
        setInputText('');
        setIsLoading(true);

        try {
            const semestaSparring = httpsCallable(functions, 'semestaSparring');
            // Send only the last message for now, context can be added later if needed
            const result = await semestaSparring({
                message: userMsg.text,
                mode: isPremiumMode ? 'onsite' : 'remote'
            });

            // [ANALYTICS] Track Sparring Interaction
            logEvent('semesta_sparring_message', {
                mode: isPremiumMode ? 'onsite' : 'remote',
                message_length: userMsg.text.length
            });

            const aiMsg = { sender: 'ai', text: result.data.text };
            setMessages(prev => [...prev, aiMsg]);
        } catch (error) {
            console.error("Sparring error:", error);
            showNotification(`Profesor sedang sibuk (Error): ${error.message}`, 'error');
            setMessages(prev => [...prev, { sender: 'ai', text: 'Maaf, saya sedang menguji mahasiswa lain. Coba lagi nanti.' }]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsLoading(true);
        showNotification('Membaca dokumen tugas...', 'info');
        try {
            const text = await parseDocument(file);
            setInputText(prev => (prev ? prev + '\n\n' : '') + `[Dokumen: ${file.name}]\n` + text);
            showNotification('Dokumen terlampir! Silakan kirim ke Profesor.', 'success');
        } catch (error) {
            console.error("File parse error:", error);
            showNotification(`Gagal membaca file: ${error.message}`, 'error');
        } finally {
            setIsLoading(false);
            e.target.value = null;
        }
    };

    return (
        <div className="flex flex-col h-[calc(100vh-140px)] bg-gray-100">
            <div className={`p-4 shadow-md ${isPremiumMode ? 'bg-indigo-900' : 'bg-red-900'} text-white`}>
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="text-xl font-bold flex items-center">
                            <span className="text-2xl mr-2">👨‍🏫</span> Ruang Sidang Prof. Brawijaya
                        </h1>
                        <p className={`text-xs mt-1 ${isPremiumMode ? 'text-indigo-200' : 'text-red-200'}`}>
                            {isPremiumMode ? "✨ Mode Semesta Area: Unlimited Mentoring" : "Mode: Remote (Killer) • Mental Baja Diperlukan"}
                        </p>
                    </div>
                    {isPremiumMode && (
                        <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded-full animate-pulse shadow-lg">
                            PREMIUM AREA
                        </span>
                    )}
                </div>
            </div>

            <div className="flex-grow overflow-y-auto p-4 space-y-4">
                {messages.map((msg, index) => (
                    <div key={index} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}>
                        <div className={`max-w-[80%] p-3 rounded-lg ${msg.sender === 'user' ? 'bg-green-100 text-green-900 rounded-br-none' : 'bg-white text-gray-800 border border-gray-300 rounded-bl-none shadow-sm'}`}>
                            <p className="whitespace-pre-wrap text-sm">{msg.text}</p>
                        </div>
                    </div>
                ))}
                {isLoading && (
                    <div className="flex justify-start">
                        <div className="bg-white p-3 rounded-lg border border-gray-300 rounded-bl-none shadow-sm">
                            <p className="text-sm text-gray-500 italic">Profesor sedang menilaimu...</p>
                        </div>
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>

            <div className="p-4 bg-white border-t border-gray-200">
                <div className="flex space-x-2 items-center">
                    <label className="cursor-pointer p-2 text-gray-500 hover:text-gray-700 bg-gray-100 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                        </svg>
                        <input type="file" accept=".pdf,.docx" className="hidden" onChange={handleFileUpload} />
                    </label>
                    <input
                        type="text"
                        value={inputText}
                        onChange={(e) => setInputText(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                        placeholder="Pertahankan argumenmu..."
                        className="flex-grow p-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-red-500"
                        disabled={isLoading}
                    />
                    <button
                        onClick={handleSend}
                        disabled={isLoading || !inputText.trim()}
                        className="bg-red-900 text-white p-3 rounded-full hover:bg-red-800 disabled:bg-gray-400 transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

const OrderSuccessModal = ({ isOpen, onClose, orderData }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 text-center" onClick={(e) => e.stopPropagation()}>
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                    <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <h3 className="text-xl font-bold text-green-900">Pesanan Berhasil Diterima!</h3>
                <p className="text-gray-600 mt-2 mb-4">
                    ID Pesanan Anda: <span className="font-mono bg-gray-100 p-1 rounded">{(orderData?.orderId || orderData?.id || '').substring(0, 8)}...</span>
                </p>

                {/* [BARU] Tampilkan QRIS Duitku Langsung di Modal jika ada */}
                {orderData?.qrString && (
                    <div className="mb-6 p-4 bg-purple-50 rounded-2xl border-2 border-purple-200 animate-fadeIn">
                        <p className="font-bold text-purple-900 mb-2">Silakan Scan QRIS</p>
                        <div className="bg-white p-4 rounded-xl inline-block shadow-sm">
                            <QRCodeSVG
                                value={orderData.qrString}
                                size={180}
                                level="M"
                                includeMargin={false}
                            />
                        </div>
                        <p className="text-xl font-bold text-purple-900 mt-4">Rp {orderData.totalAmount?.toLocaleString('id-ID')}</p>
                        <p className="text-xs text-gray-500 mt-2">QRIS Dinamis • Otomatis Lunas setelah bayar</p>
                    </div>
                )}

                {!orderData?.qrString && (
                    <p className="text-gray-600 mb-6">
                        Pesanan Anda sedang menunggu konfirmasi. Anda dapat melacak statusnya di halaman Riwayat.
                    </p>
                )}
                {/* [BARU] Post-Purchase Reward: Voucher Diskon 10% */}
                {orderData?.voucherCode ? (
                    <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-4 mb-6 text-left relative overflow-hidden">
                        <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 rounded-bl-lg">
                            REWARD
                        </div>
                        <p className="font-bold text-yellow-900 mb-1">🎉 Selamat! Anda dapat Voucher 10%</p>
                        <p className="text-sm text-gray-700 mb-3">Gunakan kode ini untuk pembelian minuman/makanan selanjutnya!</p>

                        <div className="flex space-x-2 items-center">
                            <div className="flex-1 bg-white border border-yellow-300 border-dashed rounded-lg px-3 py-2 font-mono font-bold text-center text-lg text-yellow-800 tracking-wider">
                                {orderData.voucherCode}
                            </div>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(orderData.voucherCode);
                                    // alert('Kode berhasil disalin!'); // Simple feedback
                                }}
                                className="bg-yellow-500 text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-yellow-600 transition-colors shadow-sm"
                            >
                                Salin
                            </button>
                        </div>
                    </div>
                ) : (
                    /* Fallback to upsell if no voucher (e.g. for regular orders) */
                    <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6 text-left">
                        <p className="font-bold text-green-900 mb-1">🔥 Mau Diskon 25%?</p>
                        <p className="text-sm text-gray-700 mb-3">Install aplikasi Semesta Café sekarang dan dapatkan voucher khusus pengguna baru!</p>

                        <div className="flex space-x-2">
                            <button
                                onClick={() => window.open('https://play.google.com/store/apps/details?id=app.web.semestacafe.twa&pcampaignid=web_share', '_blank')}
                                className="flex-1 bg-black text-white py-2 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-colors flex items-center justify-center space-x-1"
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M3.609 1.814L13.792 12 3.61 22.186a2.95 2.95 0 01-.61-2.071V3.885c0-.765.234-1.472.609-2.071zM15.42 12l4.8 4.8-2.054 1.15c-.933.522-2.094.462-2.986-.14L15.42 12zm2.748-5.95L15.422 12l-.24-.24-11.572-11.57c.89-.604 2.053-.664 2.986-.142l11.572 6.002zM4.09 23.95l11.09-11.09.24.238L3.848 24.67c-.22-.16-.62-.43-.243-.72z" /></svg>
                                <span>Install App</span>
                            </button>
                            <button
                                onClick={onClose}
                                className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg text-sm font-semibold hover:bg-gray-100 transition-colors"
                            >
                                Nanti Saja
                            </button>
                        </div>
                    </div>
                )}

                <div className="text-sm text-gray-400 cursor-pointer hover:underline" onClick={onClose}>
                    Tutup Modal
                </div>
            </div>
        </div>
    );
};




const AppView = ({ currentUser, settings, menuItems, packages, tutorials, dailyQuiz, activeOrder, onQuizSubmit, cart, onCartChange, handleLogout, onAddToCart, showNotification, setIsFokusModeActive, specialPromos, onPromoClick, allUserOrders, unreadOrderChatId, setUnreadOrderChatId, latestBroadcast, onDismissBroadcast, unreadCount, setShowNotificationCenter, isPremiumMode, userLocation, selectedEvent, setSelectedEvent, selectedTicket, setSelectedTicket, locationError, onRefreshLocation, isLocationLoading, menuCategories, bukberJoinData, setBukberJoinData, guestName, setGuestName, setView, loginPrompt, setLoginPrompt, showIncentiveModal, setShowIncentiveModal }) => {
    const [currentPage, setCurrentPage] = useState('Home');
    const [selectedPromo, setSelectedPromo] = useState(null);
    const [isRecommendationModalOpen, setIsRecommendationModalOpen] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState(null);
    const [orderSuccessData, setOrderSuccessData] = useState(null);
    const [isProcessingOrder, setIsProcessingOrder] = useState(false);
    const [selectedOrderForChat, setSelectedOrderForChat] = useState(null);
    const [isTopUpModalOpen, setIsTopUpModalOpen] = useState(false);
    const [isCartAnimating, setIsCartAnimating] = useState(false);
    const [shareBookingData, setShareBookingData] = useState(null);
    const [selectedBlogArticle, setSelectedBlogArticle] = useState(null);

    const [pendingOrderData, setPendingOrderData] = useState(null); // [FIX] State untuk data order sementara (Cart -> Bukber)
    const [defaultCartOrderType, setDefaultCartOrderType] = useState(''); // [BARU] Default order type dari menu Bukber
    const [isBukberMode, setIsBukberMode] = useState(false); // [BARU] Mode Bukber dari Link

    // [BARU] Auto-detect Bukber items in cart
    const isBukberItemInCart = cart.some(item =>
        (item.name && item.name.toLowerCase().includes('bukber')) ||
        (item.category && item.category === 'Paket Bukber')
    );

    const effectiveBukberMode = isBukberMode || isBukberItemInCart;

    const totalCartItems = cart.reduce((sum, item) => sum + item.quantity, 0);

    // [BARU] Animasi keranjang saat ada barang masuk
    const prevCartItemsRef = useRef(totalCartItems);

    useEffect(() => {
        if (totalCartItems > prevCartItemsRef.current) {
            console.log("Cart items increased, triggering animation");
            setIsCartAnimating(true);
            const timer = setTimeout(() => setIsCartAnimating(false), 2500); // Berkedip 2.5 detik
            return () => clearTimeout(timer);
        }
        prevCartItemsRef.current = totalCartItems;
    }, [totalCartItems]);

    // [BARU] Lifted State: Current Hour (Real-time Clock)
    // Dipindahkan dari CartScreen agar HomeScreen juga bisa akses
    const [currentHour, setCurrentHour] = useState(new Date().getHours());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentHour(new Date().getHours());
        }, 60000); // Update setiap 1 menit
        return () => clearInterval(timer);
    }, []);

    // [BARU] Listener untuk membuka modal top up dari mana saja
    useEffect(() => {
        const handleOpenTopUp = () => setIsTopUpModalOpen(true);
        window.addEventListener('openTopUpModal', handleOpenTopUp);
        return () => window.removeEventListener('openTopUpModal', handleOpenTopUp);
    }, []);

    // [BARU] Listener untuk navigasi antar halaman
    // [MODIFIKASI] Jika navigasi ke Bukber, set defaultOrderType ke 'booking' tapi tetap di Home untuk pilih menu
    useEffect(() => {
        const handleNavigate = (e) => {
            if (e.detail === 'Bukber') {
                setDefaultCartOrderType('booking');
                setCurrentPage('Home'); // Tetap di Home untuk pilih menu
                showNotification('Mode Bukber aktif! Silakan pilih menu untuk reservasi.', 'info');
            } else {
                // Reset hanya jika bukan navigasi ke Cart (agar flag tetap saat checkout)
                if (e.detail !== 'Cart') {
                    setDefaultCartOrderType('');
                }
                setCurrentPage(e.detail);
            }
        };
        window.addEventListener('navigate', handleNavigate);
        return () => window.removeEventListener('navigate', handleNavigate);
    }, [showNotification]);

    // [BARU] Listener untuk Login Prompt
    useEffect(() => {
        const handleOpenPrompt = (e) => setLoginPrompt(e.detail);
        window.addEventListener('open-login-prompt', handleOpenPrompt);
        return () => window.removeEventListener('open-login-prompt', handleOpenPrompt);
    }, []);

    // [BARU] Duitku Return Handling (Redirect Logic)
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const resultCode = queryParams.get('resultCode');
        const reference = queryParams.get('reference') || queryParams.get('merchantOrderId'); // Order ID

        if (resultCode === '00' && reference) {
            // Pembayaran Berhasil
            setOrderSuccessData({
                orderId: reference
            });
            // Bersihkan URL agar tidak trigger ulang saat refresh
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    // [BARU] Duitku Return Handling (Redirect Logic)
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const resultCode = queryParams.get('resultCode');
        const reference = queryParams.get('reference') || queryParams.get('merchantOrderId'); // Order ID

        if (resultCode === '00' && reference) {
            // Pembayaran Berhasil
            setOrderSuccessData({
                orderId: reference
            });
            // Bersihkan URL agar tidak trigger ulang saat refresh
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    // [BARU] Direct Link Routing (Bukber & Blog) - Inside AppView
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const mode = urlParams.get('mode');
        const path = window.location.pathname.toLowerCase();

        if (mode === 'bukber') {
            setIsBukberMode(true);
            setCurrentPage('Bukber');
            showNotification('Mode Bukber aktif! Silakan pilih menu untuk reservasi.', 'info');
        } else if (path.includes('/blog') || path.includes('/artikel')) {
            setCurrentPage('BlogList');
        } else if (urlParams.get('promo_success') === '1' || mode === 'promo_weekend') {
            setCurrentPage('PromoWeekend');
        }
    }, []);

    // [BARU] AFFILIATE LOGIC: Tangkap Referral ID dari URL dengan useEffect (Lebih Robust)
    // [BARU] AFFILIATE LOGIC: Tangkap Referral ID & Deep Link Item
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const refId = urlParams.get('ref');
        const itemId = urlParams.get('item');

        // 1. Handle Referral ID
        if (refId) {
            console.log("[AFFILIATE] Referral detected in AppView:", refId);
            localStorage.setItem('semesta_referrer_id', refId);
        }

        // 2. Handle Deep Link Item (Auto Open Modal)
        if (itemId && menuItems.length > 0) {
            console.log("[DEEP_LINK] Found item ID:", itemId);
            const targetItem = menuItems.find(m => m.id === itemId);
            if (targetItem) {
                console.log("[DEEP_LINK] Opening item:", targetItem.name);
                setSelectedMenuItem(targetItem);
            }
        }

        // 3. Handle Join Bukber Link
        const joinBukberId = urlParams.get('joinBukber');
        if (joinBukberId) {
            console.log("[BUKBER] Join request detected:", joinBukberId);
            // Fetch booking data - [FIX] Use correct path with publicDataPath
            getDoc(doc(db, `${publicDataPath}/transactions`, joinBukberId)).then(snap => {
                if (snap.exists() && snap.data().type === 'booking') {
                    setBukberJoinData({ id: snap.id, ...snap.data() });
                    setCurrentPage('Bukber');
                    showNotification(`Bergabung dengan Bukber: ${snap.data().customerName}`, 'success');
                } else {
                    showNotification('Link Bukber tidak valid atau kadaluarsa.', 'error');
                }
            }).catch(err => {
                console.error("Error fetching bukber data:", err);
                showNotification('Gagal memuat data Bukber.', 'error');
            });
        }

        // 4. [BARU] Handle Bukber Success Return dari Duitku
        const bukberSuccess = urlParams.get('bukber_success');
        const bookingIdFromUrl = urlParams.get('booking_id');
        if (bukberSuccess || window.location.pathname.includes('bukber-success')) {
            console.log("[BUKBER] Payment success return detected, booking_id:", bookingIdFromUrl);

            // Fetch booking data - prefer URL param booking_id
            if (bookingIdFromUrl) {
                getDoc(doc(db, "artifacts", appId, "public", "data", "transactions", bookingIdFromUrl))
                    .then(snap => {
                        if (snap.exists()) {
                            const booking = { id: snap.id, ...snap.data() };
                            setShareBookingData({
                                id: booking.id,
                                customerName: booking.customerName,
                                dpOption: booking.dpOption,
                                dpAmount: booking.dpAmount,
                                bookingDate: booking.bookingDate,
                                bookingTime: booking.bookingTime
                            });
                            showNotification('Pembayaran Bukber berhasil! 🎉', 'success');
                            setCurrentPage('Riwayat');
                        }
                    }).catch(err => {
                        console.error("Error fetching booking:", err);
                    });
            } else if (currentUser) {
                // Fallback: cari booking terakhir dari user
                getDocs(query(
                    collection(db, "artifacts", appId, "public", "data", "transactions"),
                    where("customerId", "==", currentUser.uid),
                    where("type", "==", "booking"),
                    orderBy("createdAt", "desc"),
                    limit(1)
                )).then(snap => {
                    if (!snap.empty) {
                        const booking = { id: snap.docs[0].id, ...snap.docs[0].data() };
                        setShareBookingData({
                            id: booking.id,
                            customerName: booking.customerName,
                            dpOption: booking.dpOption,
                            dpAmount: booking.dpAmount,
                            bookingDate: booking.bookingDate,
                            bookingTime: booking.bookingTime
                        });
                        showNotification('Pembayaran Bukber berhasil! 🎉', 'success');
                        setCurrentPage('Riwayat');
                    }
                }).catch(err => {
                    console.error("Error fetching latest booking:", err);
                });
            }
            // Clean up URL
            window.history.replaceState({}, '', window.location.origin);
        }
    }, [menuItems, currentUser]); // Dependency menuItems penting agar saat data load, effect jalan lagi

    // [ANALYTICS] Track Screen Views
    useEffect(() => {
        logScreenView(currentPage);
    }, [currentPage]);

    // [ANALYTICS] Scroll Depth Tracking
    const scrollDepthRef = useRef({ 25: false, 50: false, 75: false, 90: false });

    // Reset scroll tracking when page changes
    useEffect(() => {
        scrollDepthRef.current = { 25: false, 50: false, 75: false, 90: false };
    }, [currentPage]);

    const handleScroll = (e) => {
        if (currentPage !== 'Home') return; // Only track Home for now

        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;

        const thresholds = [25, 50, 75, 90];

        thresholds.forEach(threshold => {
            if (scrollPercent >= threshold && !scrollDepthRef.current[threshold]) {
                scrollDepthRef.current[threshold] = true;
                logEvent('scroll_depth', {
                    page: currentPage,
                    depth: `${threshold}%`
                });
            }
        });
    };

    const handleRiwayatClick = () => {
        if (unreadOrderChatId) {
            const orderToOpen = allUserOrders.find(o => o.id === unreadOrderChatId);
            if (orderToOpen) {
                setSelectedOrderForChat(orderToOpen);
                setUnreadOrderChatId(null);
            } else {
                setCurrentPage('Riwayat');
                setUnreadOrderChatId(null);
            }
        } else {
            setCurrentPage('Riwayat');
        }
    };

    const handlePlaceOrder = async (orderData, setIsProcessing) => {
        // [MODIFIKASI] Mendapatkan ongkir dan jarak
        const { notes, orderType, address, seatingPosition, appliedVoucher, total, discount, paymentMethod, deliveryFee, distanceInKm } = orderData;

        if (cart.length === 0) {
            showNotification('Keranjang Anda kosong.', 'error');
            return;
        }
        // [MODIFIKASI] Validasi alamat sekarang ditangani oleh isLocationSet
        if (orderType === 'delivery' && !address.trim()) {
            showNotification('Alamat pengiriman tidak boleh kosong.', 'error');
            return;
        }
        if (orderType === 'dine-in' && !seatingPosition.trim()) {
            showNotification('Posisi tempat duduk tidak boleh kosong.', 'error');
            return;
        }

        // [BARU] Proteksi Login untuk Delivery (Pesanan Luar Area)
        if (orderType === 'delivery' && currentUser.isAnonymous) {
            window.dispatchEvent(new CustomEvent('open-login-prompt', { detail: { message: 'Untuk pesanan delivery, mohon login atau buat akun terlebih dahulu agar data Anda aman.' } }));
            return;
        }

        // [BARU] Redirect Cart -> Bukber Form
        if (orderType === 'booking') {
            setIsProcessing(false);
            setPendingOrderData(orderData); // [FIX] Simpan data order (termasuk paymentMethod) ke state App
            setCurrentPage('Bukber');
            showNotification('Silakan lengkapi data reservasi Bukber Anda.', 'info');
            return;
        }

        setIsProcessing(true);

        try {
            const batch = writeBatch(db);
            const newOrderRef = doc(transactionsCol);

            batch.set(newOrderRef, {
                customerId: currentUser.uid,
                customerName: currentUser.isAnonymous ? (guestName || currentUser.name) : currentUser.name,
                items: cart,
                total,
                notes,
                orderType,
                address: address || null,
                seatingPosition: seatingPosition || null,
                date: Timestamp.now(),
                discount: discount || 0,
                voucherCode: appliedVoucher?.code || null,
                paymentMethod: paymentMethod,
                status: (paymentMethod === 'duitku_qris' || paymentMethod === 'qris') ? 'menunggu_pembayaran' : 'baru',
                // [BARU] Menyimpan data ongkir ke Firestore
                deliveryFee: deliveryFee || 0,
                distanceInKm: distanceInKm ? parseFloat(distanceInKm.toFixed(2)) : null,
                // [BARU] AFFILIATE: Simpan referrer ID & Discount Amount
                referrerId: localStorage.getItem('semesta_referrer_id') || null,
                referralDiscount: orderData.referralDiscount || 0 // Simpan nilai diskon referral
            });

            const userDocRef = doc(db, `${publicDataPath}/users`, currentUser.uid);
            let updatedVouchers = [...(currentUser.vouchers || [])];
            let loyaltyVoucherGranted = false;

            if (appliedVoucher) {
                updatedVouchers = updatedVouchers.map(v =>
                    v.id === appliedVoucher.id ? { ...v, used: true } : v
                );
            }

            const newTransactionCount = (currentUser.transactionCount || 0) + 1;
            if (newTransactionCount > 0 && newTransactionCount % 5 === 0) {
                const loyaltyVoucher = {
                    id: `loyalty_${newTransactionCount}_${Date.now()}`,
                    type: 'Loyalty 5 Pesanan',
                    discount: 10,
                    createdAt: Timestamp.now(),
                    used: false,
                    code: `LOYAL${Math.random().toString(36).substring(2, 7).toUpperCase()}`
                };
                updatedVouchers.push(loyaltyVoucher);
                loyaltyVoucherGranted = true;
            }

            // [FIX] Validasi Dokumen User (Cek Existensi)
            // Menggunakan getDoc untuk memastikan kita tidak mengupdate 'hantu'
            // dan untuk menyiapkan field default jika dokumen baru dibuat.
            const userDocSnap = await getDoc(userDocRef);

            const userUpdateData = {
                vouchers: updatedVouchers,
                transactionCount: increment(1),
                // Pastikan role ada jika dokumen baru
                role: userDocSnap.exists() ? (userDocSnap.data().role || 'customer') : 'customer',
                email: userDocSnap.exists() ? (userDocSnap.data().email || currentUser.email) : currentUser.email,
                name: userDocSnap.exists() ? (userDocSnap.data().name || currentUser.name) : currentUser.name
            };

            // Jika dokumen baru, tambahkan createdAt
            if (!userDocSnap.exists()) {
                userUpdateData.createdAt = Timestamp.now();
                userUpdateData.balance = 0; // Default balance
            }

            if (paymentMethod === 'semesta_pay') {
                const currentBalance = userDocSnap.exists() ? (userDocSnap.data().balance || 0) : 0;
                if (currentBalance < total) {
                    throw new Error("Saldo tidak mencukupi untuk melakukan transaksi ini.");
                }
                userUpdateData.balance = increment(-total);
            }

            // Gunakan batch.set dengan merge: true (Upsert aman)
            batch.set(userDocRef, userUpdateData, { merge: true });

            await batch.commit();

            if (loyaltyVoucherGranted) {
                showNotification('Selamat! Anda mendapat voucher loyalitas 10%. Cek halaman Promo!', 'success');
            }

            // [MODIFIKASI] Tampilkan modal sukses HANYA jika BUKAN Duitku QRIS (karena Duitku butuh redirect/buffering)
            if (paymentMethod !== 'duitku_qris' && paymentMethod !== 'qris') {
                setOrderSuccessData({
                    orderId: newOrderRef.id
                });
            }

            // [ANALYTICS] Track Purchase
            logPurchase(newOrderRef.id, total, cart);

            onCartChange([]);
            setCurrentPage('Home');

            // [BARU] Integrasi Duitku QRIS (Otomatis)
            if (paymentMethod === 'duitku_qris' || paymentMethod === 'qris') {
                setIsProcessingOrder(true); // [FIX] Tampilkan halaman buffering/loading
                try {
                    const createDuitkuInvoice = httpsCallable(functions, 'createDuitkuInvoice');
                    const result = await createDuitkuInvoice({
                        amount: total - (orderData.referralDiscount || 0) + (deliveryFee || 0),
                        orderId: newOrderRef.id,
                        orderType: orderType, // Opsional: Berikan info tipe order
                        paymentMethod: 'SP' // [BARU] Force QRIS Langsung (Sesuai Request User)
                    });

                    if (result.data.qrString) {
                        // [BARU] Simpan QR dan URL ke dokumen transaksi agar bisa diakses di Riwayat
                        const orderRef = doc(db, transactionsCol.path, newOrderRef.id);
                        await updateDoc(orderRef, {
                            qrString: result.data.qrString,
                            paymentUrl: result.data.paymentUrl
                        });
                    }

                    // [MODIFIKASI] Selalu redirect ke halaman pembayaran Duitku (Buffering -> Redirect)
                    if (result.data.paymentUrl) {
                        window.location.href = result.data.paymentUrl;
                        return;
                    } else {
                        throw new Error('Gagal mendapatkan data pembayaran Duitku');
                    }
                } catch (paymentError) {
                    setIsProcessingOrder(false); // [FIX] Stop buffering jika error
                    console.error("Duitku Error:", paymentError);
                    showNotification("Pesanan dibuat, tapi gagal membuka pembayaran. Silakan hubungi admin.", "warning");
                    setOrderSuccessData({ orderId: newOrderRef.id });
                }
            } else {
                setOrderSuccessData({
                    orderId: newOrderRef.id
                });
            }

            // [BARU] Tanyakan login setelah pesanan tamu berhasil
            if (currentUser.isAnonymous) {
                setTimeout(() => setShowIncentiveModal(true), 2000);
            }

        } catch (error) {
            console.error("Gagal menempatkan pesanan (DEBUG_FIX):", error);
            showNotification(`Gagal membuat pesanan [FIX]: ${error.message}`, 'error');
        } finally {
            setIsProcessing(false);
        }
    };

    const handlePromoClick = (promo) => {
        onPromoClick(promo);
        setSelectedPromo(promo);
    };

    // [BARU] Handle Event Ticket Purchase
    // [BARU] Handle Event Ticket Purchase
    const handleEventPurchase = async (purchaseData) => {
        if (!currentUser) {
            showNotification("Silakan login untuk membeli tiket.", "error");
            return;
        }

        try {
            const { event, category } = purchaseData;
            const total = category.price;

            // [NEW] Logic Pembayaran SemestaPay
            // 1. Cek Saldo User
            const userDocRef = doc(db, `${publicDataPath}/users`, currentUser.uid);
            const userDocSnap = await getDoc(userDocRef);

            if (!userDocSnap.exists()) {
                throw new Error("User data not found.");
            }

            const userData = userDocSnap.data();
            const currentBalance = userData.balance || 0;

            if (currentBalance < total) {
                showNotification("Saldo SemestaPay tidak mencukupi. Silakan Top Up.", "error");
                // [OPTIONAL] Open TopUp Modal here
                return;
            }

            // 2. Prepare Batch Transaction (Atomic Operation)
            const batch = writeBatch(db);
            const newTransactionRef = doc(transactionsCol);

            // Simplified transaction object for Event Ticket
            const transactionData = {
                type: 'event_ticket', // New Type
                eventId: event.id,
                eventTitle: event.title,
                eventDate: event.date, // Timestamp
                ticketCategoryId: category.id,
                ticketCategoryName: category.name,
                price: category.price,
                quantity: 1, // Currently 1 ticket per transaction
                total: total,
                status: 'paid', // [UPDATED] Langsung Lunas jika pakai Saldo
                customerId: currentUser.uid,
                customerName: currentUser.name || currentUser.email,
                customerEmail: currentUser.email,
                createdAt: serverTimestamp(),
                paymentMethod: 'SemestaPay', // Default for now
                items: [{
                    id: category.id,
                    name: `Tiket: ${event.title} (${category.name})`,
                    price: category.price,
                    quantity: 1
                }]
            };

            // 3. Add Operations to Batch
            // Create Transaction
            batch.set(newTransactionRef, transactionData);

            // [NEW] Generate Reward Voucher (10%)
            const rewardVoucher = {
                id: `reward_${newTransactionRef.id}`,
                type: 'Hadiah Transaksi',
                discount: 10,
                createdAt: Timestamp.now(),
                used: false,
                code: `REWARD${Math.random().toString(36).substring(2, 7).toUpperCase()}`
            };

            // Deduct Balance & Add Voucher
            batch.update(userDocRef, {
                balance: increment(-total),
                transactionCount: increment(1),
                vouchers: arrayUnion(rewardVoucher)
            });

            // 4. Commit Batch
            await batch.commit();

            console.log("Ticket Transaction Created ID:", newTransactionRef.id);

            const successData = {
                id: newTransactionRef.id,
                ...transactionData,
                date: new Date(), // for display
                voucherCode: rewardVoucher.code, // Pass to Modal
                voucherDiscount: rewardVoucher.discount
            };

            setOrderSuccessData(successData);


        } catch (error) {
            console.error("Error creating ticket transaction:", error);
            showNotification(`Gagal memproses pembelian tiket: ${error.message}`, "error");
        }
    };

    // [BARU] Handler Booking Bukber
    const handleBookingSubmit = async (formData) => {
        if (!currentUser) {
            showNotification('Silakan login terlebih dahulu.', 'error');
            return;
        }

        try {
            const bookingRef = doc(transactionsCol);
            const bookingTotal = cart.reduce((sum, item) => sum + ((item.isPackage ? item.packagePrice : item.price) || 0) * item.quantity, 0);

            // Logic beda untuk JOIN vs NEW
            if (bukberJoinData) {
                // [SIMPEL] Joiner hanya submit nama + menu tanpa bayar
                await setDoc(bookingRef, {
                    ...formData,
                    type: 'booking_join', // Tipe khusus joiner
                    parentBookingId: bukberJoinData.id, // Link ke booking ketua
                    parentCustomerName: bukberJoinData.customerName, // Nama ketua
                    items: cart.map(item => ({
                        ...item,
                        price: item.isPackage ? (item.packagePrice || 0) : (item.price || 0)
                    })),
                    total: bookingTotal,
                    customerId: currentUser.uid,
                    customerName: formData.name || currentUser.name || "Anggota", // [FIX] Pakai nama dari form
                    isAnonymous: currentUser.isAnonymous || false,
                    status: 'confirmed', // [SIMPEL] Langsung confirmed karena sudah dibayar ketua
                    paymentStatus: 'paid_by_ketua', // [SIMPEL] Pembayaran oleh ketua
                    createdAt: serverTimestamp(),
                    date: serverTimestamp(), // [FIX] Tambahkan date agar muncul di Riwayat
                    bookingDate: bukberJoinData.bookingDate, // Ikut Ketua
                    bookingTime: bukberJoinData.bookingTime, // Ikut Ketua
                    dateTime: bukberJoinData.dateTime // Ikut Ketua
                });

                // Clear cart dan reset state
                onCartChange([]); // [FIX] Gunakan onCartChange (prop) bukan setCart
                setBukberJoinData(null);
                showNotification(`🎉 Berhasil bergabung ke Bukber ${bukberJoinData.customerName}!`, 'success');
                setCurrentPage('Riwayat');
            } else {
                // New Booking (Ketua)
                // [BARU] Hitung DP Amount berdasarkan opsi
                const dpOption = formData.dpOption || 'dp30';
                const dpAmount = dpOption === 'lunas' ? bookingTotal : Math.ceil(bookingTotal * 0.3);
                const sisaPembayaran = bookingTotal - dpAmount;

                await setDoc(bookingRef, {
                    ...formData,
                    type: 'booking',
                    orderType: 'booking', // [FIX] Tambahkan field ini agar konsisten dengan Kasir
                    isBukber: true, // [BARU] Flag untuk proteksi hapus di Kasir
                    items: cart.map(item => ({
                        ...item,
                        price: item.isPackage ? (item.packagePrice || 0) : (item.price || 0)
                    })),
                    total: bookingTotal,
                    dpOption: dpOption, // [BARU] Opsi DP
                    dpAmount: dpAmount, // [BARU] Nominal DP
                    sisaPembayaran: sisaPembayaran, // [BARU] Sisa yang harus dibayar
                    customerId: currentUser.uid,
                    customerName: currentUser.name || "Pelanggan",
                    customerWhatsapp: formData.whatsapp || "",
                    status: 'pending_payment', // [BARU] Status pending sampai pembayaran masuk
                    createdAt: serverTimestamp(),
                    date: serverTimestamp(), // [FIX] Tambahkan date agar muncul di Riwayat
                    bookingDate: formData.date,
                    bookingTime: formData.time,
                    dateTime: Timestamp.fromDate(new Date(`${formData.date}T${formData.time}:00`)),
                    paymentMethod: 'duitku_qris', // [BARU] Force Duitku untuk Bukber
                    paymentStatus: 'unpaid'
                });

                // [BARU] Selalu redirect ke Duitku untuk pembayaran
                try {
                    const createBukberInvoice = httpsCallable(functions, 'createBukberInvoice');
                    const result = await createBukberInvoice({
                        amount: dpAmount, // [BARU] Nominal DP sesuai pilihan
                        totalAmount: bookingTotal,
                        dpOption: dpOption,
                        bookingId: bookingRef.id,
                        items: cart,
                        bookingDetails: {
                            date: formData.date,
                            time: formData.time,
                            pax: formData.pax,
                            notes: formData.notes
                        },
                        customerDetails: {
                            name: currentUser.name,
                            email: currentUser.email,
                            phone: formData.whatsapp || "08123456789"
                        }
                    });

                    if (result.data && result.data.paymentUrl) {
                        showNotification('Mengalihkan ke halaman pembayaran...', 'info');
                        setTimeout(() => {
                            window.location.href = result.data.paymentUrl;
                        }, 1500);
                        return; // Stop eksekusi agar tidak muncul popup sukses biasa
                    }
                } catch (error) {
                    console.error("Duitku Error:", error);
                    showNotification(`Gagal membuat link pembayaran: ${error.message}`, 'error');
                    return;
                }

                showNotification('Silakan selesaikan pembayaran untuk konfirmasi booking.', 'info');
                // [BARU] Tampilkan popup share link untuk ketua
                setShareBookingData({ id: bookingRef.id, customerName: currentUser.name || "Pelanggan" });
            }

            onCartChange([]);
            setCurrentPage('Riwayat');
            setBukberJoinData(null); // Reset join mode
        } catch (error) {
            console.error("Booking Error:", error);
            showNotification(`Gagal mengirim booking: ${error.message}`, 'error');
        }
    };

    const renderScreen = () => {
        switch (currentPage) {
            case 'Home': return <HomeScreen user={currentUser} settings={settings} menuItems={menuItems} packages={packages} activeOrder={activeOrder} onAddToCart={onAddToCart} onShowRecommendation={() => setIsRecommendationModalOpen(true)} onShowDetail={setSelectedMenuItem} latestBroadcast={latestBroadcast} onDismissBroadcast={onDismissBroadcast} isPremiumMode={isPremiumMode} userLocation={userLocation} currentHour={currentHour} locationError={locationError} onRefreshLocation={onRefreshLocation} isLocationLoading={isLocationLoading} menuCategories={menuCategories} />;
            case 'Riwayat': return <RiwayatScreen currentUser={currentUser} showNotification={showNotification} onOpenChat={setSelectedOrderForChat} setOrderSuccessData={setOrderSuccessData} />;
            case 'Nearby': return <NearbyScreen currentUser={currentUser} userLocation={userLocation} showNotification={showNotification} />;
            case 'EventList': return <EventListScreen user={currentUser} showNotification={showNotification} onBack={() => setCurrentPage('Home')} onEventSelect={(event) => { setSelectedEvent(event); setCurrentPage('EventDetail'); }} onOpenMyTickets={() => setCurrentPage('MyTickets')} />; // [UPDATED] With selection and My Tickets
            case 'EventDetail': return <EventDetailScreen eventId={selectedEvent?.id} user={currentUser} onBack={() => setCurrentPage('EventList')} onPurchase={handleEventPurchase} />; // [UPDATED] Real Purchase Handler
            case 'Bukber': return <BookingForm onBack={() => setCurrentPage('Home')} onSubmit={handleBookingSubmit} cart={cart} total={cart.reduce((sum, item) => sum + ((item.isPackage ? item.packagePrice : item.price) || 0) * item.quantity, 0)} onSelectMenu={() => setCurrentPage('Home')} joinMode={!!bukberJoinData} parentData={bukberJoinData} />;
            case 'Promo': return <PromoScreen user={currentUser} dailyQuiz={dailyQuiz} onQuizSubmit={onQuizSubmit} showNotification={showNotification} specialPromos={specialPromos} onPromoClick={handlePromoClick} />;
            case 'PromoWeekend': return <PromoWeekendScreen user={currentUser} showNotification={showNotification} onBack={() => setCurrentPage('Home')} />;
            case 'Laundry': return <SemestaLaundryScreen user={currentUser} showNotification={showNotification} isPremiumMode={isPremiumMode} userLocation={userLocation} />;
            case 'Sparring': return <SemestaSparringScreen user={currentUser} showNotification={showNotification} isPremiumMode={isPremiumMode} />;
            case 'Fokus': return <FokusScreen setIsFokusModeActive={setIsFokusModeActive} />;
            case 'Saran': return <SaranScreen user={currentUser} showNotification={showNotification} />;
            case 'Cart': return <CartScreen cart={cart} user={currentUser} settings={settings} showNotification={showNotification} currentHour={currentHour} defaultOrderType={effectiveBukberMode ? 'booking' : (typeof defaultCartOrderType !== 'undefined' ? defaultCartOrderType : 'dine-in')} isBukberMode={effectiveBukberMode} onUpdateQuantity={(itemId, quantity) => {
                const newCart = cart.map(item => item.id === itemId ? { ...item, quantity } : item).filter(item => item.quantity > 0);
                onCartChange(newCart);
            }} onDeleteItem={(itemId) => onCartChange(cart.filter(i => i.id !== itemId))} onBack={() => setCurrentPage('Home')} onPlaceOrder={handlePlaceOrder} bukberJoinData={bukberJoinData} setCurrentPage={setCurrentPage} guestName={guestName} setGuestName={setGuestName} />;
            case 'MyTickets': return <MyTicketsScreen user={currentUser} onBack={() => setCurrentPage('EventList')} onTicketSelect={(ticket) => { setSelectedTicket(ticket); setCurrentPage('TicketDetail'); }} />; // [NEW] My Tickets Case
            case 'TicketDetail': return <TicketDetailScreen ticket={selectedTicket} onBack={() => setCurrentPage('MyTickets')} />; // [NEW] Ticket Detail Case
            case 'BlogList': return <BlogList db={db} appId={appId} onSelectArticle={(article) => { setSelectedBlogArticle(article); setCurrentPage('BlogPost'); }} />;
            case 'BlogPost': return <BlogPost article={selectedBlogArticle} onBack={() => setCurrentPage('BlogList')} />;
            default: return <div className="p-6 text-center">Halaman {currentPage} sedang dalam pengembangan.</div>;
        }
    };

    return (
        <div className="max-w-lg mx-auto bg-gray-50 min-h-screen flex flex-col shadow-2xl">
            <TopUpModal
                isOpen={isTopUpModalOpen}
                onClose={() => setIsTopUpModalOpen(false)}
                user={currentUser}
                showNotification={showNotification}
            />
            <PromoModal notification={selectedPromo} onClose={() => setSelectedPromo(null)} showNotification={showNotification} />
            <RecommendationModal
                isOpen={isRecommendationModalOpen}
                onClose={() => setIsRecommendationModalOpen(false)}
                menuItems={[...menuItems, ...packages]}
                onAddToCart={onAddToCart}
                showNotification={showNotification}
            />
            <MenuDetailModal
                isOpen={!!selectedMenuItem}
                onClose={() => setSelectedMenuItem(null)}
                item={selectedMenuItem}
                onAddToCart={onAddToCart}
                currentUser={currentUser} // [BARU] Pass currentUser untuk Share Button
            />
            <OrderSuccessModal
                isOpen={!!orderSuccessData}
                onClose={() => setOrderSuccessData(null)}
                orderData={orderSuccessData}
            />
            {/* [BARU] Buffering Overlay saat redirect ke Duitku */}
            {isProcessingOrder && (
                <div className="fixed inset-0 bg-black/80 z-[70] flex flex-col items-center justify-center text-white animate-fadeIn">
                    <SemestaLogoSpinner className="w-16 h-16 mb-6" />
                    <h3 className="text-xl font-bold mb-2">Mengalihkan ke Pembayaran...</h3>
                    <p className="text-sm opacity-80">Mohon jangan tutup halaman ini.</p>
                </div>
            )}
            <ChatModal
                isOpen={!!selectedOrderForChat}
                onClose={() => setSelectedOrderForChat(null)}
                order={selectedOrderForChat}
                currentUser={currentUser}
                showNotification={showNotification}
            />
            {/* [BARU] Share Booking Popup Modal */}
            {shareBookingData && (
                <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl animate-scaleIn">
                        <div className="text-center mb-4">
                            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="text-3xl">🎉</span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-800">Booking Bukber Berhasil!</h3>
                            {shareBookingData.dpOption && (
                                <p className="text-sm text-gray-600 mt-1">
                                    {shareBookingData.dpOption === 'lunas'
                                        ? 'Pembayaran LUNAS sudah diterima'
                                        : `DP 30% (Rp ${new Intl.NumberFormat('id-ID').format(shareBookingData.dpAmount || 0)}) sudah diterima`}
                                </p>
                            )}
                            {shareBookingData.bookingDate && (
                                <p className="text-sm font-semibold text-purple-600 mt-2">
                                    📅 {shareBookingData.bookingDate} | {shareBookingData.bookingTime}
                                </p>
                            )}
                        </div>

                        <div className="bg-purple-50 rounded-xl p-4 mb-4">
                            <p className="text-sm font-semibold text-purple-800 mb-2">Ajak teman-teman gabung:</p>
                            <div className="flex items-center gap-2">
                                <input
                                    type="text"
                                    readOnly
                                    value={`${window.location.origin}?joinBukber=${shareBookingData.id}`}
                                    className="flex-1 text-xs bg-white border rounded-lg px-3 py-2 text-gray-600"
                                />
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${window.location.origin}?joinBukber=${shareBookingData.id}`);
                                        showNotification('Link disalin!', 'success');
                                    }}
                                    className="px-3 py-2 bg-purple-600 text-white rounded-lg text-sm font-semibold hover:bg-purple-700"
                                >
                                    Salin
                                </button>
                            </div>
                            <p className="text-xs text-purple-600 mt-2">
                                🔗 Bagikan link ini agar anggota bisa pesan menu masing-masing
                            </p>
                        </div>

                        <button
                            onClick={() => setShareBookingData(null)}
                            className="w-full py-3 bg-gray-800 text-white font-semibold rounded-xl hover:bg-gray-900"
                        >
                            Tutup
                        </button>
                    </div>
                </div>
            )}
            <header className="p-4 flex justify-between items-center bg-white">
                <img
                    src="https://res.cloudinary.com/dixc7tg2l/image/upload/v1753695417/logo_semesta_baru-removebg-preview_x8admb.png"
                    alt="Logo Semesta Cafe"
                    className="h-16"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://placehold.co/200x100/e2e8f0/64748b?text=Logo+Semesta';
                    }}
                />
                <div className="flex items-center space-x-2">
                    <button
                        onClick={() => setCurrentPage('BlogList')}
                        className={`p-2 rounded-full transition-colors ${currentPage === 'BlogList' || currentPage === 'BlogPost' ? 'bg-green-100 text-green-800' : 'hover:bg-gray-200 text-gray-600'}`}
                        title="Blog & Artikel"
                    >
                        <HiOutlineBookOpen className="w-6 h-6" />
                    </button>
                    <NotificationBellIcon
                        count={unreadCount}
                        onClick={() => setShowNotificationCenter(true)}
                    />
                    {currentUser?.isAnonymous ? (
                        <button onClick={() => setView('login')} className="flex items-center gap-1 px-3 py-1.5 bg-green-800 text-white rounded-full text-sm font-bold shadow-sm hover:bg-green-900 transition-colors">
                            <span className="text-xs uppercase">Login</span>
                        </button>
                    ) : (
                        <button onClick={handleLogout} className="p-2 rounded-full hover:bg-gray-200" title="Logout"><LogoutIcon /></button>
                    )}
                </div>
            </header>
            {/* [DEBUG] Location Status Bar - Hidden globally now as per user request */}
            {/* {userLocation && currentPage !== 'Home' && (
                <div className={`text-xs text-center py-1 ${isPremiumMode ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                    Jarak: {userLocation.distance.toFixed(2)} km {isPremiumMode ? '(Di Area Cafe)' : `(Luar Area > ${SEMESTA_AREA_RADIUS_KM}km)`}
                </div>
            )} */}
            <main
                className="flex-grow overflow-y-auto pb-24"
                onScroll={handleScroll} // [ANALYTICS] Attach scroll listener
            >
                {renderScreen()}
            </main>
            <nav className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto h-20 bg-white border-t flex justify-around items-center shadow-top z-40">
                <button onClick={() => setCurrentPage('Home')} className="flex-1 flex items-center justify-center">
                    <div className={`flex flex-col items-center justify-center w-full py-2 ${currentPage === 'Home' ? 'text-green-800' : 'text-gray-400'}`}>
                        <div className={`p-2 rounded-full transition-colors ${currentPage === 'Home' ? 'bg-green-100' : 'bg-transparent'}`}>
                            <HiOutlineHome className="w-6 h-6" />
                        </div>
                        <span className="text-xs mt-1">Home</span>
                    </div>
                </button>

                <button onClick={handleRiwayatClick} className="flex-1 flex items-center justify-center relative">
                    <div className={`flex flex-col items-center justify-center w-full py-2 ${currentPage === 'Riwayat' ? 'text-green-800' : 'text-gray-400'}`}>
                        <div className={`p-2 rounded-full transition-colors ${currentPage === 'Riwayat' ? 'bg-green-100' : 'bg-transparent'}`}>
                            <HiOutlineClock className="w-6 h-6" />
                        </div>
                        <span className="text-xs mt-1">Riwayat</span>
                    </div>
                    {unreadOrderChatId && (
                        <span className="absolute top-2 right-[26%] w-3 h-3 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
                    )}
                </button>

                <button onClick={() => setCurrentPage('Nearby')} className="flex-1 flex items-center justify-center">
                    <div className={`flex flex-col items-center justify-center w-full py-2 ${currentPage === 'Nearby' ? 'text-green-800' : 'text-gray-400'}`}>
                        <div className={`p-2 rounded-full transition-colors ${currentPage === 'Nearby' ? 'bg-green-100' : 'bg-transparent'}`}>
                            <HiOutlineMapPin className="w-6 h-6" />
                        </div>
                        <span className="text-xs mt-1">Nearby</span>
                    </div>
                </button>



                <button onClick={() => setCurrentPage('Promo')} className="flex-1 flex items-center justify-center">
                    <div className={`flex flex-col items-center justify-center w-full py-2 ${currentPage === 'Promo' ? 'text-green-800' : 'text-gray-400'}`}>
                        <div className={`p-2 rounded-full transition-colors ${currentPage === 'Promo' ? 'bg-green-100' : 'bg-transparent'}`}>
                            <HiOutlineTag className="w-6 h-6" />
                        </div>
                        <span className="text-xs mt-1">Promo</span>
                    </div>
                </button>

                <button onClick={() => setCurrentPage('Cart')} className={`flex-1 flex items-center justify-center relative transition-all duration-300 ${isCartAnimating ? 'animate-pulse bg-green-100 ring-4 ring-green-300 z-50' : ''}`}>
                    <div className={`flex flex-col items-center justify-center w-full py-2 ${currentPage === 'Cart' ? 'text-green-800' : 'text-gray-400'}`}>
                        <div className={`p-2 rounded-full transition-colors ${currentPage === 'Cart' ? 'bg-green-100' : 'bg-transparent'}`}>
                            <HiOutlineShoppingCart className={`w-6 h-6 ${isCartAnimating ? 'scale-110 text-green-700' : ''}`} />
                        </div>
                        <span className={`text-xs mt-1 ${isCartAnimating ? 'font-bold text-green-800' : ''}`}>Keranjang</span>
                    </div>
                    {totalCartItems > 0 && <div className="absolute top-1 right-6 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">{totalCartItems}</div>}
                </button>
            </nav>
        </div>
    );
};


// --- Komponen Utama Aplikasi ---
export default function App() {
    const [view, setView] = useState('loading');
    const [currentUser, setCurrentUser] = useState(null);
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [bukberJoinData, setBukberJoinData] = useState(null);
    const [loginPrompt, setLoginPrompt] = useState(null); // [FIX] Move to top
    const [showIncentiveModal, setShowIncentiveModal] = useState(false); // [FIX] Move to top


    const [cart, setCart] = useState([]);
    const [notification, setNotification] = useState({ message: '', type: 'success' });
    const [guestName, setGuestName] = useState(localStorage.getItem('semesta_guest_name') || ''); // [BARU] Nama untuk tamu dine-in
    // [BARU] Notification States
    const [showPermissionModal, setShowPermissionModal] = useState(false);
    const [showNotificationCenter, setShowNotificationCenter] = useState(false);

    // [BARU] Location & Premium Mode State
    const [userLocation, setUserLocation] = useState(null);
    const [isPremiumMode, setIsPremiumMode] = useState(false);
    const [pendingOrderData, setPendingOrderData] = useState(null); // [BARU] Untuk data order sementara checkout -> bukber

    // [BARU] Location Tracking Effect



    // [BARU] Location Tracking Effect (Robust Capacitor Implementation)
    const [locationError, setLocationError] = useState(null);
    const [isLocationLoading, setIsLocationLoading] = useState(true);
    const watchIdRef = useRef(null); // Ref to store watch ID

    const requestAndWatchLocation = useCallback(async () => {
        setIsLocationLoading(true);
        setLocationError(null);

        try {
            // 1. Check & Request Permissions
            const permStatus = await Geolocation.checkPermissions();

            if (permStatus.location !== 'granted') {
                const newPerm = await Geolocation.requestPermissions();
                if (newPerm.location !== 'granted') {
                    throw new Error('Izin lokasi tidak diberikan. Mohon aktifkan di pengaturan.');
                }
            }

            // 2. Clear existing watch if any
            if (watchIdRef.current) {
                await Geolocation.clearWatch({ id: watchIdRef.current });
                watchIdRef.current = null;
            }

            // 3. Start Watching (High Accuracy First)
            const id = await Geolocation.watchPosition(
                {
                    enableHighAccuracy: true,
                    timeout: 20000,
                    maximumAge: 1000 // Accept cached location up to 1 second old
                },
                (position, err) => {
                    if (err) {
                        console.warn("High accuracy watch failed, trying low accuracy...", err);
                        setLocationError("Sinyal lemah, mencoba mode hemat...");
                        // If persistent error, logic could degrade to getCurrentPosition or low accuracy
                        return;
                    }

                    if (position) {
                        const { latitude, longitude } = position.coords;
                        const distance = getDistanceFromLatLonInKm(
                            latitude,
                            longitude,
                            CAFE_LOCATION.latitude,
                            CAFE_LOCATION.longitude
                        );

                        setUserLocation({ latitude, longitude, distance });
                        setIsLocationLoading(false);
                        setLocationError(null);

                        // Radius Semesta Area logic
                        const isInside = distance <= SEMESTA_AREA_RADIUS_KM;
                        setIsPremiumMode(isInside);
                        window.isPremiumModeGlobal = isInside;

                        // Dispatch for global UI usage if needed
                        window.dispatchEvent(new CustomEvent('location-update', { detail: { distance } }));
                    }
                }
            );

            watchIdRef.current = id;

        } catch (error) {
            console.error("Location Error:", error);
            setLocationError(error.message || 'Gagal mengambil lokasi.');
            setIsLocationLoading(false);
        }
    }, []);

    // Initial load
    useEffect(() => {
        requestAndWatchLocation();

        // Cleanup on unmount
        return () => {
            if (watchIdRef.current) {
                Geolocation.clearWatch({ id: watchIdRef.current });
            }
        };
    }, [requestAndWatchLocation]);

    // Expose manual refresh function to window (for debug or UI buttons)
    useEffect(() => {
        window.refreshLocation = requestAndWatchLocation;
        return () => { delete window.refreshLocation; };
    }, [requestAndWatchLocation]);
    const [notificationHistory, setNotificationHistory] = useState([]);
    const [currentForegroundNotif, setCurrentForegroundNotif] = useState(null);
    const [unreadCount, setUnreadCount] = useState(0);

    const [menuItems, setMenuItems] = useState([]);
    const [packages, setPackages] = useState([]);
    const [tutorials, setTutorials] = useState([]);
    const [dailyQuiz, setDailyQuiz] = useState(null);
    const [settings, setSettings] = useState(null);
    const [menuCategories, setMenuCategories] = useState(['Makanan', 'Minuman', 'Cemilan']); // [BARU] Default kategori menu
    const [specialPromos, setSpecialPromos] = useState([]);
    const [isFokusModeActive, setIsFokusModeActive] = useState(false);
    const [globalPromoNotification, setGlobalPromoNotification] = useState(null);
    const [activeOrder, setActiveOrder] = useState(null);

    const audioContextRef = useRef(null);
    const globalMessageListenerUnsub = useRef(null);
    const [orderInGracePeriod, setOrderInGracePeriod] = useState(null);
    const prevActiveOrderId = useRef(null);
    const [unreadOrderChatId, setUnreadOrderChatId] = useState(null);
    const [allUserOrders, setAllUserOrders] = useState([]);
    // [BARU] State untuk modal update
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    // [BARU] State untuk menyimpan broadcast terbaru
    const [latestBroadcast, setLatestBroadcast] = useState(null);
    // [BARU] State untuk pesan langsung dari admin
    const [directMessage, setDirectMessage] = useState(null);
    // [NEW] State untuk Event Selection
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedTicket, setSelectedTicket] = useState(null); // [NEW] Selected Ticket State


    const initAudioContext = () => {
        if (audioContextRef.current) return;
        try {
            const context = new (window.AudioContext || window.webkitAudioContext)();
            context.resume().then(() => {
                audioContextRef.current = context;
                console.log("Global AudioContext is ready.");
                document.body.removeEventListener('click', initAudioContext);
            });
        } catch (e) {
            console.error("Web Audio API is not supported in this browser.");
        }
    };

    const playGlobalNotificationSound = () => {
        const audioContext = audioContextRef.current;
        if (!audioContext || audioContext.state !== 'running') {
            console.log("Global AudioContext not ready, cannot play sound.");
            if (!audioContextRef.current) initAudioContext();
            return;
        }

        const playBeep = (time, frequency) => {
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.type = 'triangle';
            oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            oscillator.start(time);
            oscillator.stop(time + 0.08);
        };
        const now = audioContext.currentTime;
        playBeep(now, 1000);
        playBeep(now + 0.12, 1000);
        playBeep(now + 0.24, 1200);
    };


    const showNotification = useCallback((message, type = 'success', force = false) => {
        if (isFokusModeActive && !force) return;
        setNotification({ message, type });
        setTimeout(() => setNotification({ message: '', type: '' }), 4000);
    }, [isFokusModeActive]);

    // [BARU] FCM Token Management
    const { requestPermission, deleteToken, hasPermission } = useFCMToken(
        messaging,
        currentUser,
        db,
        publicDataPath,
        showNotification
    );

    // [BARU] Foreground Message Handler
    useForegroundMessage(
        messaging,
        (notification) => {
            // Add to history
            setNotificationHistory(prev => {
                const updated = [notification, ...prev];
                localStorage.setItem('notification_history', JSON.stringify(updated));
                return updated;
            });
            // Show in-app popup -> DISABLED by User Request (Route to Bell only)
            // setCurrentForegroundNotif(notification);

            // Update unread count
            setUnreadCount(prev => prev + 1);

            // Optional: Tampilkan toast kecil agar user sadar ada notif masuk (tanpa popup besar)
            showNotification("Pesan baru diterima! Cek lonceng.", "success");
        },
        playNotificationSound
    );

    // [BARU] Notification Permission Handlers
    const handleRequestNotificationPermission = async () => {
        const granted = await requestPermission();
        setShowPermissionModal(false);
        localStorage.setItem('notification_permission_asked', 'true');
    };

    const handleDenyPermission = () => {
        setShowPermissionModal(false);
        localStorage.setItem('notification_permission_asked', 'true');
    };

    // [BARU] Notification Center Handlers
    const handleMarkAsRead = (notifId) => {
        setNotificationHistory(prev => {
            const updated = prev.map(n =>
                n.id === notifId ? { ...n, read: true } : n
            );
            localStorage.setItem('notification_history', JSON.stringify(updated));
            const unread = updated.filter(n => !n.read).length;
            setUnreadCount(unread);
            return updated;
        });
    };

    const handleClearAllNotifications = () => {
        setNotificationHistory([]);
        setUnreadCount(0);
        localStorage.setItem('notification_history', JSON.stringify([]));
    };

    const manageDailyQuiz = async () => {
        const todayStr = new Date().toISOString().split('T')[0];
        const dailyQuizRef = doc(db, `${publicDataPath}/quizzes`, 'daily');
        const dailyQuizDoc = await getDoc(dailyQuizRef);

        if (dailyQuizDoc.exists() && dailyQuizDoc.data().date === todayStr) {
            return;
        }

        const q = query(quizBankCol, where("isUsed", "==", false), limit(1));
        const quizBankSnapshot = await getDocs(q);

        if (!quizBankSnapshot.empty) {
            const newQuizDoc = quizBankSnapshot.docs[0];
            const newQuizData = newQuizDoc.data();

            const batch = writeBatch(db);

            batch.set(dailyQuizRef, {
                ...newQuizData,
                date: todayStr,
            });

            batch.update(newQuizDoc.ref, { isUsed: true });

            await batch.commit();
        }
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                manageDailyQuiz();
                const userDocRef = doc(db, `${publicDataPath}/users`, user.uid);
                const unsubDoc = onSnapshot(userDocRef, (doc) => {
                    if (doc.exists() && doc.data().role !== 'admin') {
                        setCurrentUser({ uid: user.uid, email: user.email, ...doc.data() });
                        setView('app');
                    } else if (!doc.exists()) {
                        // [FIX] Handle anonymous users yang tidak punya email
                        const isAnonymous = user.isAnonymous;
                        const newUser = {
                            uid: user.uid,
                            email: user.email || null,
                            name: user.displayName || (user.email ? user.email.split('@')[0] : `Tamu-${user.uid.slice(-4)}`),
                            role: 'customer',
                            isAnonymous: isAnonymous
                        };
                        setCurrentUser(newUser);
                        setView('app');
                    } else {
                        signOut(auth);
                    }
                    setIsAuthLoading(false);
                });
                return () => unsubDoc();
            } else {
                // [MODIFIKASI] Selalu anonymous login agar bisa browse menu (Guest Mode)
                console.log("[AUTH] No user found, triggering anonymous login for Guest Mode...");
                signInAnonymously(auth)
                    .then((userCredential) => {
                        const user = userCredential.user;
                        const currentGuestName = localStorage.getItem('semesta_guest_name') || `Tamu-${user.uid.slice(-4)}`;
                        setGuestName(currentGuestName);
                        setCurrentUser({
                            uid: user.uid,
                            email: null,
                            name: currentGuestName,
                            role: 'customer',
                            isAnonymous: true
                        });
                        setView('app');
                        setIsAuthLoading(false);
                    })
                    .catch((error) => {
                        console.error("[AUTH] Guest Mode login failed:", error);
                        setIsAuthLoading(false);
                        setView('login'); // Fallback ke login jika gagal total
                    });
            }
        });

        const handleTriggerLogin = () => setView('login');
        window.addEventListener('trigger-login', handleTriggerLogin);

        document.body.addEventListener('click', initAudioContext, { once: true });

        return () => {
            unsubscribe();
            window.removeEventListener('trigger-login', handleTriggerLogin);
            document.body.removeEventListener('click', initAudioContext);
        };
    }, []);

    useEffect(() => {
        if (currentUser?.uid) {
            const q = query(
                transactionsCol,
                where("customerId", "==", currentUser.uid),
                orderBy("date", "desc"),
                // [PRIORITAS #3 - TAHAP 1] Optimasi Listener Global
                // Kita batasi query ini untuk HANYA mengambil 100 transaksi terbaru.
                // Ini secara drastis mengurangi document reads (dari 500+ menjadi 100)
                // sambil tetap menyediakan data yang cukup untuk Halaman Riwayat (100 terbaru)
                // dan untuk logika notifikasi chat (orderInGracePeriod).
                limit(10)
            );

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const activeStatuses = ["baru", "diproses"];
                const freshUserOrders = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAllUserOrders(freshUserOrders);

                const currentActiveOrders = freshUserOrders.filter(order => activeStatuses.includes(order.status));

                let newActiveOrder = null;
                if (currentActiveOrders.length > 0) {
                    newActiveOrder = currentActiveOrders[0];
                }
                setActiveOrder(newActiveOrder);

                if (prevActiveOrderId.current && !newActiveOrder) {
                    const previouslyActiveOrder = freshUserOrders.find(o => o.id === prevActiveOrderId.current);
                    if (previouslyActiveOrder && previouslyActiveOrder.status === 'selesai') {
                        console.log(`Order ${previouslyActiveOrder.id} just completed. Starting grace period.`);
                        setOrderInGracePeriod(previouslyActiveOrder);

                        setTimeout(() => {
                            setOrderInGracePeriod(current => (current?.id === previouslyActiveOrder.id ? null : current));
                            console.log(`Grace period for order ${previouslyActiveOrder.id} has ended.`);
                        }, 60 * 60 * 1000);
                    }
                }
                prevActiveOrderId.current = newActiveOrder ? newActiveOrder.id : null;

            }, (error) => {
                console.error("Gagal mendengarkan status pesanan:", error);
            });

            return () => unsubscribe();
        }
    }, [currentUser?.uid]);

    // [BARU] Check Notification Permission Status
    useEffect(() => {
        if (!currentUser || !messaging) return;

        const checkAndRequest = async () => {
            // 1. Cek Permission
            let currentStatus = Notification.permission;
            console.log("Current Notification Permission Status:", currentStatus);

            // 2. Jika belum 'granted' (bisa 'prompt' atau 'default'), Tampilkan Modal / Request
            const hasAskedPermission = localStorage.getItem('notification_permission_asked');

            if (!hasAskedPermission && currentStatus === 'default' && isNotificationSupported()) {
                setTimeout(() => {
                    setShowPermissionModal(true);
                }, 3000);
            }
        };

        checkAndRequest();

        // Load notification history from localStorage
        const savedHistory = localStorage.getItem('notification_history');
        if (savedHistory) {
            try {
                const history = JSON.parse(savedHistory);
                setNotificationHistory(history);
                const unread = history.filter(n => !n.read).length;
                setUnreadCount(unread);
            } catch (error) {
                console.error('Error loading notification history:', error);
            }
        }
    }, [currentUser, messaging]);

    useEffect(() => {
        if (globalMessageListenerUnsub.current) {
            globalMessageListenerUnsub.current();
            globalMessageListenerUnsub.current = null;
        }

        const orderToMonitor = orderInGracePeriod || activeOrder;
        const monitoredOrderId = orderToMonitor?.id;

        if (monitoredOrderId) {
            const messagesCol = collection(db, `${publicDataPath}/transactions/${monitoredOrderId}/messages`);
            const q = query(messagesCol, orderBy("createdAt", "asc"));

            let isInitialDataIgnored = false;

            const unsubscribe = onSnapshot(q, (snapshot) => {
                if (!isInitialDataIgnored) {
                    isInitialDataIgnored = true;
                    return;
                }

                snapshot.docChanges().forEach((change) => {
                    if (change.type === "added") {
                        const newMessage = change.doc.data();

                        if (newMessage.senderId === 'kasir') {
                            console.log(`[REALTIME] New message from cashier detected: ${change.doc.id}`);
                            playGlobalNotificationSound();
                            setUnreadOrderChatId(monitoredOrderId);
                            showNotification(`Pesan baru dari kasir untuk pesanan ${monitoredOrderId.substring(0, 5)}...`, 'success', true);
                        }
                    }
                });
            }, (error) => {
                console.error("Gagal memantau pesan baru (global):", error);
            });

            globalMessageListenerUnsub.current = unsubscribe;
        }

        return () => {
            if (globalMessageListenerUnsub.current) {
                globalMessageListenerUnsub.current();
            }
        };
    }, [(orderInGracePeriod || activeOrder)?.id]);

    // [BARU] Listener untuk pesan langsung dari admin
    useEffect(() => {
        if (currentUser?.uid) {
            const q = query(
                directMessagesCol,
                where("userId", "==", currentUser.uid),
                where("isRead", "==", false),
                orderBy("createdAt", "desc"),
                limit(1)
            );

            const unsubscribe = onSnapshot(q, (snapshot) => {
                if (!snapshot.empty) {
                    const doc = snapshot.docs[0];
                    const newMessage = { id: doc.id, ...doc.data() };
                    setDirectMessage(newMessage);
                    playGlobalNotificationSound(); // Memutar suara notifikasi
                    showNotification("Anda menerima pesan spesial dari admin!", "success", true);
                } else {
                    setDirectMessage(null);
                }
            });

            return () => unsubscribe();
        }
    }, [currentUser?.uid]);


    useEffect(() => {
        if (view === 'app') {
            // [OPTIMASI] Settings: Gunakan cache localStorage + onSnapshot
            // Settings tetap onSnapshot karena pengecekan versi app memerlukan deteksi real-time
            const cachedSettings = localStorage.getItem('cached_settings');
            if (cachedSettings) {
                try {
                    const parsed = JSON.parse(cachedSettings);
                    setSettings(parsed);
                } catch (e) { console.warn("Failed to parse cached settings"); }
            }

            const unsubSettings = onSnapshot(settingsDoc, doc => {
                const settingsData = doc.exists() ? doc.data() : { bannerUrls: [], headerTexts: { subtitle: '', title: '' }, leaderboardPrizes: [] };
                setSettings(settingsData);
                // Cache settings ke localStorage
                localStorage.setItem('cached_settings', JSON.stringify(settingsData));

                // [BARU] Logika pengecekan versi aplikasi
                if (settingsData.appVersion && isNewerVersion(settingsData.appVersion, CURRENT_APP_VERSION)) {
                    setShowUpdateModal(true);
                }
            });

            // [OPTIMASI] Broadcast: dari onSnapshot -> getDocs (sekali baca)
            // Broadcast jarang berubah, cukup baca sekali saat load
            const fetchBroadcast = async () => {
                try {
                    const qBroadcast = query(broadcastsCol, orderBy("sentAt", "desc"), limit(1));
                    const snapshot = await getDocs(qBroadcast);
                    if (!snapshot.empty) {
                        const broadcastDocSnap = snapshot.docs[0];
                        const broadcastData = { id: broadcastDocSnap.id, ...broadcastDocSnap.data() };

                        const lastBroadcastId = localStorage.getItem('lastProcessedBroadcastId');

                        if (broadcastData.id !== lastBroadcastId) {
                            const newNotif = {
                                id: `broadcast_${broadcastData.id}`,
                                title: "Pengumuman",
                                message: broadcastData.message,
                                type: "info",
                                date: new Date().toISOString(),
                                read: false
                            };

                            setNotificationHistory(prev => {
                                const updated = [newNotif, ...prev];
                                localStorage.setItem('notification_history', JSON.stringify(updated));
                                return updated;
                            });

                            setUnreadCount(prev => prev + 1);
                            showNotification(`Pengumuman: ${broadcastData.message}`, "info");

                            localStorage.setItem('lastProcessedBroadcastId', broadcastData.id);
                            playGlobalNotificationSound();
                        }
                    }
                } catch (error) {
                    console.error("Gagal mengambil broadcast:", error);
                }
            };
            fetchBroadcast();

            // [OPTIMASI] Quiz: dari onSnapshot -> getDoc (sekali baca)
            // Quiz hanya berubah 1x sehari, tidak perlu real-time listener
            const fetchDailyQuiz = async () => {
                try {
                    const quizDocRef = doc(db, `${publicDataPath}/quizzes`, 'daily');
                    const quizSnap = await getDoc(quizDocRef);
                    setDailyQuiz(quizSnap.exists() ? { id: quizSnap.id, ...quizSnap.data() } : null);
                } catch (error) {
                    console.error("Gagal mengambil daily quiz:", error);
                }
            };
            fetchDailyQuiz();

            // [OPTIMASI] Data Dingin: Semua data jarang berubah diambil sekali saja
            // Ini mengurangi reads dari ratusan menjadi puluhan
            const fetchColdData = async () => {
                try {
                    console.log("Mengambil data dingin (Menu, Paket, Kategori, Tutorials) satu kali...");

                    // Menu & Paket (sudah dioptimasi sebelumnya)
                    const menuSnap = await getDocs(query(menuItemsCol, orderBy("name")));
                    const packagesSnap = await getDocs(query(packagesCol));
                    setMenuItems(menuSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                    setPackages(packagesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

                    // [OPTIMASI] Kategori: dari onSnapshot -> getDocs
                    const categoriesSnap = await getDoc(categoriesDoc);
                    if (categoriesSnap.exists()) {
                        const data = categoriesSnap.data();
                        if (data.categories) {
                            const sortedCategories = Object.keys(data.categories)
                                .sort((a, b) => (data.categories[a].order || 0) - (data.categories[b].order || 0));
                            setMenuCategories(sortedCategories);
                            console.log("Menu categories loaded from Firestore (one-time):", sortedCategories);
                        }
                    }

                    // [OPTIMASI] Tutorials: dari onSnapshot -> getDocs
                    const tutorialsSnap = await getDocs(tutorialsCol);
                    setTutorials(tutorialsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

                    console.log("Data dingin berhasil dimuat (Menu, Paket, Kategori, Tutorials).");
                } catch (error) {
                    console.error("Gagal mengambil data dingin:", error);
                }
            };
            fetchColdData();
            // [AKHIR PRIORITAS #2]

            // [OPTIMASI] Promos: dari onSnapshot -> getDocs (sekali baca)
            // Promo jarang berubah, cukup baca sekali saat load
            const fetchPromos = async () => {
                try {
                    const today = Timestamp.now();
                    const qPromos = query(specialPromosCol, where("endDate", ">=", today));
                    const promosSnap = await getDocs(qPromos);
                    setSpecialPromos(promosSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                } catch (error) {
                    console.error("Gagal mengambil promos:", error);
                }
            };
            fetchPromos();

            // [OPTIMASI] Notifications: dari onSnapshot -> getDoc (sekali baca)
            // Notifikasi global promo cukup dibaca sekali saat load
            const fetchNotifications = async () => {
                try {
                    const notifSnap = await getDoc(notificationDoc);
                    if (notifSnap.exists()) {
                        const data = notifSnap.data();
                        const promoId = `global_${data.sentAt.seconds}`;
                        const dismissedPromoId = localStorage.getItem('dismissedPromoId');
                        if (promoId !== dismissedPromoId) {
                            const isRecent = (Timestamp.now().seconds - data.sentAt.seconds) < 86400;
                            if (isRecent) {
                                setGlobalPromoNotification({ ...data, id: promoId, description: data.message });
                            }
                        }
                    }
                } catch (error) {
                    console.error("Gagal mengambil notifications:", error);
                }
            };
            fetchNotifications();

            return () => {
                console.log("Detaching real-time listeners...");
                unsubSettings();
                // Broadcast, Quiz, Promos, Notifications sekarang pakai getDocs/getDoc
                // Tidak perlu cleanup karena bukan listener
            };
        }
    }, [view]);

    useEffect(() => {
        if (view === 'app' && 'Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }, [view]);

    const handleRegister = async ({ name, email, password }) => {
        if (password.length < 6) {
            showNotification('Password harus terdiri dari minimal 6 karakter.', 'error');
            return;
        }
        try {
            const cred = await createUserWithEmailAndPassword(auth, email, password);
            await setDoc(doc(db, `${publicDataPath}/users`, cred.user.uid), {
                name,
                email,
                points: 0,
                role: 'customer',
                createdAt: Timestamp.now(),
                scanCount: 0,
                quizCorrectAnswers: 0,
                transactionCount: 0,
                balance: 0,
                walletBalance: 0,
                saldo: 0,
                vouchers: []
            });
            showNotification('Registrasi berhasil! Selamat datang di Semesta.', 'success');
        } catch (error) {
            if (error.code === 'auth/email-already-in-use') {
                showNotification('Email ini sudah terdaftar. Silakan login.', 'error');
            } else {
                showNotification(`Registrasi gagal: ${error.message}`, 'error');
            }
        }
    };

    const handleLogin = async (email, password) => {
        try {
            await signInWithEmailAndPassword(auth, email, password);
            showNotification('Login berhasil!', 'success');
        } catch (error) {
            console.error("Login Error:", error);
            showNotification(`Login gagal: ${error.message}`, 'error');
        }
    };

    const handleGoogleLogin = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const userDocRef = doc(db, `${publicDataPath}/users`, user.uid);
            const userDoc = await getDoc(userDocRef);

            if (!userDoc.exists()) {
                await setDoc(userDocRef, {
                    name: user.displayName,
                    email: user.email,
                    points: 0,
                    role: 'customer',
                    createdAt: Timestamp.now(),
                    scanCount: 0,
                    quizCorrectAnswers: 0,
                    transactionCount: 0,
                    vouchers: []
                });
                showNotification(`Selamat datang, ${user.displayName}!`, 'success');
            } else {
                showNotification(`Selamat datang kembali, ${user.displayName}!`, 'success');
            }
        } catch (error) {
            showNotification(`Login Google gagal: ${error.message}`, 'error');
        }
    };

    const handleLogout = async () => {
        // [BARU] Delete FCM token before logout
        try {
            await deleteToken();
        } catch (err) {
            console.warn('Error deleting FCM token during logout:', err);
        }

        // [BARU] Clear notification data
        setNotificationHistory([]);
        setUnreadCount(0);
        localStorage.removeItem('notification_history');

        await signOut(auth);
        setCart([]);
        showNotification('Anda telah logout.', 'success');
    };

    const handleUserForgotPassword = async (email) => {
        if (!email) { showNotification('Silakan masukkan email Anda.', 'error'); return; }
        try {
            await sendPasswordResetEmail(auth, email);
            showNotification(`Email untuk reset password telah dikirim ke ${email}.`, 'success');
            setView('login');
        } catch (error) { showNotification(`Gagal mengirim email: ${error.message}`, 'error'); }
    };

    const handleQuizSubmit = async (quiz, selectedOptionIndex) => {
        const isCorrect = quiz.options[selectedOptionIndex] === quiz.correctAnswer;
        const userDocRef = doc(db, `${publicDataPath}/users`, currentUser.uid);
        if (isCorrect) {
            showNotification('Jawaban benar! +1 Poin Kuis', 'success');
            const newCorrectCount = (currentUser.quizCorrectAnswers || 0) + 1;

            if (newCorrectCount > 0 && newCorrectCount % 5 === 0) {
                const newVoucher = {
                    id: `voucher_quiz_${Date.now()}`,
                    type: 'Kuis',
                    discount: 10,
                    createdAt: Timestamp.now(),
                    used: false,
                    code: `KUIS${Math.random().toString(36).substring(2, 7).toUpperCase()}`
                };
                await updateDoc(userDocRef, {
                    quizCorrectAnswers: 0,
                    lastQuizAnswered: Timestamp.now(),
                    vouchers: arrayUnion(newVoucher)
                });
                showNotification('Selamat! Anda mendapatkan voucher diskon 10%!', 'success');
            } else {
                await updateDoc(userDocRef, {
                    quizCorrectAnswers: increment(1),
                    lastQuizAnswered: Timestamp.now()
                });
            }
        } else {
            showNotification(`Jawaban kamu salah, yang benar adalah "${quiz.correctAnswer}". Coba lagi besok!`, 'error');
            await updateDoc(userDocRef, {
                lastQuizAnswered: Timestamp.now(),
                quizCorrectAnswers: 0
            });
        }
    };

    const handleAddToCart = (item) => {
        if (item.isAvailable === false) {
            showNotification(`${item.name} sedang habis dan tidak bisa dipesan.`, 'error');
            return;
        }

        // [BARU] Cek apakah item adalah Paket Bukber
        const isBukberItem = (item.name && item.name.toLowerCase().includes('bukber')) || (item.category && item.category === 'Paket Bukber');

        setCart(prevCart => {
            const existing = prevCart.find(i => i.id === item.id);
            if (existing) {
                return prevCart.map(i => i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i);
            }
            return [...prevCart, { ...item, quantity: 1 }];
        });

        if (isBukberItem) {
            showNotification(`${item.name} ditambahkan! Mode pesanan otomatis masuk ke Reservasi.`, 'info');
        } else {
            showNotification(`${item.name} ditambahkan!`, 'success');
        }

        // [ANALYTICS] Track Add to Cart
        logAddToCart(item);
    };

    // [BARU] Handler untuk menutup banner broadcast
    const handleDismissBroadcast = () => {
        if (latestBroadcast) {
            localStorage.setItem('dismissedBroadcastId', latestBroadcast.id);
            setLatestBroadcast(null);
        }
    };

    const handleCloseGlobalPromo = () => {
        if (globalPromoNotification) {
            localStorage.setItem('dismissedPromoId', globalPromoNotification.id);
            setGlobalPromoNotification(null);
        }
    };

    // [BARU] Handler untuk menutup pesan langsung dan menandainya sebagai sudah dibaca
    const handleCloseDirectMessage = async () => {
        if (directMessage) {
            try {
                const messageRef = doc(db, `${publicDataPath}/directMessages`, directMessage.id);
                await updateDoc(messageRef, { isRead: true });
            } catch (error) {
                console.error("Gagal menandai pesan sebagai sudah dibaca:", error);
            } finally {
                setDirectMessage(null);
            }
        }
    };



    const handlePromoClick = async (promo) => {
        if (!currentUser) return;

        const userDocRef = doc(db, `${publicDataPath}/users`, currentUser.uid);
        const userVouchers = currentUser.vouchers || [];

        const hasVoucher = userVouchers.some(v => v.code === promo.voucherCode);

        if (!hasVoucher) {
            const newVoucher = {
                id: promo.id,
                type: 'Promo Spesial',
                discount: promo.discount,
                createdAt: Timestamp.now(),
                used: false,
                code: promo.voucherCode
            };
            try {
                await updateDoc(userDocRef, {
                    vouchers: arrayUnion(newVoucher)
                });
                showNotification('Kupon promo berhasil ditambahkan!', 'success');
            } catch (error) {
                showNotification(`Gagal menambahkan kupon: ${error.message}`, 'error');
            }
        }
    };




    const renderContent = () => {
        if (view === 'loading' || isAuthLoading) {
            return <div className="flex items-center justify-center h-screen"><SemestaLogoSpinner /></div>;
        }

        if (view === 'app') {
            if (!currentUser || !settings) {
                return <div className="flex items-center justify-center h-screen"><SemestaLogoSpinner /></div>;
            }
            return <AppView
                currentUser={currentUser}
                settings={settings}
                menuItems={menuItems}
                packages={packages}
                tutorials={tutorials}
                dailyQuiz={dailyQuiz}
                activeOrder={activeOrder}
                onQuizSubmit={handleQuizSubmit}
                cart={cart}
                onCartChange={setCart}
                handleLogout={handleLogout}
                onAddToCart={handleAddToCart}
                showNotification={showNotification}
                setIsFokusModeActive={setIsFokusModeActive}
                specialPromos={specialPromos}
                onPromoClick={handlePromoClick}
                allUserOrders={allUserOrders}
                unreadOrderChatId={unreadOrderChatId}
                setUnreadOrderChatId={setUnreadOrderChatId}
                latestBroadcast={latestBroadcast}
                onDismissBroadcast={handleDismissBroadcast}
                unreadCount={unreadCount}
                setShowNotificationCenter={setShowNotificationCenter}
                isPremiumMode={isPremiumMode}
                userLocation={userLocation}
                selectedEvent={selectedEvent}
                setSelectedEvent={setSelectedEvent}
                selectedTicket={selectedTicket}

                setSelectedTicket={setSelectedTicket}
                locationError={locationError}
                onRefreshLocation={requestAndWatchLocation}
                isLocationLoading={isLocationLoading}
                menuCategories={menuCategories}
                bukberJoinData={bukberJoinData} // [BARU] Pass data join bukber
                setBukberJoinData={setBukberJoinData} // [FIX] Pass setter
                guestName={guestName}
                setGuestName={setGuestName}
                setView={setView}
                loginPrompt={loginPrompt}
                setLoginPrompt={setLoginPrompt}
                showIncentiveModal={showIncentiveModal}
                setShowIncentiveModal={setShowIncentiveModal}
            />;
        }

        switch (view) {
            case 'register': return <RegisterPage onRegister={handleRegister} onGoogleLogin={handleGoogleLogin} onSwitchToLogin={() => setView('login')} />;
            case 'forgotPassword': return <ForgotPasswordPage onResetPassword={handleUserForgotPassword} onSwitchToLogin={() => setView('login')} />;
            default: return <LoginPage onLogin={handleLogin} onGoogleLogin={handleGoogleLogin} onSwitchToRegister={() => setView('register')} onSwitchToForgotPassword={() => setView('forgotPassword')} />;
        }
    };

    return (
        <div className="bg-gray-200 text-green-900 font-sans">


            <UpdateModal isOpen={showUpdateModal} />
            <DirectMessageFromAdminModal message={directMessage} onClose={handleCloseDirectMessage} />
            <CustomNotification message={notification.message} type={notification.type} onDismiss={() => setNotification({ message: '' })} />
            <PromoModal notification={globalPromoNotification} onClose={handleCloseGlobalPromo} showNotification={showNotification} />

            {/* [BARU] Modals untuk Guest Flow */}
            <RequiredLoginModal
                isOpen={!!loginPrompt}
                onClose={() => setLoginPrompt(null)}
                message={loginPrompt?.message}
                onLogin={() => {
                    setLoginPrompt(null);
                    setView('login');
                }}
            />

            <PostOrderIncentiveModal
                isOpen={showIncentiveModal}
                onClose={() => setShowIncentiveModal(false)}
                onRegister={() => {
                    setShowIncentiveModal(false);
                    setView('register');
                }}
            />

            {renderContent()}
            {/* Notification components */}
            <NotificationPermissionModal
                isOpen={showPermissionModal}
                onAllow={handleRequestNotificationPermission}
                onClose={handleDenyPermission}
            />

            <NotificationCenterModal
                isOpen={showNotificationCenter}
                onClose={() => setShowNotificationCenter(false)}
                notifications={notificationHistory}
                onMarkAsRead={handleMarkAsRead}
                onClear={handleClearAllNotifications}
            />


            {/* In-App Notification Popup */}
            <InAppNotificationPopup
                notification={currentForegroundNotif}
                onClose={() => setCurrentForegroundNotif(null)}
            />

            <WhatsAppBubble />
        </div>
    );
}

// --- [BARU] Komponen Modal untuk Guest Flow ---

const RequiredLoginModal = ({ isOpen, onClose, message, onLogin }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4 animate-fadeIn">
            <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl animate-scaleIn">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m0 0v2m0-2h2m-2 0H10m4-11a4 4 0 11-8 0 4 4 0 018 0zM7 10h10a2 2 0 012 2v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8a2 2 0 012-2z"></path></svg>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">Butuh Login</h3>
                    <p className="text-sm text-gray-600 mt-2">{message}</p>
                </div>
                <div className="space-y-3">
                    <button onClick={onLogin} className="w-full py-3 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors">Login Sekarang</button>
                    <button onClick={onClose} className="w-full py-3 bg-gray-100 text-gray-600 font-semibold rounded-xl hover:bg-gray-200 transition-colors">Nanti Saja</button>
                </div>
            </div>
        </div>
    );
};

const PostOrderIncentiveModal = ({ isOpen, onClose, onRegister }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4 animate-fadeIn">
            <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl animate-scaleIn border-2 border-yellow-400">
                <div className="text-center mb-6">
                    <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span className="text-4xl">🎁</span>
                    </div>
                    <h3 className="text-2xl font-black text-gray-800">Pesanan Berhasil!</h3>
                    <p className="text-base text-gray-600 mt-3">
                        Mau **Diskon 25%** untuk pesanan berikutnya?
                        <br />Daftar akun sekarang dan dapatkan vouchernya!
                    </p>
                </div>
                <div className="space-y-3">
                    <button onClick={onRegister} className="w-full py-4 bg-yellow-500 text-white font-black rounded-xl hover:bg-yellow-600 shadow-lg transition-transform active:scale-95">
                        KLAIM DISKON 25% SEKARANG
                    </button>
                    <button onClick={onClose} className="w-full py-3 text-gray-400 text-sm font-medium hover:text-gray-600 transition-colors">
                        Mungkin nanti
                    </button>
                </div>
            </div>
        </div>
    );
};
